<template>
  <div>
    <div class="text-left">
      <div>
        <p class="header-text mb-8 mt-4 sm:mt-2">
          {{
            firstTime
              ? "Confirm your company's dispatch, billing, and claims contact information."
              : 'Confirm your contact information.'
          }}
        </p>
        <div :class="firstTime ? 'border-b border-light-gray pb-6' : ''">
          <p
            v-if="firstTime"
            :class="
              dispatchPhones.length && dispatchEmails.length
                ? 'mb-4 text-dark-gray'
                : 'mb-4 text-body-color'
            "
          >
            Required Contacts
          </p>
          <div>
            <div class="flex flex-col gap-4">
              <div class="flex flex-col gap-4 md:flex-row md:flex-wrap">
                <div
                  v-if="!showBillingForm && !showClaimsForm"
                  class="w-full rounded-lg"
                  :class="[
                    showDispatchForm || savedDispatchContact?.id > 0
                      ? 'border-solid'
                      : 'border-dashed',
                    !formLoading
                      ? ''
                      : showBillingForm || showClaimsForm
                        ? 'hidden'
                        : '',
                    savedDispatchContact && !firstTime
                      ? 'custom-box-shadow border border-light-gray'
                      : savedDispatchContact
                        ? 'border border-body-color'
                        : 'border-2 border-placeholder-gray',
                  ]"
                  style="transition: all 400ms"
                  :style="
                    showDispatchForm
                      ? 'flex-grow: 1.000; flex-basis: 100%; order: -9999;'
                      : 'flex-grow: 0.001; flex-basis: calc( ( 100% - 2rem - 4px ) / 3); order: 1;'
                  "
                >
                  <div
                    v-if="savedDispatchContact && showDispatchForm == false"
                    class="hover:alt-white relative flex h-28 flex-row items-start justify-between gap-0.5 rounded-lg bg-white p-2 text-body-color"
                  >
                    <div
                      class="absolute left-2 top-2 flex h-24 flex-col items-center gap-0 py-0"
                    >
                      <svg
                        class="h-auto w-6 text-dark-gray"
                        viewBox="0 0 47 50"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_9_152)">
                          <path
                            d="M39.36 20.54C40.34 22.82 40.5 24.92 40.5 27.56C40.5 37.93 32.09 46.34 21.72 46.34C11.35 46.34 2.94 37.93 2.94 27.56C2.94 17.19 11.35 8.77 21.72 8.77C23.33 8.77 24.4 8.92 25.89 9.3L25.35 6.16C23.85 5.83 23.32 5.84 21.73 5.84C9.73 5.83 0 15.56 0 27.56C0 39.56 9.73 49.28 21.72 49.28C33.71 49.28 43.49 39.72 43.44 27.56C43.43 24.96 43.46 22.93 42.53 20.67L39.36 20.55V20.54Z"
                            fill="currentColor"
                          />
                          <path
                            d="M21.71 28.94C17.85 28.94 14.71 25.8 14.71 21.94C14.71 18.08 17.85 14.94 21.71 14.94C25.57 14.94 28.71 18.08 28.71 21.94C28.71 25.8 25.57 28.94 21.71 28.94ZM21.71 17.94C19.5 17.94 17.71 19.73 17.71 21.94C17.71 24.15 19.5 25.94 21.71 25.94C23.92 25.94 25.71 24.15 25.71 21.94C25.71 19.73 23.92 17.94 21.71 17.94Z"
                            fill="currentColor"
                          />
                          <path
                            d="M34.92 44.7L32.33 43.19C33.39 41.37 33.4 39.19 32.35 37.36C31.3 35.53 29.42 34.44 27.31 34.44H16.11C14 34.44 12.12 35.53 11.07 37.36C10.02 39.19 10.03 41.37 11.09 43.19L8.5 44.7C6.89 41.94 6.88 38.64 8.47 35.87C10.06 33.1 12.92 31.45 16.11 31.45H27.31C30.5 31.45 33.36 33.1 34.95 35.87C36.54 38.64 36.53 41.94 34.92 44.7Z"
                            fill="currentColor"
                          />
                          <path
                            d="M42.86 18.93H41.96C33.76 18.93 27.09 12.26 27.09 4.06V3.16C27.09 2.32 27.42 1.53 28.01 0.93C28.6 0.33 29.4 0.01 30.24 0.01H33.2C33.68 0.01 34.13 0.16 34.52 0.44C34.9 0.71 35.19 1.1 35.34 1.55L36.69 5.61C36.86 6.12 36.84 6.68 36.64 7.18C36.43 7.68 36.05 8.09 35.56 8.34L34.78 8.73C35.44 9.74 36.3 10.61 37.31 11.26L37.7 10.48C37.94 10 38.35 9.62 38.85 9.41C39.35 9.2 39.91 9.18 40.42 9.35L44.47 10.7C44.92 10.85 45.31 11.14 45.59 11.52C45.87 11.9 46.01 12.36 46.01 12.83V15.79C46.01 16.63 45.68 17.42 45.09 18.02C44.49 18.62 43.7 18.94 42.86 18.94V18.93ZM30.23 2.7C30.11 2.7 30 2.75 29.91 2.83C29.83 2.91 29.78 3.03 29.78 3.15V4.05C29.78 10.76 35.24 16.22 41.95 16.22H42.85C42.97 16.22 43.08 16.17 43.17 16.09C43.25 16.01 43.3 15.89 43.3 15.77V13.14L39.93 12.02L39.09 13.71C38.76 14.36 37.99 14.64 37.32 14.34C34.81 13.21 32.81 11.2 31.67 8.69C31.37 8.03 31.65 7.25 32.3 6.92L33.99 6.08L32.87 2.71H30.24L30.23 2.7ZM39.25 8.11C38.9 8.11 38.56 7.98 38.29 7.71C37.76 7.18 37.76 6.33 38.29 5.8L41.39 2.7H40.15C39.4 2.7 38.8 2.09 38.8 1.35C38.8 0.61 39.41 0 40.15 0H44.65C44.65 0 44.66 0 44.67 0C44.85 0 45.01 0.04 45.17 0.1C45.32 0.16 45.47 0.26 45.6 0.38L45.62 0.41C45.74 0.54 45.84 0.68 45.9 0.84C45.96 0.99 46 1.16 46 1.34V5.86C46 6.61 45.39 7.21 44.65 7.21C43.91 7.21 43.3 6.6 43.3 5.86V4.62L40.2 7.72C39.94 7.98 39.59 8.12 39.24 8.12L39.25 8.11Z"
                            fill="currentColor"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_9_152">
                            <rect
                              width="46.01"
                              height="49.28"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <div
                        class="relative text-center font-semibold uppercase text-dark-gray"
                        style="font-size: 0.6rem"
                      >
                        <span class="block">Dispatch</span>
                      </div>
                    </div>
                    <div class="flex h-24 w-full flex-col justify-end gap-0.5">
                      <div
                        class="flex h-full flex-col items-end justify-between"
                      >
                        <div class="flex justify-end gap-0.5">
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0.5 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="showForm('dispatch')"
                          >
                            <svg
                              class="h-3.5 w-3.5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 24 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13 4.39062H6C5.44772 4.39062 5 4.83834 5 5.39062V19.3906C5 19.9429 5.44772 20.3906 6 20.3906H18C18.5523 20.3906 19 19.9429 19 19.3906V12.3906"
                                stroke="currentColor"
                                stroke-width="2"
                              />
                              <path
                                d="M18.5971 3.53523C18.9876 3.14471 19.6208 3.14471 20.0113 3.53523L20.9212 4.44511C21.3117 4.83564 21.3117 5.4688 20.9212 5.85932L14.0195 12.761C13.8756 12.9049 13.6913 13.0015 13.4911 13.0378L12.3793 13.2398C11.6921 13.3646 11.0919 12.7644 11.2167 12.0772L11.4186 10.9654C11.4549 10.7652 11.5515 10.5808 11.6954 10.4369L18.5971 3.53523Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Edit
                            </span>
                          </div>
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="handleDeleteContact('dispatch')"
                          >
                            <svg
                              class="relative -top-px h-5 w-5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.9913 9.65885C14.4132 9.237 14.9854 9 15.582 9C16.1786 9 16.7507 9.237 17.1726 9.65885C17.3468 9.83306 17.4895 10.0329 17.597 10.2495H13.567C13.6745 10.0329 13.8171 9.83306 13.9913 9.65885ZM11.4518 10.2495C11.6341 9.49669 12.0204 8.80138 12.5771 8.24464C13.3741 7.44771 14.4549 7 15.582 7C16.709 7 17.7899 7.44771 18.5868 8.24464C19.1435 8.80138 19.5298 9.49669 19.7121 10.2495H19.9363L19.9552 10.2496H23.1642V12.2496H21.9363C21.9363 12.2889 21.9351 12.3285 21.9327 12.3683L21.2781 23.3662C21.2152 24.4228 20.3401 25.2474 19.2816 25.2474H11.8819C10.8235 25.2474 9.94837 24.4228 9.88548 23.3662L9.23084 12.3683C9.22847 12.3285 9.22728 12.2889 9.22724 12.2496H8V10.2496H11.2083L11.2273 10.2495H11.4518ZM11.8819 23.2474L11.2273 12.2496H19.9363L19.2816 23.2474H11.8819ZM12.6865 21.336L12.6865 13.7539H14.6865L14.6865 21.336H12.6865ZM16.4775 13.7539V21.336H18.4775V13.7539H16.4775Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="relative -left-px text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Delete
                            </span>
                          </div>
                        </div>
                        <div
                          class="text-contact-card align-self-end flex flex-col text-right"
                        >
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedDispatchContact?.name"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedDispatchContact?.name }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedDispatchContact?.phone?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{
                                formatPhone(savedDispatchContact?.phone?.value)
                              }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedDispatchContact?.email_address?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedDispatchContact?.email_address?.value }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!savedDispatchContact && showDispatchForm == false"
                    class="hover:alt-white flex cursor-pointer flex-col items-center justify-center gap-2 rounded-lg bg-off-white px-3 pb-5 pt-6"
                    @click="showForm('dispatch')"
                  >
                    <svg
                      class="h-10 w-auto text-gray-over-dark"
                      viewBox="0 0 48 51"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_9_157)">
                        <path
                          d="M21.71 23.11C17.85 23.11 14.71 19.97 14.71 16.11C14.71 12.25 17.85 9.10999 21.71 9.10999C25.57 9.10999 28.71 12.25 28.71 16.11C28.71 19.97 25.57 23.11 21.71 23.11ZM21.71 12.11C19.5 12.11 17.71 13.9 17.71 16.11C17.71 18.32 19.5 20.11 21.71 20.11C23.92 20.11 25.71 18.32 25.71 16.11C25.71 13.9 23.92 12.11 21.71 12.11Z"
                          fill="currentColor"
                        />
                        <path
                          d="M30.6 29.61C29.64 28.92 28.56 28.61 27.31 28.61H16.11C14 28.61 12.12 29.7 11.07 31.53C10.02 33.36 10.03 35.54 11.09 37.36L8.5 38.87C6.89 36.11 6.88 32.81 8.47 30.04C10.06 27.27 12.92 25.62 16.11 25.62H27.31C30.25 25.62 33.56 26.93 34.61 29.61C34.61 29.61 34.48 29.39 34.61 29.61H30.61H30.6Z"
                          fill="currentColor"
                        />
                        <path
                          d="M2.94 21.72C2.94 11.35 11.35 2.93999 21.72 2.93999C23.85 2.93999 25.88 3.30999 27.79 3.95999C27.9 3.75999 28.03 3.56999 28.2 3.39999C28.67 2.92999 29.3 2.66999 29.96 2.66999H32.18C29.08 0.95999 25.51 -0.0100098 21.72 -0.0100098C9.73 -9.76585e-06 0 9.72999 0 21.72C0 33.71 9.73 43.44 21.72 43.44C23.32 43.44 25.89 43.25 27.37 42.73L26.17 39.95C24.68 40.33 23.33 40.5 21.72 40.5C11.35 40.5 2.94 32.09 2.94 21.72V21.72Z"
                          fill="currentColor"
                        />
                        <path
                          d="M40.36 13.09C40.36 13.75 40.1 14.38 39.63 14.85C39.52 14.96 39.41 15.05 39.28 15.13C40.05 17.18 40.49 19.4 40.49 21.72C40.49 24.36 40 27.32 39.02 29.59L42.09 29.62C42.93 27.3 43.43 24.33 43.43 21.72C43.43 17.64 42.3 13.83 40.35 10.56V13.08L40.36 13.09Z"
                          fill="currentColor"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M36.29 0C36.7 0 37.1 0.16 37.39 0.46C37.68 0.75 37.85 1.15 37.85 1.56V4.85H41.14C41.55 4.85 41.95 5.01 42.24 5.31C42.53 5.6 42.7 6 42.7 6.41C42.7 6.82 42.54 7.22 42.24 7.51C41.94 7.8 41.55 7.97 41.14 7.97H37.85V11.26C37.85 11.67 37.69 12.07 37.39 12.36C37.09 12.65 36.7 12.82 36.29 12.82C35.88 12.82 35.48 12.66 35.19 12.36C34.9 12.07 34.73 11.67 34.73 11.26V7.97H31.44C31.03 7.97 30.63 7.81 30.34 7.51C30.05 7.22 29.88 6.82 29.88 6.41C29.88 6 30.04 5.6 30.34 5.31C30.63 5.02 31.03 4.85 31.44 4.85H34.73V1.56C34.73 1.15 34.89 0.75 35.19 0.46C35.48 0.17 35.88 0 36.29 0V0Z"
                          fill="currentColor"
                        />
                        <path
                          d="M44.14 50.67H43.24C35.04 50.67 28.37 44 28.37 35.8V34.9C28.37 34.06 28.7 33.27 29.29 32.67C29.88 32.07 30.68 31.75 31.52 31.75H34.48C34.96 31.75 35.41 31.9 35.8 32.18C36.18 32.45 36.47 32.84 36.62 33.29L37.97 37.35C38.14 37.86 38.12 38.42 37.92 38.92C37.71 39.42 37.33 39.83 36.84 40.08L36.06 40.47C36.72 41.48 37.58 42.35 38.59 43L38.98 42.22C39.22 41.74 39.63 41.36 40.13 41.15C40.63 40.94 41.19 40.92 41.7 41.09L45.75 42.44C46.2 42.59 46.59 42.88 46.87 43.26C47.15 43.64 47.29 44.1 47.29 44.57V47.53C47.29 48.37 46.96 49.16 46.37 49.76C45.77 50.36 44.98 50.68 44.14 50.68V50.67ZM31.52 34.44C31.4 34.44 31.29 34.49 31.2 34.57C31.12 34.65 31.07 34.77 31.07 34.89V35.79C31.07 42.5 36.53 47.96 43.24 47.96H44.14C44.26 47.96 44.37 47.91 44.46 47.83C44.54 47.75 44.59 47.63 44.59 47.51V44.88L41.22 43.76L40.38 45.45C40.05 46.1 39.28 46.38 38.61 46.08C36.1 44.95 34.1 42.94 32.96 40.43C32.66 39.77 32.94 38.99 33.59 38.66L35.28 37.82L34.16 34.45H31.53L31.52 34.44ZM40.54 39.85C40.19 39.85 39.85 39.72 39.58 39.45C39.05 38.92 39.05 38.07 39.58 37.54L42.68 34.44H41.44C40.69 34.44 40.09 33.83 40.09 33.09C40.09 32.35 40.7 31.74 41.44 31.74H45.94C45.94 31.74 45.95 31.74 45.96 31.74C46.14 31.74 46.3 31.78 46.46 31.84C46.61 31.9 46.76 32 46.89 32.12L46.91 32.15C47.03 32.28 47.13 32.42 47.19 32.58C47.25 32.73 47.29 32.9 47.29 33.08V37.61C47.29 38.36 46.68 38.96 45.94 38.96C45.2 38.96 44.59 38.35 44.59 37.61V36.37L41.49 39.47C41.23 39.73 40.88 39.87 40.53 39.87L40.54 39.85Z"
                          fill="currentColor"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_9_157">
                          <rect
                            width="47.3"
                            height="50.67"
                            fill="white"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    <div class="text-center text-sm text-yellow-500 underline">
                      Add dispatch contact
                    </div>
                  </div>
                  <div
                    v-if="showDispatchForm == true"
                    class="hover:alt-white relative flex w-full flex-col items-center justify-center gap-4 rounded-lg bg-white p-4 md:flex-row md:items-start"
                  >
                    <div class="flex flex-col items-center gap-1 py-2 pl-2">
                      <svg
                        class="h-auto w-8 text-dark-gray"
                        viewBox="0 0 47 50"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_9_152)">
                          <path
                            d="M39.36 20.54C40.34 22.82 40.5 24.92 40.5 27.56C40.5 37.93 32.09 46.34 21.72 46.34C11.35 46.34 2.94 37.93 2.94 27.56C2.94 17.19 11.35 8.77 21.72 8.77C23.33 8.77 24.4 8.92 25.89 9.3L25.35 6.16C23.85 5.83 23.32 5.84 21.73 5.84C9.73 5.83 0 15.56 0 27.56C0 39.56 9.73 49.28 21.72 49.28C33.71 49.28 43.49 39.72 43.44 27.56C43.43 24.96 43.46 22.93 42.53 20.67L39.36 20.55V20.54Z"
                            fill="currentColor"
                          />
                          <path
                            d="M21.71 28.94C17.85 28.94 14.71 25.8 14.71 21.94C14.71 18.08 17.85 14.94 21.71 14.94C25.57 14.94 28.71 18.08 28.71 21.94C28.71 25.8 25.57 28.94 21.71 28.94ZM21.71 17.94C19.5 17.94 17.71 19.73 17.71 21.94C17.71 24.15 19.5 25.94 21.71 25.94C23.92 25.94 25.71 24.15 25.71 21.94C25.71 19.73 23.92 17.94 21.71 17.94Z"
                            fill="currentColor"
                          />
                          <path
                            d="M34.92 44.7L32.33 43.19C33.39 41.37 33.4 39.19 32.35 37.36C31.3 35.53 29.42 34.44 27.31 34.44H16.11C14 34.44 12.12 35.53 11.07 37.36C10.02 39.19 10.03 41.37 11.09 43.19L8.5 44.7C6.89 41.94 6.88 38.64 8.47 35.87C10.06 33.1 12.92 31.45 16.11 31.45H27.31C30.5 31.45 33.36 33.1 34.95 35.87C36.54 38.64 36.53 41.94 34.92 44.7Z"
                            fill="currentColor"
                          />
                          <path
                            d="M42.86 18.93H41.96C33.76 18.93 27.09 12.26 27.09 4.06V3.16C27.09 2.32 27.42 1.53 28.01 0.93C28.6 0.33 29.4 0.01 30.24 0.01H33.2C33.68 0.01 34.13 0.16 34.52 0.44C34.9 0.71 35.19 1.1 35.34 1.55L36.69 5.61C36.86 6.12 36.84 6.68 36.64 7.18C36.43 7.68 36.05 8.09 35.56 8.34L34.78 8.73C35.44 9.74 36.3 10.61 37.31 11.26L37.7 10.48C37.94 10 38.35 9.62 38.85 9.41C39.35 9.2 39.91 9.18 40.42 9.35L44.47 10.7C44.92 10.85 45.31 11.14 45.59 11.52C45.87 11.9 46.01 12.36 46.01 12.83V15.79C46.01 16.63 45.68 17.42 45.09 18.02C44.49 18.62 43.7 18.94 42.86 18.94V18.93ZM30.23 2.7C30.11 2.7 30 2.75 29.91 2.83C29.83 2.91 29.78 3.03 29.78 3.15V4.05C29.78 10.76 35.24 16.22 41.95 16.22H42.85C42.97 16.22 43.08 16.17 43.17 16.09C43.25 16.01 43.3 15.89 43.3 15.77V13.14L39.93 12.02L39.09 13.71C38.76 14.36 37.99 14.64 37.32 14.34C34.81 13.21 32.81 11.2 31.67 8.69C31.37 8.03 31.65 7.25 32.3 6.92L33.99 6.08L32.87 2.71H30.24L30.23 2.7ZM39.25 8.11C38.9 8.11 38.56 7.98 38.29 7.71C37.76 7.18 37.76 6.33 38.29 5.8L41.39 2.7H40.15C39.4 2.7 38.8 2.09 38.8 1.35C38.8 0.61 39.41 0 40.15 0H44.65C44.65 0 44.66 0 44.67 0C44.85 0 45.01 0.04 45.17 0.1C45.32 0.16 45.47 0.26 45.6 0.38L45.62 0.41C45.74 0.54 45.84 0.68 45.9 0.84C45.96 0.99 46 1.16 46 1.34V5.86C46 6.61 45.39 7.21 44.65 7.21C43.91 7.21 43.3 6.6 43.3 5.86V4.62L40.2 7.72C39.94 7.98 39.59 8.12 39.24 8.12L39.25 8.11Z"
                            fill="currentColor"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_9_152">
                            <rect
                              width="46.01"
                              height="49.28"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <div
                        class="text-center text-xs font-semibold uppercase text-dark-gray"
                      >
                        <span class="block pr-1">Dispatch</span>
                      </div>
                    </div>
                    <div
                      class="flex w-full transform flex-col gap-4 border-light-gray transition-all duration-200 md:gap-0 md:border-l lg:mr-8"
                      style="min-height: 260px"
                    >
                      <div class="w-full md:pl-4">
                        <div
                          class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                        >
                          <span
                            class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                          >
                            Contact Name
                          </span>
                          <div class="h-6 w-full overflow-hidden">
                            <Transition name="fadeUp">
                              <div
                                v-if="selectedCensusNameComplete"
                                key="1"
                                class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold uppercase text-white"
                              >
                                <span class="truncate">
                                  {{ selectedCensusName[0] }}
                                </span>
                                <div
                                  class=""
                                  @click="
                                    ((selectedCensusName = []),
                                    (selectedCensusNameComplete = false))
                                  "
                                >
                                  <svg
                                    class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-v-7c65271a=""
                                    style="top: -0.5px"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                      clip-rule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </Transition>
                            <Transition name="fadeUp">
                              <div
                                v-if="!selectedCensusNameComplete"
                                key="2"
                                class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                              >
                                Select name of dispatch contact or add a new
                                name
                              </div>
                            </Transition>
                          </div>
                        </div>
                        <Transition name="fadeDelayHeight">
                          <div
                            v-if="selectedCensusNameComplete"
                            class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                          >
                            <span
                              class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                            >
                              Phone
                            </span>
                            <div class="h-6 w-full overflow-hidden">
                              <TransitionGroup name="fadeUp">
                                <div
                                  v-for="(
                                    selectedPhone, spIndex
                                  ) in selectedCensusPhones"
                                  :key="`phones-${spIndex}`"
                                  class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold uppercase text-white"
                                >
                                  <span class="truncate">
                                    {{
                                      formatPhone(selectedPhone) ||
                                      selectedPhone
                                    }}
                                  </span>
                                  <div
                                    class=""
                                    @click="removeAndCheck('phones', spIndex)"
                                  >
                                    <svg
                                      class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                      xmlns="http://www.w3.org/2000/svg"
                                      data-v-7c65271a=""
                                      style="top: -0.5px"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </TransitionGroup>
                              <Transition name="fadeUp">
                                <div
                                  v-if="
                                    selectedCensusNameComplete &&
                                    selectedCensusPhones?.length == 0
                                  "
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  Select {{ selectedCensusName[0] }}'s phone
                                  number or add new
                                </div>
                              </Transition>
                            </div>
                          </div>
                        </Transition>
                        <Transition name="fadeDelayHeight">
                          <div
                            v-if="
                              selectedCensusNameComplete &&
                              selectedCensusPhonesComplete
                            "
                            class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                          >
                            <span
                              class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                            >
                              Email
                            </span>
                            <div class="h-6 w-full overflow-hidden">
                              <TransitionGroup name="fadeUp">
                                <div
                                  v-for="(
                                    selectedEmail, seIndex
                                  ) in selectedCensusEmails"
                                  :key="`emails-${seIndex}`"
                                  class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold lowercase text-white"
                                >
                                  <span class="truncate">
                                    {{ selectedEmail }}
                                  </span>
                                  <div
                                    class=""
                                    @click="removeAndCheck('emails', seIndex)"
                                  >
                                    <svg
                                      class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                      xmlns="http://www.w3.org/2000/svg"
                                      data-v-7c65271a=""
                                      style="top: -0.5px"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </TransitionGroup>
                              <Transition name="fadeUp">
                                <div
                                  v-if="
                                    selectedCensusNameComplete &&
                                    selectedCensusEmails?.length == 0
                                  "
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  Select {{ selectedCensusName[0] }}'s email
                                  address or add new
                                </div>
                              </Transition>
                            </div>
                          </div>
                        </Transition>
                        <div class="w-full pt-1 md:pr-6">
                          <Transition name="fadeDelay">
                            <div
                              v-if="!selectedCensusNameComplete"
                              class="flex flex-col gap-2 pt-0"
                            >
                              <!-- NOTE: if saved contacts for this contact is_type, show here, else go to censusNames below... -->
                              <div
                                v-if="censusNames?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="contact in censusNames"
                                  :key="contact?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="contact"
                                    :item="contact?.name"
                                    :active="
                                      selectedCensusName.includes(contact?.name)
                                        ? true
                                        : false
                                    "
                                    :handle-select="handleSelectCensusName"
                                    name="census_contacts"
                                    :thin="true"
                                    :model-id="
                                      contact?.is_type == 'dispatch'
                                        ? contact?.id
                                        : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('name')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Name</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                !selectedCensusPhonesComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <div
                                v-if="censusPhones?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="phone in censusPhones"
                                  :key="phone?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="phone"
                                    :item="formatPhone(phone) || phone"
                                    :active="
                                      selectedCensusPhones.includes(phone)
                                        ? true
                                        : false
                                    "
                                    :handle-select="handleSelectCensusPhone"
                                    name="census_phones"
                                    :thin="true"
                                    :model-id="
                                      phone?.is_type == 'dispatch'
                                        ? phone?.id
                                        : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('phone')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Phone</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                selectedCensusPhonesComplete &&
                                !selectedCensusEmailsComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <div
                                v-if="censusEmails?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="email in censusEmails"
                                  :key="email?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="email"
                                    :item="email"
                                    :active="
                                      selectedCensusEmails.includes(email)
                                    "
                                    :handle-select="handleSelectCensusEmail"
                                    name="census_emails"
                                    :thin="true"
                                    :model-id="
                                      email?.is_type == 'dispatch'
                                        ? email?.id
                                        : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('email')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Email</span>
                                  </div>
                                </button-icon>
                                <button-icon
                                  v-if="firstTime"
                                  variant="primary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  :disabled="selectedCensusEmails?.length == 0"
                                  @click="
                                    ((selectedCensusEmailsComplete = true),
                                    saveNewContact('dispatch'))
                                  "
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Save Contact</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                selectedCensusPhonesComplete &&
                                selectedCensusEmailsComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <Transition name="fadeUp">
                                <div
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  <!-- You may edit by removing the contact's name, phone number, and/or email above. When ready, click Save Contact below. -->
                                </div>
                              </Transition>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="primary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  :disabled="selectedCensusEmails?.length == 0"
                                  @click="
                                    ((selectedCensusEmailsComplete = true),
                                    saveNewContact('dispatch'))
                                  "
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Save Contact</span>
                                  </div>
                                </button-icon>
                                <button-icon
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="hideForm('dispatch')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Cancel</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                        </div>
                      </div>
                    </div>
                    <div
                      class="absolute right-2 top-2 z-10 p-1"
                      @click="hideForm('dispatch')"
                    >
                      <svg
                        class="relative h-5 w-5 cursor-pointer text-body-color"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                        data-v-7c65271a=""
                        style="top: -0.5px"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div
                  v-if="!showDispatchForm && !showClaimsForm"
                  class="w-full rounded-lg"
                  :class="[
                    showBillingForm || savedBillingContact?.id > 0
                      ? 'border-solid'
                      : 'border-dashed',
                    !formLoading
                      ? ''
                      : showDispatchForm || showClaimsForm
                        ? 'hidden'
                        : '',
                    savedBillingContact && !firstTime
                      ? 'custom-box-shadow border border-light-gray'
                      : savedBillingContact
                        ? 'border border-body-color'
                        : 'border-2 border-placeholder-gray',
                  ]"
                  style="transition: all 400ms"
                  :style="
                    showBillingForm
                      ? 'flex-grow: 1.000; flex-basis: 100%; order: -9999;'
                      : 'flex-grow: 0.001; flex-basis: calc( ( 100% - 2rem - 4px ) / 3); order: 2;'
                  "
                >
                  <div
                    v-if="savedBillingContact && showBillingForm == false"
                    class="hover:alt-white relative flex h-28 flex-row items-start justify-between gap-0.5 rounded-lg bg-white p-2 text-body-color"
                  >
                    <div
                      class="absolute left-2 top-2 flex h-24 flex-col items-center gap-0 py-0"
                    >
                      <svg
                        class="h-auto w-6 text-dark-gray"
                        viewBox="0 0 50 49"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M39.25 19.77C40.23 22.05 40.78 24.56 40.78 27.19C40.78 37.56 32.37 45.97 22 45.97C11.63 45.97 3.22 37.57 3.22 27.19C3.22 16.81 11.63 8.41 22 8.41C23.61 8.41 25.16 8.62999 26.65 9.00999V5.96999C25.15 5.63999 23.6 5.45999 22 5.45999C10.01 5.46999 0.279999 15.2 0.279999 27.19C0.279999 39.18 10.01 48.91 22 48.91C33.99 48.91 43.72 39.18 43.72 27.19C43.72 24.58 43.24 22.09 42.39 19.77H39.25Z"
                          fill="currentColor"
                        />
                        <path
                          d="M21.99 28.58C18.13 28.58 14.99 25.44 14.99 21.58C14.99 17.72 18.13 14.58 21.99 14.58C25.85 14.58 28.99 17.72 28.99 21.58C28.99 25.44 25.85 28.58 21.99 28.58ZM21.99 17.58C19.78 17.58 17.99 19.37 17.99 21.58C17.99 23.79 19.78 25.58 21.99 25.58C24.2 25.58 25.99 23.79 25.99 21.58C25.99 19.37 24.2 17.58 21.99 17.58Z"
                          fill="currentColor"
                        />
                        <path
                          d="M35.2 44.34L32.61 42.83C33.67 41.01 33.68 38.83 32.63 37C31.58 35.17 29.7 34.08 27.59 34.08H16.39C14.28 34.08 12.4 35.17 11.35 37C10.3 38.83 10.31 41.01 11.37 42.83L8.78 44.34C7.17 41.58 7.16 38.28 8.75 35.51C10.34 32.74 13.2 31.09 16.39 31.09H27.59C30.78 31.09 33.64 32.74 35.23 35.51C36.82 38.28 36.81 41.58 35.2 44.34Z"
                          fill="currentColor"
                        />
                        <path
                          d="M45.57 17.68H33.26C32.1 17.68 30.96 17.21 30.13 16.38C29.3 15.55 28.83 14.43 28.83 13.25V5.04C28.83 3.86 29.29 2.75 30.13 1.91C30.97 1.07 32.09 0.610001 33.26 0.610001H45.57C46.75 0.610001 47.86 1.07 48.7 1.91C49.54 2.75 50 3.86 50 5.04V13.25C50 14.43 49.54 15.54 48.7 16.38C47.86 17.22 46.75 17.68 45.57 17.68V17.68ZM31.52 8.44V13.25C31.52 13.71 31.71 14.15 32.03 14.48C32.35 14.8 32.8 14.99 33.26 14.99H45.57C46.03 14.99 46.47 14.81 46.8 14.48C47.12 14.16 47.31 13.71 47.31 13.25V8.44H31.53H31.52ZM31.52 5.75H47.3V5.04C47.3 4.58 47.11 4.14 46.79 3.81C46.46 3.48 46.03 3.3 45.56 3.3H33.25C32.79 3.3 32.35 3.49 32.02 3.81C31.7 4.13 31.51 4.58 31.51 5.04V5.75H31.52ZM40.44 13.57H39.41C38.67 13.57 38.07 12.97 38.07 12.23C38.07 11.49 38.67 10.89 39.41 10.89H40.44C41.18 10.89 41.78 11.49 41.78 12.23C41.78 12.97 41.18 13.57 40.44 13.57ZM35.31 13.57H34.28C33.54 13.57 32.94 12.97 32.94 12.23C32.94 11.49 33.54 10.89 34.28 10.89H35.31C36.05 10.89 36.65 11.49 36.65 12.23C36.65 12.97 36.05 13.57 35.31 13.57Z"
                          fill="currentColor"
                        />
                      </svg>
                      <div
                        class="relative text-center font-semibold uppercase text-dark-gray"
                        style="font-size: 0.6rem"
                      >
                        <span class="block">Billing</span>
                      </div>
                    </div>
                    <div class="flex h-24 w-full flex-col justify-end gap-0.5">
                      <div
                        class="flex h-full flex-col items-end justify-between"
                      >
                        <div class="flex justify-end gap-0.5">
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0.5 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="showForm('billing')"
                          >
                            <svg
                              class="h-3.5 w-3.5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 24 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13 4.39062H6C5.44772 4.39062 5 4.83834 5 5.39062V19.3906C5 19.9429 5.44772 20.3906 6 20.3906H18C18.5523 20.3906 19 19.9429 19 19.3906V12.3906"
                                stroke="currentColor"
                                stroke-width="2"
                              />
                              <path
                                d="M18.5971 3.53523C18.9876 3.14471 19.6208 3.14471 20.0113 3.53523L20.9212 4.44511C21.3117 4.83564 21.3117 5.4688 20.9212 5.85932L14.0195 12.761C13.8756 12.9049 13.6913 13.0015 13.4911 13.0378L12.3793 13.2398C11.6921 13.3646 11.0919 12.7644 11.2167 12.0772L11.4186 10.9654C11.4549 10.7652 11.5515 10.5808 11.6954 10.4369L18.5971 3.53523Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Edit
                            </span>
                          </div>
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="handleDeleteContact('billing')"
                          >
                            <svg
                              class="relative -top-px h-4 w-4 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.9913 9.65885C14.4132 9.237 14.9854 9 15.582 9C16.1786 9 16.7507 9.237 17.1726 9.65885C17.3468 9.83306 17.4895 10.0329 17.597 10.2495H13.567C13.6745 10.0329 13.8171 9.83306 13.9913 9.65885ZM11.4518 10.2495C11.6341 9.49669 12.0204 8.80138 12.5771 8.24464C13.3741 7.44771 14.4549 7 15.582 7C16.709 7 17.7899 7.44771 18.5868 8.24464C19.1435 8.80138 19.5298 9.49669 19.7121 10.2495H19.9363L19.9552 10.2496H23.1642V12.2496H21.9363C21.9363 12.2889 21.9351 12.3285 21.9327 12.3683L21.2781 23.3662C21.2152 24.4228 20.3401 25.2474 19.2816 25.2474H11.8819C10.8235 25.2474 9.94837 24.4228 9.88548 23.3662L9.23084 12.3683C9.22847 12.3285 9.22728 12.2889 9.22724 12.2496H8V10.2496H11.2083L11.2273 10.2495H11.4518ZM11.8819 23.2474L11.2273 12.2496H19.9363L19.2816 23.2474H11.8819ZM12.6865 21.336L12.6865 13.7539H14.6865L14.6865 21.336H12.6865ZM16.4775 13.7539V21.336H18.4775V13.7539H16.4775Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="relative -left-px text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Delete
                            </span>
                          </div>
                        </div>
                        <div
                          class="text-contact-card align-self-end flex flex-col text-right"
                        >
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedBillingContact?.name"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedBillingContact?.name }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedBillingContact?.phone?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{
                                formatPhone(
                                  savedBillingContact?.phone?.value
                                ) || savedBillingContact?.phone?.value
                              }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedBillingContact?.email_address?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedBillingContact?.email_address?.value }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!savedBillingContact && showBillingForm == false"
                    class="hover:alt-white flex cursor-pointer flex-col items-center justify-center gap-2 rounded-lg bg-off-white px-3 pb-5 pt-6"
                    @click="showForm('billing')"
                  >
                    <svg
                      class="h-10 w-auto text-gray-over-dark"
                      viewBox="0 0 50 49"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_9_170)">
                        <path
                          d="M21.71 24.12C17.85 24.12 14.71 20.98 14.71 17.12C14.71 13.26 17.85 10.12 21.71 10.12C25.57 10.12 28.71 13.26 28.71 17.12C28.71 20.98 25.57 24.12 21.71 24.12ZM21.71 13.12C19.5 13.12 17.71 14.91 17.71 17.12C17.71 19.33 19.5 21.12 21.71 21.12C23.92 21.12 25.71 19.33 25.71 17.12C25.71 14.91 23.92 13.12 21.71 13.12Z"
                          fill="currentColor"
                        />
                        <path
                          d="M30.54 30.17C29.58 29.48 28.56 29.62 27.31 29.62H16.11C14 29.62 12.12 30.71 11.07 32.54C10.02 34.37 10.03 36.55 11.09 38.37L8.5 39.88C6.89 37.12 6.88 33.82 8.47 31.05C10.06 28.28 12.92 26.63 16.11 26.63H27.31C30.25 26.63 33.5 27.49 34.55 30.17C34.55 30.17 34.42 29.95 34.55 30.17H30.55H30.54Z"
                          fill="currentColor"
                        />
                        <path
                          d="M44.54 48.13H32.54C31.47 48.13 30.47 47.71 29.71 46.96C28.95 46.2 28.54 45.2 28.54 44.13V36.13C28.54 35.06 28.96 34.06 29.71 33.3C30.47 32.54 31.47 32.13 32.54 32.13H44.54C45.61 32.13 46.61 32.55 47.37 33.3C48.13 34.06 48.54 35.06 48.54 36.13V44.13C48.54 45.2 48.12 46.2 47.37 46.96C46.61 47.72 45.61 48.13 44.54 48.13ZM30.54 39.13V44.13C30.54 44.66 30.75 45.17 31.13 45.54C31.51 45.92 32.01 46.13 32.54 46.13H44.54C45.07 46.13 45.58 45.92 45.95 45.54C46.32 45.16 46.54 44.65 46.54 44.13V39.13H30.54ZM30.54 37.13H46.54V36.13C46.54 35.6 46.33 35.09 45.95 34.72C45.58 34.35 45.06 34.13 44.54 34.13H32.54C32.01 34.13 31.5 34.34 31.13 34.72C30.76 35.1 30.54 35.6 30.54 36.13V37.13ZM39.54 44.13H38.54C37.99 44.13 37.54 43.68 37.54 43.13C37.54 42.58 37.99 42.13 38.54 42.13H39.54C40.09 42.13 40.54 42.58 40.54 43.13C40.54 43.68 40.09 44.13 39.54 44.13ZM34.54 44.13H33.54C32.99 44.13 32.54 43.68 32.54 43.13C32.54 42.58 32.99 42.13 33.54 42.13H34.54C35.09 42.13 35.54 42.58 35.54 43.13C35.54 43.68 35.09 44.13 34.54 44.13Z"
                          fill="currentColor"
                        />
                        <path
                          d="M2.94 22.73C2.94 12.36 11.35 3.95 21.72 3.95C23.85 3.95 25.88 4.32 27.79 4.97C27.9 4.77 28.03 4.58 28.2 4.41C28.67 3.94 29.3 3.68 29.96 3.68H32.18C29.08 1.97 25.51 1 21.72 1C9.73 1.01 0 10.74 0 22.73C0 34.72 9.73 44.45 21.72 44.45C23.32 44.45 24.87 44.27 26.37 43.94V40.9C24.88 41.28 23.33 41.5 21.72 41.5C11.35 41.5 2.94 33.09 2.94 22.72V22.73Z"
                          fill="currentColor"
                        />
                        <path
                          d="M40.36 14.1C40.36 14.76 40.1 15.39 39.63 15.86C39.52 15.97 39.41 16.06 39.28 16.14C40.05 18.19 40.49 20.41 40.49 22.73C40.49 25.37 39.94 27.88 38.96 30.15H42.1C42.94 27.83 43.43 25.34 43.43 22.73C43.43 18.65 42.3 14.84 40.35 11.57V14.09L40.36 14.1Z"
                          fill="currentColor"
                        />
                        <path
                          d="M45.13 48.18H32.82C31.66 48.18 30.52 47.71 29.69 46.88C28.86 46.05 28.39 44.93 28.39 43.75V35.54C28.39 34.36 28.85 33.25 29.69 32.41C30.53 31.57 31.65 31.11 32.82 31.11H45.13C46.31 31.11 47.42 31.57 48.26 32.41C49.1 33.25 49.56 34.36 49.56 35.54V43.75C49.56 44.93 49.1 46.04 48.26 46.88C47.42 47.72 46.31 48.18 45.13 48.18ZM31.08 38.94V43.75C31.08 44.21 31.27 44.65 31.59 44.98C31.91 45.3 32.36 45.49 32.82 45.49H45.13C45.59 45.49 46.03 45.31 46.36 44.98C46.68 44.66 46.87 44.21 46.87 43.75V38.94H31.09H31.08ZM31.08 36.25H46.86V35.54C46.86 35.08 46.67 34.64 46.35 34.31C46.02 33.98 45.59 33.8 45.12 33.8H32.81C32.35 33.8 31.91 33.99 31.58 34.31C31.26 34.63 31.07 35.08 31.07 35.54V36.25H31.08ZM40 44.07H38.97C38.23 44.07 37.63 43.47 37.63 42.73C37.63 41.99 38.23 41.39 38.97 41.39H40C40.74 41.39 41.34 41.99 41.34 42.73C41.34 43.47 40.74 44.07 40 44.07ZM34.87 44.07H33.84C33.1 44.07 32.5 43.47 32.5 42.73C32.5 41.99 33.1 41.39 33.84 41.39H34.87C35.61 41.39 36.21 41.99 36.21 42.73C36.21 43.47 35.61 44.07 34.87 44.07Z"
                          fill="currentColor"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M36.29 0C36.7 0 37.1 0.16 37.39 0.46C37.68 0.75 37.85 1.15 37.85 1.56V4.85H41.14C41.55 4.85 41.95 5.01 42.24 5.31C42.53 5.6 42.7 6 42.7 6.41C42.7 6.82 42.54 7.22 42.24 7.51C41.94 7.8 41.55 7.97 41.14 7.97H37.85V11.26C37.85 11.67 37.69 12.07 37.39 12.36C37.09 12.65 36.7 12.82 36.29 12.82C35.88 12.82 35.48 12.66 35.19 12.36C34.9 12.07 34.73 11.67 34.73 11.26V7.97H31.44C31.03 7.97 30.63 7.81 30.34 7.51C30.05 7.22 29.88 6.82 29.88 6.41C29.88 6 30.04 5.6 30.34 5.31C30.63 5.02 31.03 4.85 31.44 4.85H34.73V1.56C34.73 1.15 34.89 0.75 35.19 0.46C35.48 0.17 35.88 0 36.29 0V0Z"
                          fill="currentColor"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_9_170">
                          <rect
                            width="49.55"
                            height="48.18"
                            fill="white"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    <div class="text-center text-sm text-yellow-500 underline">
                      Add billing contact
                    </div>
                  </div>
                  <div
                    v-if="showBillingForm == true"
                    class="hover:alt-white relative flex w-full flex-col items-center justify-center gap-4 rounded-lg bg-white p-4 md:flex-row md:items-start"
                  >
                    <div class="flex flex-col items-center gap-1 py-2 pl-2">
                      <svg
                        class="h-auto w-8 text-dark-gray"
                        viewBox="0 0 50 49"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M39.25 19.77C40.23 22.05 40.78 24.56 40.78 27.19C40.78 37.56 32.37 45.97 22 45.97C11.63 45.97 3.22 37.57 3.22 27.19C3.22 16.81 11.63 8.41 22 8.41C23.61 8.41 25.16 8.62999 26.65 9.00999V5.96999C25.15 5.63999 23.6 5.45999 22 5.45999C10.01 5.46999 0.279999 15.2 0.279999 27.19C0.279999 39.18 10.01 48.91 22 48.91C33.99 48.91 43.72 39.18 43.72 27.19C43.72 24.58 43.24 22.09 42.39 19.77H39.25Z"
                          fill="currentColor"
                        />
                        <path
                          d="M21.99 28.58C18.13 28.58 14.99 25.44 14.99 21.58C14.99 17.72 18.13 14.58 21.99 14.58C25.85 14.58 28.99 17.72 28.99 21.58C28.99 25.44 25.85 28.58 21.99 28.58ZM21.99 17.58C19.78 17.58 17.99 19.37 17.99 21.58C17.99 23.79 19.78 25.58 21.99 25.58C24.2 25.58 25.99 23.79 25.99 21.58C25.99 19.37 24.2 17.58 21.99 17.58Z"
                          fill="currentColor"
                        />
                        <path
                          d="M35.2 44.34L32.61 42.83C33.67 41.01 33.68 38.83 32.63 37C31.58 35.17 29.7 34.08 27.59 34.08H16.39C14.28 34.08 12.4 35.17 11.35 37C10.3 38.83 10.31 41.01 11.37 42.83L8.78 44.34C7.17 41.58 7.16 38.28 8.75 35.51C10.34 32.74 13.2 31.09 16.39 31.09H27.59C30.78 31.09 33.64 32.74 35.23 35.51C36.82 38.28 36.81 41.58 35.2 44.34Z"
                          fill="currentColor"
                        />
                        <path
                          d="M45.57 17.68H33.26C32.1 17.68 30.96 17.21 30.13 16.38C29.3 15.55 28.83 14.43 28.83 13.25V5.04C28.83 3.86 29.29 2.75 30.13 1.91C30.97 1.07 32.09 0.610001 33.26 0.610001H45.57C46.75 0.610001 47.86 1.07 48.7 1.91C49.54 2.75 50 3.86 50 5.04V13.25C50 14.43 49.54 15.54 48.7 16.38C47.86 17.22 46.75 17.68 45.57 17.68V17.68ZM31.52 8.44V13.25C31.52 13.71 31.71 14.15 32.03 14.48C32.35 14.8 32.8 14.99 33.26 14.99H45.57C46.03 14.99 46.47 14.81 46.8 14.48C47.12 14.16 47.31 13.71 47.31 13.25V8.44H31.53H31.52ZM31.52 5.75H47.3V5.04C47.3 4.58 47.11 4.14 46.79 3.81C46.46 3.48 46.03 3.3 45.56 3.3H33.25C32.79 3.3 32.35 3.49 32.02 3.81C31.7 4.13 31.51 4.58 31.51 5.04V5.75H31.52ZM40.44 13.57H39.41C38.67 13.57 38.07 12.97 38.07 12.23C38.07 11.49 38.67 10.89 39.41 10.89H40.44C41.18 10.89 41.78 11.49 41.78 12.23C41.78 12.97 41.18 13.57 40.44 13.57ZM35.31 13.57H34.28C33.54 13.57 32.94 12.97 32.94 12.23C32.94 11.49 33.54 10.89 34.28 10.89H35.31C36.05 10.89 36.65 11.49 36.65 12.23C36.65 12.97 36.05 13.57 35.31 13.57Z"
                          fill="currentColor"
                        />
                      </svg>
                      <div
                        class="text-center text-xs font-semibold uppercase text-dark-gray"
                      >
                        <span class="block pr-1">Billing</span>
                      </div>
                    </div>
                    <div
                      class="flex w-full transform flex-col gap-4 border-light-gray transition-all duration-200 md:gap-0 md:border-l lg:mr-8"
                      style="min-height: 260px"
                    >
                      <div class="w-full md:pl-4">
                        <div
                          class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                        >
                          <span
                            class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                          >
                            Contact Name
                          </span>
                          <div class="h-6 w-full overflow-hidden">
                            <Transition name="fadeUp">
                              <div
                                v-if="selectedCensusNameComplete"
                                key="1"
                                class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold uppercase text-white"
                              >
                                <span class="truncate">
                                  {{ selectedCensusName[0] }}
                                </span>
                                <div
                                  class=""
                                  @click="
                                    ((selectedCensusName = []),
                                    (selectedCensusNameComplete = false))
                                  "
                                >
                                  <svg
                                    class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-v-7c65271a=""
                                    style="top: -0.5px"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                      clip-rule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </Transition>
                            <Transition name="fadeUp">
                              <div
                                v-if="!selectedCensusNameComplete"
                                key="2"
                                class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                              >
                                Select name of billing contact or add a new name
                              </div>
                            </Transition>
                          </div>
                        </div>
                        <Transition name="fadeDelayHeight">
                          <div
                            v-if="selectedCensusNameComplete"
                            class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                          >
                            <span
                              class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                            >
                              Phone
                            </span>
                            <div class="h-6 w-full overflow-hidden">
                              <TransitionGroup name="fadeUp">
                                <div
                                  v-for="(
                                    selectedPhone, spIndex
                                  ) in selectedCensusPhones"
                                  :key="`phones-${spIndex}`"
                                  class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold uppercase text-white"
                                >
                                  <span class="truncate">
                                    {{
                                      formatPhone(selectedPhone) ||
                                      selectedPhone
                                    }}
                                  </span>
                                  <div
                                    class=""
                                    @click="removeAndCheck('phones', spIndex)"
                                  >
                                    <svg
                                      class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                      xmlns="http://www.w3.org/2000/svg"
                                      data-v-7c65271a=""
                                      style="top: -0.5px"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </TransitionGroup>
                              <Transition name="fadeUp">
                                <div
                                  v-if="
                                    selectedCensusNameComplete &&
                                    selectedCensusPhones?.length == 0
                                  "
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  Select {{ selectedCensusName[0] }}'s phone
                                  number or add new
                                </div>
                              </Transition>
                            </div>
                          </div>
                        </Transition>
                        <Transition name="fadeDelayHeight">
                          <div
                            v-if="
                              selectedCensusNameComplete &&
                              selectedCensusPhonesComplete
                            "
                            class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                          >
                            <span
                              class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                            >
                              Email
                            </span>
                            <div class="h-6 w-full overflow-hidden">
                              <TransitionGroup name="fadeUp">
                                <div
                                  v-for="(
                                    selectedEmail, seIndex
                                  ) in selectedCensusEmails"
                                  :key="`emails-${seIndex}`"
                                  class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold lowercase text-white"
                                >
                                  <span class="truncate">
                                    {{ selectedEmail }}
                                  </span>
                                  <div
                                    class=""
                                    @click="removeAndCheck('emails', seIndex)"
                                  >
                                    <svg
                                      class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                      xmlns="http://www.w3.org/2000/svg"
                                      data-v-7c65271a=""
                                      style="top: -0.5px"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </TransitionGroup>
                              <Transition name="fadeUp">
                                <div
                                  v-if="
                                    selectedCensusNameComplete &&
                                    selectedCensusEmails?.length == 0
                                  "
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  Select {{ selectedCensusName[0] }}'s email
                                  address or add new
                                </div>
                              </Transition>
                            </div>
                          </div>
                        </Transition>
                        <div class="w-full pt-1 md:pr-6">
                          <Transition name="fadeDelay">
                            <div
                              v-if="!selectedCensusNameComplete"
                              class="flex flex-col gap-2 pt-0"
                            >
                              <!-- NOTE: if saved contacts for this contact is_type, show here, else go to censusNames below... -->
                              <div
                                v-if="censusNames?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="contact in censusNames"
                                  :key="contact?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="contact"
                                    :item="contact?.name"
                                    :active="
                                      selectedCensusName.includes(
                                        contact?.name
                                      ) ?? true
                                    "
                                    :handle-select="handleSelectCensusName"
                                    name="census_contacts"
                                    :thin="true"
                                    :model-id="
                                      contact?.is_type == 'billing'
                                        ? contact?.id
                                        : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('name')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Name</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                !selectedCensusPhonesComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <div
                                v-if="censusPhones?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="phone in censusPhones"
                                  :key="phone?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="phone"
                                    :item="formatPhone(phone) || phone"
                                    :active="
                                      selectedCensusPhones.includes(phone)
                                    "
                                    :handle-select="handleSelectCensusPhone"
                                    name="census_phones"
                                    :thin="true"
                                    :model-id="
                                      phone?.is_type == 'billing'
                                        ? phone?.id
                                        : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('phone')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Phone</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                selectedCensusPhonesComplete &&
                                !selectedCensusEmailsComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <div
                                v-if="censusEmails?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="email in censusEmails"
                                  :key="email?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="email"
                                    :item="email"
                                    :active="
                                      selectedCensusEmails.includes(email)
                                    "
                                    :handle-select="handleSelectCensusEmail"
                                    name="census_emails"
                                    :thin="true"
                                    :model-id="
                                      email?.is_type == 'billing'
                                        ? email?.id
                                        : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('email')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Email</span>
                                  </div>
                                </button-icon>
                                <button-icon
                                  v-if="firstTime"
                                  variant="primary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  :disabled="selectedCensusEmails?.length == 0"
                                  @click="
                                    ((selectedCensusEmailsComplete = true),
                                    saveNewContact('billing'))
                                  "
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Save Contact</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                selectedCensusPhonesComplete &&
                                selectedCensusEmailsComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <Transition name="fadeUp">
                                <div
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  <!-- You may edit by removing the contact's name, phone number, and/or email above. When ready, click Save Contact below. -->
                                </div>
                              </Transition>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="primary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  :disabled="selectedCensusEmails?.length == 0"
                                  @click="
                                    ((selectedCensusEmailsComplete = true),
                                    saveNewContact('billing'))
                                  "
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Save Contact</span>
                                  </div>
                                </button-icon>
                                <button-icon
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="hideForm('billing')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Cancel</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                        </div>
                      </div>
                    </div>
                    <div
                      class="absolute right-2 top-2 z-10 p-1"
                      @click="hideForm('billing')"
                    >
                      <svg
                        class="relative h-5 w-5 cursor-pointer text-body-color"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                        data-v-7c65271a=""
                        style="top: -0.5px"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div
                  v-if="!showDispatchForm && !showBillingForm"
                  class="w-full rounded-lg"
                  :class="[
                    showClaimsForm || savedClaimsContact?.id > 0
                      ? 'border-solid'
                      : 'border-dashed',
                    !formLoading
                      ? ''
                      : showDispatchForm || showBillingForm
                        ? 'hidden'
                        : '',
                    savedClaimsContact && !firstTime
                      ? 'custom-box-shadow border border-light-gray'
                      : savedClaimsContact
                        ? 'border border-body-color'
                        : 'border-2 border-placeholder-gray',
                  ]"
                  style="transition: all 400ms"
                  :style="
                    showClaimsForm
                      ? 'flex-grow: 1.000; flex-basis: 100%; order: -9999;'
                      : 'flex-grow: 0.001; flex-basis: calc( ( 100% - 2rem - 4px ) / 3); order: 3;'
                  "
                >
                  <div
                    v-if="savedClaimsContact && showClaimsForm == false"
                    class="hover:alt-white relative flex h-28 flex-row items-start justify-between gap-0.5 rounded-lg bg-white p-2 text-body-color"
                  >
                    <div
                      class="absolute left-2 top-2 flex h-24 flex-col items-center gap-0 py-0"
                    >
                      <svg
                        class="h-auto w-6 text-dark-gray"
                        viewBox="0 0 48 51"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M38.97 21.05C39.95 23.33 40.5 25.84 40.5 28.47C40.5 38.84 32.09 47.25 21.72 47.25C11.35 47.25 2.94 38.85 2.94 28.48C2.94 18.11 11.35 9.7 21.72 9.7C23.33 9.7 24.88 9.92 26.37 10.3L26.05 7.2C24.55 6.87 23.32 6.76 21.72 6.76C9.73 6.75 0 16.48 0 28.48C0 40.48 9.73 50.2 21.72 50.2C33.71 50.2 43.44 40.47 43.44 28.48C43.44 25.87 42.96 22.14 41.87 19.91L38.97 21.06V21.05Z"
                          fill="currentColor"
                        />
                        <path
                          d="M21.71 29.87C17.85 29.87 14.71 26.73 14.71 22.87C14.71 19.01 17.85 15.87 21.71 15.87C25.57 15.87 28.71 19.01 28.71 22.87C28.71 26.73 25.57 29.87 21.71 29.87ZM21.71 18.87C19.5 18.87 17.71 20.66 17.71 22.87C17.71 25.08 19.5 26.87 21.71 26.87C23.92 26.87 25.71 25.08 25.71 22.87C25.71 20.66 23.92 18.87 21.71 18.87Z"
                          fill="currentColor"
                        />
                        <path
                          d="M34.92 45.62L32.33 44.11C33.39 42.29 33.4 40.11 32.35 38.28C31.3 36.45 29.42 35.36 27.31 35.36H16.11C14 35.36 12.12 36.45 11.07 38.28C10.02 40.11 10.03 42.29 11.09 44.11L8.5 45.62C6.89 42.86 6.88 39.56 8.47 36.79C10.06 34.02 12.92 32.37 16.11 32.37H27.31C30.5 32.37 33.36 34.02 34.95 36.79C36.54 39.56 36.53 42.86 34.92 45.62Z"
                          fill="currentColor"
                        />
                        <path
                          d="M37.76 19.4C37.64 19.4 37.52 19.39 37.41 19.36C31.82 17.92 27.91 12.88 27.91 7.09C27.91 6.01 28.05 4.94 28.31 3.91C28.48 3.26 29.12 2.82 29.75 2.86C32.36 3 34.87 2.11 36.82 0.370002C37.36 -0.109998 38.16 -0.109998 38.7 0.370002C40.65 2.12 43.15 3.01 45.77 2.86C46.42 2.82 47.04 3.26 47.21 3.91C47.48 4.94 47.61 6.01 47.61 7.09C47.61 12.87 43.7 17.92 38.11 19.36C37.99 19.39 37.88 19.4 37.76 19.4V19.4ZM30.83 5.67C30.76 6.14 30.73 6.61 30.73 7.09C30.73 11.47 33.6 15.3 37.77 16.53C41.93 15.3 44.81 11.46 44.81 7.09C44.81 6.61 44.78 6.14 44.71 5.67C42.2 5.56 39.8 4.72 37.77 3.22C35.75 4.72 33.35 5.56 30.84 5.67H30.83ZM37.77 14.12C36.99 14.12 36.36 13.49 36.36 12.71C36.36 11.93 36.99 11.3 37.76 11.3H37.77C38.55 11.3 39.18 11.93 39.18 12.71C39.18 13.49 38.55 14.12 37.77 14.12ZM37.76 10.37C36.98 10.37 36.35 9.74 36.35 8.96V7.08C36.35 6.3 36.98 5.67 37.76 5.67C38.54 5.67 39.17 6.3 39.17 7.08V8.96C39.17 9.74 38.54 10.37 37.76 10.37Z"
                          fill="currentColor"
                        />
                      </svg>
                      <div
                        class="relative text-center font-semibold uppercase text-dark-gray"
                        style="font-size: 0.6rem"
                      >
                        <span class="block">Claims</span>
                      </div>
                    </div>
                    <div class="flex h-24 w-full flex-col justify-end gap-0.5">
                      <div
                        class="flex h-full flex-col items-end justify-between"
                      >
                        <div class="flex justify-end gap-0.5">
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0.5 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="showForm('claims')"
                          >
                            <svg
                              class="h-3.5 w-3.5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 24 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13 4.39062H6C5.44772 4.39062 5 4.83834 5 5.39062V19.3906C5 19.9429 5.44772 20.3906 6 20.3906H18C18.5523 20.3906 19 19.9429 19 19.3906V12.3906"
                                stroke="currentColor"
                                stroke-width="2"
                              />
                              <path
                                d="M18.5971 3.53523C18.9876 3.14471 19.6208 3.14471 20.0113 3.53523L20.9212 4.44511C21.3117 4.83564 21.3117 5.4688 20.9212 5.85932L14.0195 12.761C13.8756 12.9049 13.6913 13.0015 13.4911 13.0378L12.3793 13.2398C11.6921 13.3646 11.0919 12.7644 11.2167 12.0772L11.4186 10.9654C11.4549 10.7652 11.5515 10.5808 11.6954 10.4369L18.5971 3.53523Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Edit
                            </span>
                          </div>
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="handleDeleteContact('claims')"
                          >
                            <svg
                              class="relative -top-px h-5 w-5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.9913 9.65885C14.4132 9.237 14.9854 9 15.582 9C16.1786 9 16.7507 9.237 17.1726 9.65885C17.3468 9.83306 17.4895 10.0329 17.597 10.2495H13.567C13.6745 10.0329 13.8171 9.83306 13.9913 9.65885ZM11.4518 10.2495C11.6341 9.49669 12.0204 8.80138 12.5771 8.24464C13.3741 7.44771 14.4549 7 15.582 7C16.709 7 17.7899 7.44771 18.5868 8.24464C19.1435 8.80138 19.5298 9.49669 19.7121 10.2495H19.9363L19.9552 10.2496H23.1642V12.2496H21.9363C21.9363 12.2889 21.9351 12.3285 21.9327 12.3683L21.2781 23.3662C21.2152 24.4228 20.3401 25.2474 19.2816 25.2474H11.8819C10.8235 25.2474 9.94837 24.4228 9.88548 23.3662L9.23084 12.3683C9.22847 12.3285 9.22728 12.2889 9.22724 12.2496H8V10.2496H11.2083L11.2273 10.2495H11.4518ZM11.8819 23.2474L11.2273 12.2496H19.9363L19.2816 23.2474H11.8819ZM12.6865 21.336L12.6865 13.7539H14.6865L14.6865 21.336H12.6865ZM16.4775 13.7539V21.336H18.4775V13.7539H16.4775Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="relative -left-px text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Delete
                            </span>
                          </div>
                        </div>
                        <div
                          class="text-contact-card align-self-end flex flex-col text-right"
                        >
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedClaimsContact?.name"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedClaimsContact?.name }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedClaimsContact?.phone?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{
                                formatPhone(savedClaimsContact?.phone?.value) ||
                                savedClaimsContact?.phone?.value
                              }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedClaimsContact?.email_address?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedClaimsContact?.email_address?.value }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!savedClaimsContact && showClaimsForm == false"
                    class="hover:alt-white flex cursor-pointer flex-col items-center justify-center gap-2 rounded-lg bg-off-white px-3 pb-5 pt-6"
                    @click="showForm('claims')"
                  >
                    <svg
                      class="h-10 w-auto text-gray-over-dark"
                      viewBox="0 0 49 51"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.68 23.93C18.82 23.93 15.68 20.79 15.68 16.93C15.68 13.07 18.82 9.93 22.68 9.93C26.54 9.93 29.68 13.07 29.68 16.93C29.68 20.79 26.54 23.93 22.68 23.93ZM22.68 12.93C20.47 12.93 18.68 14.72 18.68 16.93C18.68 19.14 20.47 20.93 22.68 20.93C24.89 20.93 26.68 19.14 26.68 16.93C26.68 14.72 24.89 12.93 22.68 12.93Z"
                        fill="currentColor"
                      />
                      <path
                        d="M31.51 29.98C30.55 29.29 29.53 29.43 28.28 29.43H17.08C14.97 29.43 13.09 30.52 12.04 32.35C10.99 34.18 11 36.36 12.06 38.18L9.46999 39.69C7.85999 36.93 7.84999 33.63 9.43999 30.86C11.03 28.09 13.89 26.44 17.08 26.44H28.28C31.22 26.44 34.47 27.3 35.52 29.98C35.52 29.98 35.39 29.76 35.52 29.98H31.52H31.51Z"
                        fill="currentColor"
                      />
                      <path
                        d="M3.91 22.54C3.91 12.17 12.32 3.76 22.69 3.76C24.82 3.76 26.85 4.13 28.76 4.78C28.87 4.58 29 4.39 29.17 4.22C29.64 3.75 30.27 3.49 30.93 3.49H33.15C30.05 1.78 26.48 0.809998 22.69 0.809998C10.69 0.809998 0.970001 10.54 0.970001 22.53C0.970001 34.52 10.7 44.25 22.69 44.25C24.29 44.25 26.55 43.98 28.05 43.65L27.34 40.7C25.85 41.08 24.3 41.3 22.69 41.3C12.32 41.3 3.91 32.89 3.91 22.52V22.54Z"
                        fill="currentColor"
                      />
                      <path
                        d="M41.33 13.9C41.33 14.56 41.07 15.19 40.6 15.66C40.49 15.77 40.38 15.86 40.25 15.94C41.02 17.99 41.46 20.21 41.46 22.53C41.46 25.17 40.91 26.86 39.93 29.14L42.71 30.84C43.55 28.52 44.41 25.14 44.41 22.52C44.41 18.44 43.28 14.63 41.33 11.36V13.88V13.9Z"
                        fill="currentColor"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M37.26 0.809998C37.67 0.809998 38.07 0.969998 38.36 1.27C38.65 1.56 38.82 1.96 38.82 2.37V5.66H42.11C42.52 5.66 42.92 5.82 43.21 6.12C43.5 6.41 43.67 6.81 43.67 7.22C43.67 7.63 43.51 8.03 43.21 8.32C42.91 8.61 42.52 8.78 42.11 8.78H38.82V12.07C38.82 12.48 38.66 12.88 38.36 13.17C38.06 13.46 37.67 13.63 37.26 13.63C36.85 13.63 36.45 13.47 36.16 13.17C35.87 12.88 35.7 12.48 35.7 12.07V8.78H32.41C32 8.78 31.6 8.62 31.31 8.32C31.02 8.03 30.85 7.63 30.85 7.22C30.85 6.81 31.01 6.41 31.31 6.12C31.6 5.83 32 5.66 32.41 5.66H35.7V2.37C35.7 1.96 35.86 1.56 36.16 1.27C36.45 0.979998 36.85 0.809998 37.26 0.809998Z"
                        fill="currentColor"
                      />
                      <path
                        d="M39.03 50.59C38.91 50.59 38.79 50.58 38.68 50.55C33.09 49.11 29.18 44.07 29.18 38.28C29.18 37.2 29.32 36.13 29.58 35.1C29.75 34.45 30.39 34.01 31.02 34.05C33.63 34.19 36.14 33.3 38.09 31.56C38.63 31.08 39.43 31.08 39.97 31.56C41.92 33.31 44.42 34.2 47.04 34.05C47.69 34.01 48.31 34.45 48.48 35.1C48.75 36.13 48.88 37.2 48.88 38.28C48.88 44.06 44.97 49.11 39.38 50.55C39.26 50.58 39.15 50.59 39.03 50.59V50.59ZM32.1 36.86C32.03 37.33 32 37.8 32 38.28C32 42.66 34.87 46.49 39.04 47.72C43.2 46.49 46.08 42.65 46.08 38.28C46.08 37.8 46.05 37.33 45.98 36.86C43.47 36.75 41.07 35.91 39.04 34.41C37.02 35.91 34.62 36.75 32.11 36.86H32.1ZM39.04 45.31C38.26 45.31 37.63 44.68 37.63 43.9C37.63 43.12 38.26 42.49 39.03 42.49H39.04C39.82 42.49 40.45 43.12 40.45 43.9C40.45 44.68 39.82 45.31 39.04 45.31V45.31ZM39.03 41.56C38.25 41.56 37.62 40.93 37.62 40.15V38.27C37.62 37.49 38.25 36.86 39.03 36.86C39.81 36.86 40.44 37.49 40.44 38.27V40.15C40.44 40.93 39.81 41.56 39.03 41.56Z"
                        fill="currentColor"
                      />
                    </svg>
                    <div class="text-center text-sm text-yellow-500 underline">
                      Add claims contact
                    </div>
                  </div>
                  <div
                    v-if="showClaimsForm == true"
                    class="hover:alt-white relative flex w-full flex-col items-center justify-center gap-4 rounded-lg bg-white p-4 md:flex-row md:items-start"
                  >
                    <div class="flex flex-col items-center gap-1 py-2 pl-2">
                      <svg
                        class="h-auto w-8 text-dark-gray"
                        viewBox="0 0 48 51"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M38.97 21.05C39.95 23.33 40.5 25.84 40.5 28.47C40.5 38.84 32.09 47.25 21.72 47.25C11.35 47.25 2.94 38.85 2.94 28.48C2.94 18.11 11.35 9.7 21.72 9.7C23.33 9.7 24.88 9.92 26.37 10.3L26.05 7.2C24.55 6.87 23.32 6.76 21.72 6.76C9.73 6.75 0 16.48 0 28.48C0 40.48 9.73 50.2 21.72 50.2C33.71 50.2 43.44 40.47 43.44 28.48C43.44 25.87 42.96 22.14 41.87 19.91L38.97 21.06V21.05Z"
                          fill="currentColor"
                        />
                        <path
                          d="M21.71 29.87C17.85 29.87 14.71 26.73 14.71 22.87C14.71 19.01 17.85 15.87 21.71 15.87C25.57 15.87 28.71 19.01 28.71 22.87C28.71 26.73 25.57 29.87 21.71 29.87ZM21.71 18.87C19.5 18.87 17.71 20.66 17.71 22.87C17.71 25.08 19.5 26.87 21.71 26.87C23.92 26.87 25.71 25.08 25.71 22.87C25.71 20.66 23.92 18.87 21.71 18.87Z"
                          fill="currentColor"
                        />
                        <path
                          d="M34.92 45.62L32.33 44.11C33.39 42.29 33.4 40.11 32.35 38.28C31.3 36.45 29.42 35.36 27.31 35.36H16.11C14 35.36 12.12 36.45 11.07 38.28C10.02 40.11 10.03 42.29 11.09 44.11L8.5 45.62C6.89 42.86 6.88 39.56 8.47 36.79C10.06 34.02 12.92 32.37 16.11 32.37H27.31C30.5 32.37 33.36 34.02 34.95 36.79C36.54 39.56 36.53 42.86 34.92 45.62Z"
                          fill="currentColor"
                        />
                        <path
                          d="M37.76 19.4C37.64 19.4 37.52 19.39 37.41 19.36C31.82 17.92 27.91 12.88 27.91 7.09C27.91 6.01 28.05 4.94 28.31 3.91C28.48 3.26 29.12 2.82 29.75 2.86C32.36 3 34.87 2.11 36.82 0.370002C37.36 -0.109998 38.16 -0.109998 38.7 0.370002C40.65 2.12 43.15 3.01 45.77 2.86C46.42 2.82 47.04 3.26 47.21 3.91C47.48 4.94 47.61 6.01 47.61 7.09C47.61 12.87 43.7 17.92 38.11 19.36C37.99 19.39 37.88 19.4 37.76 19.4V19.4ZM30.83 5.67C30.76 6.14 30.73 6.61 30.73 7.09C30.73 11.47 33.6 15.3 37.77 16.53C41.93 15.3 44.81 11.46 44.81 7.09C44.81 6.61 44.78 6.14 44.71 5.67C42.2 5.56 39.8 4.72 37.77 3.22C35.75 4.72 33.35 5.56 30.84 5.67H30.83ZM37.77 14.12C36.99 14.12 36.36 13.49 36.36 12.71C36.36 11.93 36.99 11.3 37.76 11.3H37.77C38.55 11.3 39.18 11.93 39.18 12.71C39.18 13.49 38.55 14.12 37.77 14.12ZM37.76 10.37C36.98 10.37 36.35 9.74 36.35 8.96V7.08C36.35 6.3 36.98 5.67 37.76 5.67C38.54 5.67 39.17 6.3 39.17 7.08V8.96C39.17 9.74 38.54 10.37 37.76 10.37Z"
                          fill="currentColor"
                        />
                      </svg>
                      <div
                        class="text-center text-xs font-semibold uppercase text-dark-gray"
                      >
                        <span class="block pr-1">Claims</span>
                      </div>
                    </div>
                    <div
                      class="flex w-full transform flex-col gap-4 border-light-gray transition-all duration-200 md:gap-0 md:border-l lg:mr-8"
                      style="min-height: 260px"
                    >
                      <div class="w-full md:pl-4">
                        <div
                          class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                        >
                          <span
                            class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                          >
                            Contact Name
                          </span>
                          <div class="h-6 w-full overflow-hidden">
                            <Transition name="fadeUp">
                              <div
                                v-if="selectedCensusNameComplete"
                                key="1"
                                class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold uppercase text-white"
                              >
                                <span class="truncate">
                                  {{ selectedCensusName[0] }}
                                </span>
                                <div
                                  class=""
                                  @click="
                                    ((selectedCensusName = []),
                                    (selectedCensusNameComplete = false))
                                  "
                                >
                                  <svg
                                    class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-v-7c65271a=""
                                    style="top: -0.5px"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                      clip-rule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </Transition>
                            <Transition name="fadeUp">
                              <div
                                v-if="!selectedCensusNameComplete"
                                key="2"
                                class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                              >
                                Select name of claims contact or add a new name
                              </div>
                            </Transition>
                          </div>
                        </div>
                        <Transition name="fadeDelayHeight">
                          <div
                            v-if="selectedCensusNameComplete"
                            class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                          >
                            <span
                              class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                            >
                              Phone
                            </span>
                            <div class="h-6 w-full overflow-hidden">
                              <TransitionGroup name="fadeUp">
                                <div
                                  v-for="(
                                    selectedPhone, spIndex
                                  ) in selectedCensusPhones"
                                  :key="`phones-${spIndex}`"
                                  class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold uppercase text-white"
                                >
                                  <span class="truncate">
                                    {{
                                      formatPhone(selectedPhone) ||
                                      selectedPhone
                                    }}
                                  </span>
                                  <div
                                    class=""
                                    @click="removeAndCheck('phones', spIndex)"
                                  >
                                    <svg
                                      class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                      xmlns="http://www.w3.org/2000/svg"
                                      data-v-7c65271a=""
                                      style="top: -0.5px"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </TransitionGroup>
                              <Transition name="fadeUp">
                                <div
                                  v-if="
                                    selectedCensusNameComplete &&
                                    selectedCensusPhones?.length == 0
                                  "
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  Select {{ selectedCensusName[0] }}'s phone
                                  number or add new
                                </div>
                              </Transition>
                            </div>
                          </div>
                        </Transition>
                        <Transition name="fadeDelayHeight">
                          <div
                            v-if="
                              selectedCensusNameComplete &&
                              selectedCensusPhonesComplete
                            "
                            class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                          >
                            <span
                              class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                            >
                              Email
                            </span>
                            <div class="h-6 w-full overflow-hidden">
                              <TransitionGroup name="fadeUp">
                                <div
                                  v-for="(
                                    selectedEmail, seIndex
                                  ) in selectedCensusEmails"
                                  :key="`emails-${seIndex}`"
                                  class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold lowercase text-white"
                                >
                                  <span class="truncate">
                                    {{ selectedEmail }}
                                  </span>
                                  <div
                                    class=""
                                    @click="removeAndCheck('emails', seIndex)"
                                  >
                                    <svg
                                      class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                      xmlns="http://www.w3.org/2000/svg"
                                      data-v-7c65271a=""
                                      style="top: -0.5px"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </TransitionGroup>
                              <Transition name="fadeUp">
                                <div
                                  v-if="
                                    selectedCensusNameComplete &&
                                    selectedCensusEmails?.length == 0
                                  "
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  Select {{ selectedCensusName[0] }}'s email
                                  address or add new
                                </div>
                              </Transition>
                            </div>
                          </div>
                        </Transition>
                        <div class="w-full pt-1 md:pr-6">
                          <Transition name="fadeDelay">
                            <div
                              v-if="!selectedCensusNameComplete"
                              class="flex flex-col gap-2 pt-0"
                            >
                              <!-- NOTE: if saved contacts for this contact is_type, show here, else go to censusNames below... -->
                              <div
                                v-if="censusNames?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="contact in censusNames"
                                  :key="contact?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="contact"
                                    :item="contact?.name"
                                    :active="
                                      selectedCensusName.includes(
                                        contact?.name
                                      ) ?? true
                                    "
                                    :handle-select="handleSelectCensusName"
                                    name="census_contacts"
                                    :thin="true"
                                    :model-id="
                                      contact?.is_type == 'claims'
                                        ? contact?.id
                                        : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('name')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Name</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                !selectedCensusPhonesComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <div
                                v-if="censusPhones?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="phone in censusPhones"
                                  :key="phone?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="phone"
                                    :item="formatPhone(phone) || phone"
                                    :active="
                                      selectedCensusPhones.includes(phone)
                                    "
                                    :handle-select="handleSelectCensusPhone"
                                    name="census_phones"
                                    :thin="true"
                                    :model-id="
                                      phone?.is_type == 'claims' ? phone?.id : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('phone')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Phone</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                selectedCensusPhonesComplete &&
                                !selectedCensusEmailsComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <div
                                v-if="censusEmails?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="email in censusEmails"
                                  :key="email?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="email"
                                    :item="email"
                                    :active="
                                      selectedCensusEmails.includes(email)
                                    "
                                    :handle-select="handleSelectCensusEmail"
                                    name="census_emails"
                                    :thin="true"
                                    :model-id="
                                      email?.is_type == 'claims' ? email?.id : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('email')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Email</span>
                                  </div>
                                </button-icon>
                                <button-icon
                                  v-if="firstTime"
                                  variant="primary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  :disabled="selectedCensusEmails?.length == 0"
                                  @click="
                                    ((selectedCensusEmailsComplete = true),
                                    saveNewContact('claims'))
                                  "
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Save Contact</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                selectedCensusPhonesComplete &&
                                selectedCensusEmailsComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <Transition name="fadeUp">
                                <div
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  <!-- You may edit by removing the contact's name, phone number, and/or email above. When ready, click Save Contact below. -->
                                </div>
                              </Transition>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="primary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  :disabled="selectedCensusEmails?.length == 0"
                                  @click="
                                    ((selectedCensusEmailsComplete = true),
                                    saveNewContact('claims'))
                                  "
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Save Contact</span>
                                  </div>
                                </button-icon>
                                <button-icon
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="hideForm('claims')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Cancel</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                        </div>
                      </div>
                    </div>
                    <div
                      class="absolute right-2 top-2 z-10 p-1"
                      @click="hideForm('claims')"
                    >
                      <svg
                        class="relative h-5 w-5 cursor-pointer text-body-color"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                        data-v-7c65271a=""
                        style="top: -0.5px"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="showDispatchForm || showBillingForm || showClaimsForm"
                class="flex flex-col gap-4 md:flex-row md:flex-wrap"
              >
                <div
                  v-if="showBillingForm || showClaimsForm"
                  class="w-full cursor-pointer rounded-lg border-placeholder-gray"
                  :class="
                    savedDispatchContact && showDispatchForm == false
                      ? 'border border-body-color'
                      : 'border-dashed border-placeholder-gray'
                  "
                  style="transition: all 400ms"
                  :style="
                    showDispatchForm
                      ? 'flex-grow: 1.000; flex-basis: 100%; order: -9999;'
                      : 'flex-grow: 0.001; flex-basis: calc( ( 100% - 1rem ) / 2); order: 1;'
                  "
                >
                  <div
                    v-if="savedDispatchContact && showDispatchForm == false"
                    class="hover:alt-white relative flex h-28 flex-row items-start justify-between gap-0.5 rounded-lg bg-white p-2 text-body-color"
                  >
                    <div
                      class="absolute left-2 top-2 flex h-24 flex-col items-center gap-0 py-0"
                    >
                      <svg
                        class="h-auto w-6 text-dark-gray"
                        viewBox="0 0 47 50"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_9_152)">
                          <path
                            d="M39.36 20.54C40.34 22.82 40.5 24.92 40.5 27.56C40.5 37.93 32.09 46.34 21.72 46.34C11.35 46.34 2.94 37.93 2.94 27.56C2.94 17.19 11.35 8.77 21.72 8.77C23.33 8.77 24.4 8.92 25.89 9.3L25.35 6.16C23.85 5.83 23.32 5.84 21.73 5.84C9.73 5.83 0 15.56 0 27.56C0 39.56 9.73 49.28 21.72 49.28C33.71 49.28 43.49 39.72 43.44 27.56C43.43 24.96 43.46 22.93 42.53 20.67L39.36 20.55V20.54Z"
                            fill="currentColor"
                          />
                          <path
                            d="M21.71 28.94C17.85 28.94 14.71 25.8 14.71 21.94C14.71 18.08 17.85 14.94 21.71 14.94C25.57 14.94 28.71 18.08 28.71 21.94C28.71 25.8 25.57 28.94 21.71 28.94ZM21.71 17.94C19.5 17.94 17.71 19.73 17.71 21.94C17.71 24.15 19.5 25.94 21.71 25.94C23.92 25.94 25.71 24.15 25.71 21.94C25.71 19.73 23.92 17.94 21.71 17.94Z"
                            fill="currentColor"
                          />
                          <path
                            d="M34.92 44.7L32.33 43.19C33.39 41.37 33.4 39.19 32.35 37.36C31.3 35.53 29.42 34.44 27.31 34.44H16.11C14 34.44 12.12 35.53 11.07 37.36C10.02 39.19 10.03 41.37 11.09 43.19L8.5 44.7C6.89 41.94 6.88 38.64 8.47 35.87C10.06 33.1 12.92 31.45 16.11 31.45H27.31C30.5 31.45 33.36 33.1 34.95 35.87C36.54 38.64 36.53 41.94 34.92 44.7Z"
                            fill="currentColor"
                          />
                          <path
                            d="M42.86 18.93H41.96C33.76 18.93 27.09 12.26 27.09 4.06V3.16C27.09 2.32 27.42 1.53 28.01 0.93C28.6 0.33 29.4 0.01 30.24 0.01H33.2C33.68 0.01 34.13 0.16 34.52 0.44C34.9 0.71 35.19 1.1 35.34 1.55L36.69 5.61C36.86 6.12 36.84 6.68 36.64 7.18C36.43 7.68 36.05 8.09 35.56 8.34L34.78 8.73C35.44 9.74 36.3 10.61 37.31 11.26L37.7 10.48C37.94 10 38.35 9.62 38.85 9.41C39.35 9.2 39.91 9.18 40.42 9.35L44.47 10.7C44.92 10.85 45.31 11.14 45.59 11.52C45.87 11.9 46.01 12.36 46.01 12.83V15.79C46.01 16.63 45.68 17.42 45.09 18.02C44.49 18.62 43.7 18.94 42.86 18.94V18.93ZM30.23 2.7C30.11 2.7 30 2.75 29.91 2.83C29.83 2.91 29.78 3.03 29.78 3.15V4.05C29.78 10.76 35.24 16.22 41.95 16.22H42.85C42.97 16.22 43.08 16.17 43.17 16.09C43.25 16.01 43.3 15.89 43.3 15.77V13.14L39.93 12.02L39.09 13.71C38.76 14.36 37.99 14.64 37.32 14.34C34.81 13.21 32.81 11.2 31.67 8.69C31.37 8.03 31.65 7.25 32.3 6.92L33.99 6.08L32.87 2.71H30.24L30.23 2.7ZM39.25 8.11C38.9 8.11 38.56 7.98 38.29 7.71C37.76 7.18 37.76 6.33 38.29 5.8L41.39 2.7H40.15C39.4 2.7 38.8 2.09 38.8 1.35C38.8 0.61 39.41 0 40.15 0H44.65C44.65 0 44.66 0 44.67 0C44.85 0 45.01 0.04 45.17 0.1C45.32 0.16 45.47 0.26 45.6 0.38L45.62 0.41C45.74 0.54 45.84 0.68 45.9 0.84C45.96 0.99 46 1.16 46 1.34V5.86C46 6.61 45.39 7.21 44.65 7.21C43.91 7.21 43.3 6.6 43.3 5.86V4.62L40.2 7.72C39.94 7.98 39.59 8.12 39.24 8.12L39.25 8.11Z"
                            fill="currentColor"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_9_152">
                            <rect
                              width="46.01"
                              height="49.28"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <div
                        class="relative text-center font-semibold uppercase text-dark-gray"
                        style="font-size: 0.6rem"
                      >
                        <span class="block">Dispatch</span>
                      </div>
                    </div>
                    <div class="flex h-24 w-full flex-col justify-end gap-0.5">
                      <div
                        class="flex h-full flex-col items-end justify-between"
                      >
                        <div class="flex justify-end gap-0.5">
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0.5 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="showForm('dispatch')"
                          >
                            <svg
                              class="h-3.5 w-3.5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 24 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13 4.39062H6C5.44772 4.39062 5 4.83834 5 5.39062V19.3906C5 19.9429 5.44772 20.3906 6 20.3906H18C18.5523 20.3906 19 19.9429 19 19.3906V12.3906"
                                stroke="currentColor"
                                stroke-width="2"
                              />
                              <path
                                d="M18.5971 3.53523C18.9876 3.14471 19.6208 3.14471 20.0113 3.53523L20.9212 4.44511C21.3117 4.83564 21.3117 5.4688 20.9212 5.85932L14.0195 12.761C13.8756 12.9049 13.6913 13.0015 13.4911 13.0378L12.3793 13.2398C11.6921 13.3646 11.0919 12.7644 11.2167 12.0772L11.4186 10.9654C11.4549 10.7652 11.5515 10.5808 11.6954 10.4369L18.5971 3.53523Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Edit
                            </span>
                          </div>
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="handleDeleteContact('dispatch')"
                          >
                            <svg
                              class="relative -top-px h-5 w-5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.9913 9.65885C14.4132 9.237 14.9854 9 15.582 9C16.1786 9 16.7507 9.237 17.1726 9.65885C17.3468 9.83306 17.4895 10.0329 17.597 10.2495H13.567C13.6745 10.0329 13.8171 9.83306 13.9913 9.65885ZM11.4518 10.2495C11.6341 9.49669 12.0204 8.80138 12.5771 8.24464C13.3741 7.44771 14.4549 7 15.582 7C16.709 7 17.7899 7.44771 18.5868 8.24464C19.1435 8.80138 19.5298 9.49669 19.7121 10.2495H19.9363L19.9552 10.2496H23.1642V12.2496H21.9363C21.9363 12.2889 21.9351 12.3285 21.9327 12.3683L21.2781 23.3662C21.2152 24.4228 20.3401 25.2474 19.2816 25.2474H11.8819C10.8235 25.2474 9.94837 24.4228 9.88548 23.3662L9.23084 12.3683C9.22847 12.3285 9.22728 12.2889 9.22724 12.2496H8V10.2496H11.2083L11.2273 10.2495H11.4518ZM11.8819 23.2474L11.2273 12.2496H19.9363L19.2816 23.2474H11.8819ZM12.6865 21.336L12.6865 13.7539H14.6865L14.6865 21.336H12.6865ZM16.4775 13.7539V21.336H18.4775V13.7539H16.4775Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="relative -left-px text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Delete
                            </span>
                          </div>
                        </div>
                        <div
                          class="text-contact-card align-self-end flex flex-col text-right"
                        >
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedDispatchContact?.name"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedDispatchContact?.name }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedDispatchContact?.phone?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{
                                formatPhone(
                                  savedDispatchContact?.phone?.value
                                ) || savedDispatchContact?.phone?.value
                              }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedDispatchContact?.email_address?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedDispatchContact?.email_address?.value }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!savedDispatchContact && showDispatchForm == false"
                    class="flex cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-placeholder-gray bg-off-white px-3 pb-5 pt-6"
                    @click="showForm('dispatch')"
                  >
                    <svg
                      class="h-10 w-auto text-gray-over-dark"
                      viewBox="0 0 48 51"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_9_157)">
                        <path
                          d="M21.71 23.11C17.85 23.11 14.71 19.97 14.71 16.11C14.71 12.25 17.85 9.10999 21.71 9.10999C25.57 9.10999 28.71 12.25 28.71 16.11C28.71 19.97 25.57 23.11 21.71 23.11ZM21.71 12.11C19.5 12.11 17.71 13.9 17.71 16.11C17.71 18.32 19.5 20.11 21.71 20.11C23.92 20.11 25.71 18.32 25.71 16.11C25.71 13.9 23.92 12.11 21.71 12.11Z"
                          fill="currentColor"
                        />
                        <path
                          d="M30.6 29.61C29.64 28.92 28.56 28.61 27.31 28.61H16.11C14 28.61 12.12 29.7 11.07 31.53C10.02 33.36 10.03 35.54 11.09 37.36L8.5 38.87C6.89 36.11 6.88 32.81 8.47 30.04C10.06 27.27 12.92 25.62 16.11 25.62H27.31C30.25 25.62 33.56 26.93 34.61 29.61C34.61 29.61 34.48 29.39 34.61 29.61H30.61H30.6Z"
                          fill="currentColor"
                        />
                        <path
                          d="M2.94 21.72C2.94 11.35 11.35 2.93999 21.72 2.93999C23.85 2.93999 25.88 3.30999 27.79 3.95999C27.9 3.75999 28.03 3.56999 28.2 3.39999C28.67 2.92999 29.3 2.66999 29.96 2.66999H32.18C29.08 0.95999 25.51 -0.0100098 21.72 -0.0100098C9.73 -9.76585e-06 0 9.72999 0 21.72C0 33.71 9.73 43.44 21.72 43.44C23.32 43.44 25.89 43.25 27.37 42.73L26.17 39.95C24.68 40.33 23.33 40.5 21.72 40.5C11.35 40.5 2.94 32.09 2.94 21.72V21.72Z"
                          fill="currentColor"
                        />
                        <path
                          d="M40.36 13.09C40.36 13.75 40.1 14.38 39.63 14.85C39.52 14.96 39.41 15.05 39.28 15.13C40.05 17.18 40.49 19.4 40.49 21.72C40.49 24.36 40 27.32 39.02 29.59L42.09 29.62C42.93 27.3 43.43 24.33 43.43 21.72C43.43 17.64 42.3 13.83 40.35 10.56V13.08L40.36 13.09Z"
                          fill="currentColor"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M36.29 0C36.7 0 37.1 0.16 37.39 0.46C37.68 0.75 37.85 1.15 37.85 1.56V4.85H41.14C41.55 4.85 41.95 5.01 42.24 5.31C42.53 5.6 42.7 6 42.7 6.41C42.7 6.82 42.54 7.22 42.24 7.51C41.94 7.8 41.55 7.97 41.14 7.97H37.85V11.26C37.85 11.67 37.69 12.07 37.39 12.36C37.09 12.65 36.7 12.82 36.29 12.82C35.88 12.82 35.48 12.66 35.19 12.36C34.9 12.07 34.73 11.67 34.73 11.26V7.97H31.44C31.03 7.97 30.63 7.81 30.34 7.51C30.05 7.22 29.88 6.82 29.88 6.41C29.88 6 30.04 5.6 30.34 5.31C30.63 5.02 31.03 4.85 31.44 4.85H34.73V1.56C34.73 1.15 34.89 0.75 35.19 0.46C35.48 0.17 35.88 0 36.29 0V0Z"
                          fill="currentColor"
                        />
                        <path
                          d="M44.14 50.67H43.24C35.04 50.67 28.37 44 28.37 35.8V34.9C28.37 34.06 28.7 33.27 29.29 32.67C29.88 32.07 30.68 31.75 31.52 31.75H34.48C34.96 31.75 35.41 31.9 35.8 32.18C36.18 32.45 36.47 32.84 36.62 33.29L37.97 37.35C38.14 37.86 38.12 38.42 37.92 38.92C37.71 39.42 37.33 39.83 36.84 40.08L36.06 40.47C36.72 41.48 37.58 42.35 38.59 43L38.98 42.22C39.22 41.74 39.63 41.36 40.13 41.15C40.63 40.94 41.19 40.92 41.7 41.09L45.75 42.44C46.2 42.59 46.59 42.88 46.87 43.26C47.15 43.64 47.29 44.1 47.29 44.57V47.53C47.29 48.37 46.96 49.16 46.37 49.76C45.77 50.36 44.98 50.68 44.14 50.68V50.67ZM31.52 34.44C31.4 34.44 31.29 34.49 31.2 34.57C31.12 34.65 31.07 34.77 31.07 34.89V35.79C31.07 42.5 36.53 47.96 43.24 47.96H44.14C44.26 47.96 44.37 47.91 44.46 47.83C44.54 47.75 44.59 47.63 44.59 47.51V44.88L41.22 43.76L40.38 45.45C40.05 46.1 39.28 46.38 38.61 46.08C36.1 44.95 34.1 42.94 32.96 40.43C32.66 39.77 32.94 38.99 33.59 38.66L35.28 37.82L34.16 34.45H31.53L31.52 34.44ZM40.54 39.85C40.19 39.85 39.85 39.72 39.58 39.45C39.05 38.92 39.05 38.07 39.58 37.54L42.68 34.44H41.44C40.69 34.44 40.09 33.83 40.09 33.09C40.09 32.35 40.7 31.74 41.44 31.74H45.94C45.94 31.74 45.95 31.74 45.96 31.74C46.14 31.74 46.3 31.78 46.46 31.84C46.61 31.9 46.76 32 46.89 32.12L46.91 32.15C47.03 32.28 47.13 32.42 47.19 32.58C47.25 32.73 47.29 32.9 47.29 33.08V37.61C47.29 38.36 46.68 38.96 45.94 38.96C45.2 38.96 44.59 38.35 44.59 37.61V36.37L41.49 39.47C41.23 39.73 40.88 39.87 40.53 39.87L40.54 39.85Z"
                          fill="currentColor"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_9_157">
                          <rect
                            width="47.3"
                            height="50.67"
                            fill="white"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    <div class="text-center text-sm text-gray-over-dark">
                      Add dispatch contact
                    </div>
                  </div>
                </div>

                <div
                  v-if="showDispatchForm || showClaimsForm"
                  class="w-full cursor-pointer rounded-lg border-placeholder-gray"
                  :class="
                    savedBillingContact && showBillingForm == false
                      ? 'border border-body-color'
                      : 'border-dashed border-placeholder-gray'
                  "
                  style="transition: all 400ms"
                  :style="
                    showBillingForm
                      ? 'flex-grow: 1.000; flex-basis: 100%; order: -9999;'
                      : 'flex-grow: 0.001; flex-basis: calc( ( 100% - 1rem ) / 2); order: 2;'
                  "
                >
                  <div
                    v-if="savedBillingContact && showBillingForm == false"
                    class="hover:alt-white relative flex h-28 flex-row items-start justify-between gap-0.5 rounded-lg bg-white p-2 text-body-color"
                  >
                    <div
                      class="absolute left-2 top-2 flex h-24 flex-col items-center gap-0 py-0"
                    >
                      <svg
                        class="h-auto w-6 text-dark-gray"
                        viewBox="0 0 50 49"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_9_170)">
                          <path
                            d="M21.71 24.12C17.85 24.12 14.71 20.98 14.71 17.12C14.71 13.26 17.85 10.12 21.71 10.12C25.57 10.12 28.71 13.26 28.71 17.12C28.71 20.98 25.57 24.12 21.71 24.12ZM21.71 13.12C19.5 13.12 17.71 14.91 17.71 17.12C17.71 19.33 19.5 21.12 21.71 21.12C23.92 21.12 25.71 19.33 25.71 17.12C25.71 14.91 23.92 13.12 21.71 13.12Z"
                            fill="currentColor"
                          />
                          <path
                            d="M30.54 30.17C29.58 29.48 28.56 29.62 27.31 29.62H16.11C14 29.62 12.12 30.71 11.07 32.54C10.02 34.37 10.03 36.55 11.09 38.37L8.5 39.88C6.89 37.12 6.88 33.82 8.47 31.05C10.06 28.28 12.92 26.63 16.11 26.63H27.31C30.25 26.63 33.5 27.49 34.55 30.17C34.55 30.17 34.42 29.95 34.55 30.17H30.55H30.54Z"
                            fill="currentColor"
                          />
                          <path
                            d="M44.54 48.13H32.54C31.47 48.13 30.47 47.71 29.71 46.96C28.95 46.2 28.54 45.2 28.54 44.13V36.13C28.54 35.06 28.96 34.06 29.71 33.3C30.47 32.54 31.47 32.13 32.54 32.13H44.54C45.61 32.13 46.61 32.55 47.37 33.3C48.13 34.06 48.54 35.06 48.54 36.13V44.13C48.54 45.2 48.12 46.2 47.37 46.96C46.61 47.72 45.61 48.13 44.54 48.13ZM30.54 39.13V44.13C30.54 44.66 30.75 45.17 31.13 45.54C31.51 45.92 32.01 46.13 32.54 46.13H44.54C45.07 46.13 45.58 45.92 45.95 45.54C46.32 45.16 46.54 44.65 46.54 44.13V39.13H30.54ZM30.54 37.13H46.54V36.13C46.54 35.6 46.33 35.09 45.95 34.72C45.58 34.35 45.06 34.13 44.54 34.13H32.54C32.01 34.13 31.5 34.34 31.13 34.72C30.76 35.1 30.54 35.6 30.54 36.13V37.13ZM39.54 44.13H38.54C37.99 44.13 37.54 43.68 37.54 43.13C37.54 42.58 37.99 42.13 38.54 42.13H39.54C40.09 42.13 40.54 42.58 40.54 43.13C40.54 43.68 40.09 44.13 39.54 44.13ZM34.54 44.13H33.54C32.99 44.13 32.54 43.68 32.54 43.13C32.54 42.58 32.99 42.13 33.54 42.13H34.54C35.09 42.13 35.54 42.58 35.54 43.13C35.54 43.68 35.09 44.13 34.54 44.13Z"
                            fill="currentColor"
                          />
                          <path
                            d="M2.94 22.73C2.94 12.36 11.35 3.95 21.72 3.95C23.85 3.95 25.88 4.32 27.79 4.97C27.9 4.77 28.03 4.58 28.2 4.41C28.67 3.94 29.3 3.68 29.96 3.68H32.18C29.08 1.97 25.51 1 21.72 1C9.73 1.01 0 10.74 0 22.73C0 34.72 9.73 44.45 21.72 44.45C23.32 44.45 24.87 44.27 26.37 43.94V40.9C24.88 41.28 23.33 41.5 21.72 41.5C11.35 41.5 2.94 33.09 2.94 22.72V22.73Z"
                            fill="currentColor"
                          />
                          <path
                            d="M40.36 14.1C40.36 14.76 40.1 15.39 39.63 15.86C39.52 15.97 39.41 16.06 39.28 16.14C40.05 18.19 40.49 20.41 40.49 22.73C40.49 25.37 39.94 27.88 38.96 30.15H42.1C42.94 27.83 43.43 25.34 43.43 22.73C43.43 18.65 42.3 14.84 40.35 11.57V14.09L40.36 14.1Z"
                            fill="currentColor"
                          />
                          <path
                            d="M45.13 48.18H32.82C31.66 48.18 30.52 47.71 29.69 46.88C28.86 46.05 28.39 44.93 28.39 43.75V35.54C28.39 34.36 28.85 33.25 29.69 32.41C30.53 31.57 31.65 31.11 32.82 31.11H45.13C46.31 31.11 47.42 31.57 48.26 32.41C49.1 33.25 49.56 34.36 49.56 35.54V43.75C49.56 44.93 49.1 46.04 48.26 46.88C47.42 47.72 46.31 48.18 45.13 48.18ZM31.08 38.94V43.75C31.08 44.21 31.27 44.65 31.59 44.98C31.91 45.3 32.36 45.49 32.82 45.49H45.13C45.59 45.49 46.03 45.31 46.36 44.98C46.68 44.66 46.87 44.21 46.87 43.75V38.94H31.09H31.08ZM31.08 36.25H46.86V35.54C46.86 35.08 46.67 34.64 46.35 34.31C46.02 33.98 45.59 33.8 45.12 33.8H32.81C32.35 33.8 31.91 33.99 31.58 34.31C31.26 34.63 31.07 35.08 31.07 35.54V36.25H31.08ZM40 44.07H38.97C38.23 44.07 37.63 43.47 37.63 42.73C37.63 41.99 38.23 41.39 38.97 41.39H40C40.74 41.39 41.34 41.99 41.34 42.73C41.34 43.47 40.74 44.07 40 44.07ZM34.87 44.07H33.84C33.1 44.07 32.5 43.47 32.5 42.73C32.5 41.99 33.1 41.39 33.84 41.39H34.87C35.61 41.39 36.21 41.99 36.21 42.73C36.21 43.47 35.61 44.07 34.87 44.07Z"
                            fill="currentColor"
                          />
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M36.29 0C36.7 0 37.1 0.16 37.39 0.46C37.68 0.75 37.85 1.15 37.85 1.56V4.85H41.14C41.55 4.85 41.95 5.01 42.24 5.31C42.53 5.6 42.7 6 42.7 6.41C42.7 6.82 42.54 7.22 42.24 7.51C41.94 7.8 41.55 7.97 41.14 7.97H37.85V11.26C37.85 11.67 37.69 12.07 37.39 12.36C37.09 12.65 36.7 12.82 36.29 12.82C35.88 12.82 35.48 12.66 35.19 12.36C34.9 12.07 34.73 11.67 34.73 11.26V7.97H31.44C31.03 7.97 30.63 7.81 30.34 7.51C30.05 7.22 29.88 6.82 29.88 6.41C29.88 6 30.04 5.6 30.34 5.31C30.63 5.02 31.03 4.85 31.44 4.85H34.73V1.56C34.73 1.15 34.89 0.75 35.19 0.46C35.48 0.17 35.88 0 36.29 0V0Z"
                            fill="currentColor"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_9_170">
                            <rect
                              width="49.55"
                              height="48.18"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <div
                        class="relative text-center font-semibold uppercase text-dark-gray"
                        style="font-size: 0.6rem"
                      >
                        <span class="block">Billing</span>
                      </div>
                    </div>
                    <div class="flex h-24 w-full flex-col justify-end gap-0.5">
                      <div
                        class="flex h-full flex-col items-end justify-between"
                      >
                        <div class="flex justify-end gap-0.5">
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0.5 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="showForm('billing')"
                          >
                            <svg
                              class="h-3.5 w-3.5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 24 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13 4.39062H6C5.44772 4.39062 5 4.83834 5 5.39062V19.3906C5 19.9429 5.44772 20.3906 6 20.3906H18C18.5523 20.3906 19 19.9429 19 19.3906V12.3906"
                                stroke="currentColor"
                                stroke-width="2"
                              />
                              <path
                                d="M18.5971 3.53523C18.9876 3.14471 19.6208 3.14471 20.0113 3.53523L20.9212 4.44511C21.3117 4.83564 21.3117 5.4688 20.9212 5.85932L14.0195 12.761C13.8756 12.9049 13.6913 13.0015 13.4911 13.0378L12.3793 13.2398C11.6921 13.3646 11.0919 12.7644 11.2167 12.0772L11.4186 10.9654C11.4549 10.7652 11.5515 10.5808 11.6954 10.4369L18.5971 3.53523Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Edit
                            </span>
                          </div>
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="handleDeleteContact('billing')"
                          >
                            <svg
                              class="relative -top-px h-4 w-4 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.9913 9.65885C14.4132 9.237 14.9854 9 15.582 9C16.1786 9 16.7507 9.237 17.1726 9.65885C17.3468 9.83306 17.4895 10.0329 17.597 10.2495H13.567C13.6745 10.0329 13.8171 9.83306 13.9913 9.65885ZM11.4518 10.2495C11.6341 9.49669 12.0204 8.80138 12.5771 8.24464C13.3741 7.44771 14.4549 7 15.582 7C16.709 7 17.7899 7.44771 18.5868 8.24464C19.1435 8.80138 19.5298 9.49669 19.7121 10.2495H19.9363L19.9552 10.2496H23.1642V12.2496H21.9363C21.9363 12.2889 21.9351 12.3285 21.9327 12.3683L21.2781 23.3662C21.2152 24.4228 20.3401 25.2474 19.2816 25.2474H11.8819C10.8235 25.2474 9.94837 24.4228 9.88548 23.3662L9.23084 12.3683C9.22847 12.3285 9.22728 12.2889 9.22724 12.2496H8V10.2496H11.2083L11.2273 10.2495H11.4518ZM11.8819 23.2474L11.2273 12.2496H19.9363L19.2816 23.2474H11.8819ZM12.6865 21.336L12.6865 13.7539H14.6865L14.6865 21.336H12.6865ZM16.4775 13.7539V21.336H18.4775V13.7539H16.4775Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="relative -left-px text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Delete
                            </span>
                          </div>
                        </div>
                        <div
                          class="text-contact-card align-self-end flex flex-col text-right"
                        >
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedBillingContact?.name"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedBillingContact?.name }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedBillingContact?.phone?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{
                                formatPhone(
                                  savedBillingContact?.phone?.value
                                ) || savedBillingContact?.phone?.value
                              }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedBillingContact?.email_address?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedBillingContact?.email_address?.value }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!savedBillingContact && showBillingForm == false"
                    class="flex w-full cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-placeholder-gray bg-off-white px-6 pb-5 pt-6 hover:bg-alt-white"
                    @click="showForm('billing')"
                  >
                    <svg
                      class="h-10 w-auto text-gray-over-dark"
                      viewBox="0 0 50 49"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_9_170)">
                        <path
                          d="M21.71 24.12C17.85 24.12 14.71 20.98 14.71 17.12C14.71 13.26 17.85 10.12 21.71 10.12C25.57 10.12 28.71 13.26 28.71 17.12C28.71 20.98 25.57 24.12 21.71 24.12ZM21.71 13.12C19.5 13.12 17.71 14.91 17.71 17.12C17.71 19.33 19.5 21.12 21.71 21.12C23.92 21.12 25.71 19.33 25.71 17.12C25.71 14.91 23.92 13.12 21.71 13.12Z"
                          fill="currentColor"
                        />
                        <path
                          d="M30.54 30.17C29.58 29.48 28.56 29.62 27.31 29.62H16.11C14 29.62 12.12 30.71 11.07 32.54C10.02 34.37 10.03 36.55 11.09 38.37L8.5 39.88C6.89 37.12 6.88 33.82 8.47 31.05C10.06 28.28 12.92 26.63 16.11 26.63H27.31C30.25 26.63 33.5 27.49 34.55 30.17C34.55 30.17 34.42 29.95 34.55 30.17H30.55H30.54Z"
                          fill="currentColor"
                        />
                        <path
                          d="M44.54 48.13H32.54C31.47 48.13 30.47 47.71 29.71 46.96C28.95 46.2 28.54 45.2 28.54 44.13V36.13C28.54 35.06 28.96 34.06 29.71 33.3C30.47 32.54 31.47 32.13 32.54 32.13H44.54C45.61 32.13 46.61 32.55 47.37 33.3C48.13 34.06 48.54 35.06 48.54 36.13V44.13C48.54 45.2 48.12 46.2 47.37 46.96C46.61 47.72 45.61 48.13 44.54 48.13ZM30.54 39.13V44.13C30.54 44.66 30.75 45.17 31.13 45.54C31.51 45.92 32.01 46.13 32.54 46.13H44.54C45.07 46.13 45.58 45.92 45.95 45.54C46.32 45.16 46.54 44.65 46.54 44.13V39.13H30.54ZM30.54 37.13H46.54V36.13C46.54 35.6 46.33 35.09 45.95 34.72C45.58 34.35 45.06 34.13 44.54 34.13H32.54C32.01 34.13 31.5 34.34 31.13 34.72C30.76 35.1 30.54 35.6 30.54 36.13V37.13ZM39.54 44.13H38.54C37.99 44.13 37.54 43.68 37.54 43.13C37.54 42.58 37.99 42.13 38.54 42.13H39.54C40.09 42.13 40.54 42.58 40.54 43.13C40.54 43.68 40.09 44.13 39.54 44.13ZM34.54 44.13H33.54C32.99 44.13 32.54 43.68 32.54 43.13C32.54 42.58 32.99 42.13 33.54 42.13H34.54C35.09 42.13 35.54 42.58 35.54 43.13C35.54 43.68 35.09 44.13 34.54 44.13Z"
                          fill="currentColor"
                        />
                        <path
                          d="M2.94 22.73C2.94 12.36 11.35 3.95 21.72 3.95C23.85 3.95 25.88 4.32 27.79 4.97C27.9 4.77 28.03 4.58 28.2 4.41C28.67 3.94 29.3 3.68 29.96 3.68H32.18C29.08 1.97 25.51 1 21.72 1C9.73 1.01 0 10.74 0 22.73C0 34.72 9.73 44.45 21.72 44.45C23.32 44.45 24.87 44.27 26.37 43.94V40.9C24.88 41.28 23.33 41.5 21.72 41.5C11.35 41.5 2.94 33.09 2.94 22.72V22.73Z"
                          fill="currentColor"
                        />
                        <path
                          d="M40.36 14.1C40.36 14.76 40.1 15.39 39.63 15.86C39.52 15.97 39.41 16.06 39.28 16.14C40.05 18.19 40.49 20.41 40.49 22.73C40.49 25.37 39.94 27.88 38.96 30.15H42.1C42.94 27.83 43.43 25.34 43.43 22.73C43.43 18.65 42.3 14.84 40.35 11.57V14.09L40.36 14.1Z"
                          fill="currentColor"
                        />
                        <path
                          d="M45.13 48.18H32.82C31.66 48.18 30.52 47.71 29.69 46.88C28.86 46.05 28.39 44.93 28.39 43.75V35.54C28.39 34.36 28.85 33.25 29.69 32.41C30.53 31.57 31.65 31.11 32.82 31.11H45.13C46.31 31.11 47.42 31.57 48.26 32.41C49.1 33.25 49.56 34.36 49.56 35.54V43.75C49.56 44.93 49.1 46.04 48.26 46.88C47.42 47.72 46.31 48.18 45.13 48.18ZM31.08 38.94V43.75C31.08 44.21 31.27 44.65 31.59 44.98C31.91 45.3 32.36 45.49 32.82 45.49H45.13C45.59 45.49 46.03 45.31 46.36 44.98C46.68 44.66 46.87 44.21 46.87 43.75V38.94H31.09H31.08ZM31.08 36.25H46.86V35.54C46.86 35.08 46.67 34.64 46.35 34.31C46.02 33.98 45.59 33.8 45.12 33.8H32.81C32.35 33.8 31.91 33.99 31.58 34.31C31.26 34.63 31.07 35.08 31.07 35.54V36.25H31.08ZM40 44.07H38.97C38.23 44.07 37.63 43.47 37.63 42.73C37.63 41.99 38.23 41.39 38.97 41.39H40C40.74 41.39 41.34 41.99 41.34 42.73C41.34 43.47 40.74 44.07 40 44.07ZM34.87 44.07H33.84C33.1 44.07 32.5 43.47 32.5 42.73C32.5 41.99 33.1 41.39 33.84 41.39H34.87C35.61 41.39 36.21 41.99 36.21 42.73C36.21 43.47 35.61 44.07 34.87 44.07Z"
                          fill="currentColor"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M36.29 0C36.7 0 37.1 0.16 37.39 0.46C37.68 0.75 37.85 1.15 37.85 1.56V4.85H41.14C41.55 4.85 41.95 5.01 42.24 5.31C42.53 5.6 42.7 6 42.7 6.41C42.7 6.82 42.54 7.22 42.24 7.51C41.94 7.8 41.55 7.97 41.14 7.97H37.85V11.26C37.85 11.67 37.69 12.07 37.39 12.36C37.09 12.65 36.7 12.82 36.29 12.82C35.88 12.82 35.48 12.66 35.19 12.36C34.9 12.07 34.73 11.67 34.73 11.26V7.97H31.44C31.03 7.97 30.63 7.81 30.34 7.51C30.05 7.22 29.88 6.82 29.88 6.41C29.88 6 30.04 5.6 30.34 5.31C30.63 5.02 31.03 4.85 31.44 4.85H34.73V1.56C34.73 1.15 34.89 0.75 35.19 0.46C35.48 0.17 35.88 0 36.29 0V0Z"
                          fill="currentColor"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_9_170">
                          <rect
                            width="49.55"
                            height="48.18"
                            fill="white"
                          />
                        </clipPath>
                      </defs>
                    </svg>

                    <div class="text-center text-sm text-gray-over-dark">
                      Add billing contact
                    </div>
                  </div>
                </div>

                <div
                  v-if="showDispatchForm || showBillingForm"
                  class="w-full cursor-pointer rounded-lg border-placeholder-gray"
                  :class="
                    savedClaimsContact && showClaimsForm == false
                      ? 'border border-body-color'
                      : 'border-dashed border-placeholder-gray'
                  "
                  style="transition: all 400ms"
                  :style="
                    showClaimsForm
                      ? 'flex-grow: 1.000; flex-basis: 100%; order: -9999;'
                      : 'flex-grow: 0.001; flex-basis: calc( ( 100% - 1rem ) / 2); order: 3;'
                  "
                >
                  <div
                    v-if="savedClaimsContact && showClaimsForm == false"
                    class="hover:alt-white relative flex h-28 flex-row items-start justify-between gap-0.5 rounded-lg bg-white p-2 text-body-color"
                  >
                    <div
                      class="absolute left-2 top-2 flex h-24 flex-col items-center gap-0 py-0"
                    >
                      <svg
                        class="h-auto w-6 text-dark-gray"
                        viewBox="0 0 48 51"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M38.97 21.05C39.95 23.33 40.5 25.84 40.5 28.47C40.5 38.84 32.09 47.25 21.72 47.25C11.35 47.25 2.94 38.85 2.94 28.48C2.94 18.11 11.35 9.7 21.72 9.7C23.33 9.7 24.88 9.92 26.37 10.3L26.05 7.2C24.55 6.87 23.32 6.76 21.72 6.76C9.73 6.75 0 16.48 0 28.48C0 40.48 9.73 50.2 21.72 50.2C33.71 50.2 43.44 40.47 43.44 28.48C43.44 25.87 42.96 22.14 41.87 19.91L38.97 21.06V21.05Z"
                          fill="currentColor"
                        />
                        <path
                          d="M21.71 29.87C17.85 29.87 14.71 26.73 14.71 22.87C14.71 19.01 17.85 15.87 21.71 15.87C25.57 15.87 28.71 19.01 28.71 22.87C28.71 26.73 25.57 29.87 21.71 29.87ZM21.71 18.87C19.5 18.87 17.71 20.66 17.71 22.87C17.71 25.08 19.5 26.87 21.71 26.87C23.92 26.87 25.71 25.08 25.71 22.87C25.71 20.66 23.92 18.87 21.71 18.87Z"
                          fill="currentColor"
                        />
                        <path
                          d="M34.92 45.62L32.33 44.11C33.39 42.29 33.4 40.11 32.35 38.28C31.3 36.45 29.42 35.36 27.31 35.36H16.11C14 35.36 12.12 36.45 11.07 38.28C10.02 40.11 10.03 42.29 11.09 44.11L8.5 45.62C6.89 42.86 6.88 39.56 8.47 36.79C10.06 34.02 12.92 32.37 16.11 32.37H27.31C30.5 32.37 33.36 34.02 34.95 36.79C36.54 39.56 36.53 42.86 34.92 45.62Z"
                          fill="currentColor"
                        />
                        <path
                          d="M37.76 19.4C37.64 19.4 37.52 19.39 37.41 19.36C31.82 17.92 27.91 12.88 27.91 7.09C27.91 6.01 28.05 4.94 28.31 3.91C28.48 3.26 29.12 2.82 29.75 2.86C32.36 3 34.87 2.11 36.82 0.370002C37.36 -0.109998 38.16 -0.109998 38.7 0.370002C40.65 2.12 43.15 3.01 45.77 2.86C46.42 2.82 47.04 3.26 47.21 3.91C47.48 4.94 47.61 6.01 47.61 7.09C47.61 12.87 43.7 17.92 38.11 19.36C37.99 19.39 37.88 19.4 37.76 19.4V19.4ZM30.83 5.67C30.76 6.14 30.73 6.61 30.73 7.09C30.73 11.47 33.6 15.3 37.77 16.53C41.93 15.3 44.81 11.46 44.81 7.09C44.81 6.61 44.78 6.14 44.71 5.67C42.2 5.56 39.8 4.72 37.77 3.22C35.75 4.72 33.35 5.56 30.84 5.67H30.83ZM37.77 14.12C36.99 14.12 36.36 13.49 36.36 12.71C36.36 11.93 36.99 11.3 37.76 11.3H37.77C38.55 11.3 39.18 11.93 39.18 12.71C39.18 13.49 38.55 14.12 37.77 14.12ZM37.76 10.37C36.98 10.37 36.35 9.74 36.35 8.96V7.08C36.35 6.3 36.98 5.67 37.76 5.67C38.54 5.67 39.17 6.3 39.17 7.08V8.96C39.17 9.74 38.54 10.37 37.76 10.37Z"
                          fill="currentColor"
                        />
                      </svg>
                      <div
                        class="relative text-center font-semibold uppercase text-dark-gray"
                        style="font-size: 0.6rem"
                      >
                        <span class="block">Claims</span>
                      </div>
                    </div>
                    <div class="flex h-24 w-full flex-col justify-end gap-0.5">
                      <div
                        class="flex h-full flex-col items-end justify-between"
                      >
                        <div class="flex justify-end gap-0.5">
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0.5 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="showForm('claims')"
                          >
                            <svg
                              class="h-3.5 w-3.5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 24 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13 4.39062H6C5.44772 4.39062 5 4.83834 5 5.39062V19.3906C5 19.9429 5.44772 20.3906 6 20.3906H18C18.5523 20.3906 19 19.9429 19 19.3906V12.3906"
                                stroke="currentColor"
                                stroke-width="2"
                              />
                              <path
                                d="M18.5971 3.53523C18.9876 3.14471 19.6208 3.14471 20.0113 3.53523L20.9212 4.44511C21.3117 4.83564 21.3117 5.4688 20.9212 5.85932L14.0195 12.761C13.8756 12.9049 13.6913 13.0015 13.4911 13.0378L12.3793 13.2398C11.6921 13.3646 11.0919 12.7644 11.2167 12.0772L11.4186 10.9654C11.4549 10.7652 11.5515 10.5808 11.6954 10.4369L18.5971 3.53523Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Edit
                            </span>
                          </div>
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="handleDeleteContact('claims')"
                          >
                            <svg
                              class="relative -top-px h-5 w-5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.9913 9.65885C14.4132 9.237 14.9854 9 15.582 9C16.1786 9 16.7507 9.237 17.1726 9.65885C17.3468 9.83306 17.4895 10.0329 17.597 10.2495H13.567C13.6745 10.0329 13.8171 9.83306 13.9913 9.65885ZM11.4518 10.2495C11.6341 9.49669 12.0204 8.80138 12.5771 8.24464C13.3741 7.44771 14.4549 7 15.582 7C16.709 7 17.7899 7.44771 18.5868 8.24464C19.1435 8.80138 19.5298 9.49669 19.7121 10.2495H19.9363L19.9552 10.2496H23.1642V12.2496H21.9363C21.9363 12.2889 21.9351 12.3285 21.9327 12.3683L21.2781 23.3662C21.2152 24.4228 20.3401 25.2474 19.2816 25.2474H11.8819C10.8235 25.2474 9.94837 24.4228 9.88548 23.3662L9.23084 12.3683C9.22847 12.3285 9.22728 12.2889 9.22724 12.2496H8V10.2496H11.2083L11.2273 10.2495H11.4518ZM11.8819 23.2474L11.2273 12.2496H19.9363L19.2816 23.2474H11.8819ZM12.6865 21.336L12.6865 13.7539H14.6865L14.6865 21.336H12.6865ZM16.4775 13.7539V21.336H18.4775V13.7539H16.4775Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="relative -left-px text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Delete
                            </span>
                          </div>
                        </div>
                        <div
                          class="text-contact-card align-self-end flex flex-col text-right"
                        >
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedClaimsContact?.name"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedClaimsContact?.name }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedClaimsContact?.phone?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{
                                formatPhone(savedClaimsContact?.phone?.value) ||
                                savedClaimsContact?.phone?.value
                              }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedClaimsContact?.email_address?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedClaimsContact?.email_address?.value }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!savedClaimsContact && showClaimsForm == false"
                    class="flex w-full cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-placeholder-gray bg-off-white px-6 pb-5 pt-6 hover:bg-alt-white"
                    @click="showForm('claims')"
                  >
                    <svg
                      class="h-10 w-auto text-gray-over-dark"
                      viewBox="0 0 49 51"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.68 23.93C18.82 23.93 15.68 20.79 15.68 16.93C15.68 13.07 18.82 9.93 22.68 9.93C26.54 9.93 29.68 13.07 29.68 16.93C29.68 20.79 26.54 23.93 22.68 23.93ZM22.68 12.93C20.47 12.93 18.68 14.72 18.68 16.93C18.68 19.14 20.47 20.93 22.68 20.93C24.89 20.93 26.68 19.14 26.68 16.93C26.68 14.72 24.89 12.93 22.68 12.93Z"
                        fill="currentColor"
                      />
                      <path
                        d="M31.51 29.98C30.55 29.29 29.53 29.43 28.28 29.43H17.08C14.97 29.43 13.09 30.52 12.04 32.35C10.99 34.18 11 36.36 12.06 38.18L9.46999 39.69C7.85999 36.93 7.84999 33.63 9.43999 30.86C11.03 28.09 13.89 26.44 17.08 26.44H28.28C31.22 26.44 34.47 27.3 35.52 29.98C35.52 29.98 35.39 29.76 35.52 29.98H31.52H31.51Z"
                        fill="currentColor"
                      />
                      <path
                        d="M3.91 22.54C3.91 12.17 12.32 3.76 22.69 3.76C24.82 3.76 26.85 4.13 28.76 4.78C28.87 4.58 29 4.39 29.17 4.22C29.64 3.75 30.27 3.49 30.93 3.49H33.15C30.05 1.78 26.48 0.809998 22.69 0.809998C10.69 0.809998 0.970001 10.54 0.970001 22.53C0.970001 34.52 10.7 44.25 22.69 44.25C24.29 44.25 26.55 43.98 28.05 43.65L27.34 40.7C25.85 41.08 24.3 41.3 22.69 41.3C12.32 41.3 3.91 32.89 3.91 22.52V22.54Z"
                        fill="currentColor"
                      />
                      <path
                        d="M41.33 13.9C41.33 14.56 41.07 15.19 40.6 15.66C40.49 15.77 40.38 15.86 40.25 15.94C41.02 17.99 41.46 20.21 41.46 22.53C41.46 25.17 40.91 26.86 39.93 29.14L42.71 30.84C43.55 28.52 44.41 25.14 44.41 22.52C44.41 18.44 43.28 14.63 41.33 11.36V13.88V13.9Z"
                        fill="currentColor"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M37.26 0.809998C37.67 0.809998 38.07 0.969998 38.36 1.27C38.65 1.56 38.82 1.96 38.82 2.37V5.66H42.11C42.52 5.66 42.92 5.82 43.21 6.12C43.5 6.41 43.67 6.81 43.67 7.22C43.67 7.63 43.51 8.03 43.21 8.32C42.91 8.61 42.52 8.78 42.11 8.78H38.82V12.07C38.82 12.48 38.66 12.88 38.36 13.17C38.06 13.46 37.67 13.63 37.26 13.63C36.85 13.63 36.45 13.47 36.16 13.17C35.87 12.88 35.7 12.48 35.7 12.07V8.78H32.41C32 8.78 31.6 8.62 31.31 8.32C31.02 8.03 30.85 7.63 30.85 7.22C30.85 6.81 31.01 6.41 31.31 6.12C31.6 5.83 32 5.66 32.41 5.66H35.7V2.37C35.7 1.96 35.86 1.56 36.16 1.27C36.45 0.979998 36.85 0.809998 37.26 0.809998Z"
                        fill="currentColor"
                      />
                      <path
                        d="M39.03 50.59C38.91 50.59 38.79 50.58 38.68 50.55C33.09 49.11 29.18 44.07 29.18 38.28C29.18 37.2 29.32 36.13 29.58 35.1C29.75 34.45 30.39 34.01 31.02 34.05C33.63 34.19 36.14 33.3 38.09 31.56C38.63 31.08 39.43 31.08 39.97 31.56C41.92 33.31 44.42 34.2 47.04 34.05C47.69 34.01 48.31 34.45 48.48 35.1C48.75 36.13 48.88 37.2 48.88 38.28C48.88 44.06 44.97 49.11 39.38 50.55C39.26 50.58 39.15 50.59 39.03 50.59V50.59ZM32.1 36.86C32.03 37.33 32 37.8 32 38.28C32 42.66 34.87 46.49 39.04 47.72C43.2 46.49 46.08 42.65 46.08 38.28C46.08 37.8 46.05 37.33 45.98 36.86C43.47 36.75 41.07 35.91 39.04 34.41C37.02 35.91 34.62 36.75 32.11 36.86H32.1ZM39.04 45.31C38.26 45.31 37.63 44.68 37.63 43.9C37.63 43.12 38.26 42.49 39.03 42.49H39.04C39.82 42.49 40.45 43.12 40.45 43.9C40.45 44.68 39.82 45.31 39.04 45.31V45.31ZM39.03 41.56C38.25 41.56 37.62 40.93 37.62 40.15V38.27C37.62 37.49 38.25 36.86 39.03 36.86C39.81 36.86 40.44 37.49 40.44 38.27V40.15C40.44 40.93 39.81 41.56 39.03 41.56Z"
                        fill="currentColor"
                      />
                    </svg>
                    <div class="text-center text-sm text-gray-over-dark">
                      Add claims contact
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            firstTime ||
            savedAfterHoursContact ||
            savedEmergencyContact ||
            savedOwnerContact
          "
          class="pt-4"
        >
          <p
            :class="
              dispatchPhones.length && dispatchEmails.length
                ? 'mb-4 mt-2 text-dark-gray'
                : 'text-body-color'
            "
          >
            Optional Contacts
          </p>
          <div class="mt-4">
            <div class="flex flex-col gap-4">
              <div class="flex flex-col gap-4 md:flex-row md:flex-wrap">
                <div
                  v-if="!showEmergencyForm && !showOwnerForm"
                  class="w-full rounded-lg"
                  :class="[
                    showAfterHoursForm || savedAfterHoursContact?.id > 0
                      ? 'border-solid'
                      : !savedAfterHoursContact &&
                          showAfterHoursForm == false &&
                          !firstTime
                        ? 'border-none'
                        : 'border-dashed',
                    !formLoading
                      ? ''
                      : showEmergencyForm || showOwnerForm
                        ? 'hidden'
                        : '',
                    savedAfterHoursContact && !firstTime
                      ? 'custom-box-shadow border border-light-gray'
                      : savedAfterHoursContact
                        ? 'border border-body-color'
                        : 'border-2 border-placeholder-gray',
                  ]"
                  style="transition: all 400ms"
                  :style="
                    showAfterHoursForm
                      ? 'flex-grow: 1.000; flex-basis: 100%; order: -9999;'
                      : 'flex-grow: 0.001; flex-basis: calc( ( 100% - 2rem - 4px ) / 3); order: 1;'
                  "
                >
                  <div
                    v-if="savedAfterHoursContact && showAfterHoursForm == false"
                    class="hover:alt-white relative flex h-28 flex-row items-start justify-between gap-0.5 rounded-lg bg-white p-2 text-body-color"
                  >
                    <div
                      class="absolute left-2 top-2 flex h-24 flex-col items-center gap-0 py-0"
                    >
                      <svg
                        class="h-auto w-6 text-dark-gray"
                        viewBox="0 0 49 53"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M38.97 23.75C39.95 26.03 40.5 28.54 40.5 31.17C40.5 41.54 32.09 49.95 21.72 49.95C11.35 49.95 2.94 41.54 2.94 31.17C2.94 20.8 11.35 12.39 21.72 12.39C23.33 12.39 24.88 12.61 26.37 12.99L26.05 9.89C24.55 9.56 23.32 9.45 21.72 9.45C9.72 9.45 0 19.18 0 31.17C0 43.16 9.73 52.89 21.72 52.89C33.71 52.89 43.44 43.16 43.44 31.17C43.44 28.56 42.96 24.83 41.87 22.6L38.97 23.75V23.75Z"
                          fill="currentColor"
                        />
                        <path
                          d="M21.71 32.56C17.85 32.56 14.71 29.42 14.71 25.56C14.71 21.7 17.85 18.56 21.71 18.56C25.57 18.56 28.71 21.7 28.71 25.56C28.71 29.42 25.57 32.56 21.71 32.56ZM21.71 21.56C19.5 21.56 17.71 23.35 17.71 25.56C17.71 27.77 19.5 29.56 21.71 29.56C23.92 29.56 25.71 27.77 25.71 25.56C25.71 23.35 23.92 21.56 21.71 21.56Z"
                          fill="currentColor"
                        />
                        <path
                          d="M34.92 48.32L32.33 46.81C33.39 44.99 33.4 42.81 32.35 40.98C31.3 39.15 29.42 38.06 27.31 38.06H16.11C14 38.06 12.12 39.15 11.07 40.98C10.02 42.81 10.03 44.99 11.09 46.81L8.5 48.32C6.89 45.56 6.88 42.26 8.47 39.49C10.06 36.72 12.92 35.07 16.11 35.07H27.31C30.5 35.07 33.36 36.72 34.95 39.49C36.54 42.26 36.53 45.56 34.92 48.32Z"
                          fill="currentColor"
                        />
                        <path
                          d="M38.46 22.08C32.39 22.08 27.46 17.15 27.46 11.08C27.46 6.63 30.12 2.64 34.23 0.919997C34.7 0.729997 35.24 0.830002 35.6 1.19C35.96 1.55 36.06 2.09 35.87 2.55C35.44 3.59 35.22 4.69 35.22 5.82C35.22 10.51 39.03 14.32 43.72 14.32C44.85 14.32 45.95 14.1 46.99 13.67C47.46 13.47 48 13.58 48.36 13.94C48.72 14.3 48.82 14.84 48.63 15.31C46.92 19.42 42.93 22.08 38.47 22.08H38.46ZM32.76 4.77C31.01 6.35 29.96 8.62 29.96 11.08C29.96 15.77 33.77 19.58 38.46 19.58C40.92 19.58 43.19 18.53 44.77 16.78C44.42 16.81 44.06 16.83 43.71 16.83C37.64 16.83 32.71 11.9 32.71 5.83C32.71 5.47 32.73 5.12 32.76 4.77V4.77Z"
                          fill="currentColor"
                        />
                      </svg>
                      <div
                        class="relative text-center font-semibold uppercase text-dark-gray"
                        style="
                          font-size: 0.6rem;
                          line-height: 1.15;
                          padding-top: 2px;
                        "
                      >
                        <span class="block">After Hours</span>
                      </div>
                    </div>
                    <div class="flex h-24 w-full flex-col justify-end gap-0.5">
                      <div
                        class="flex h-full flex-col items-end justify-between"
                      >
                        <div class="flex justify-end gap-0.5">
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0.5 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="showForm('after_hours')"
                          >
                            <svg
                              class="h-3.5 w-3.5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 24 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13 4.39062H6C5.44772 4.39062 5 4.83834 5 5.39062V19.3906C5 19.9429 5.44772 20.3906 6 20.3906H18C18.5523 20.3906 19 19.9429 19 19.3906V12.3906"
                                stroke="currentColor"
                                stroke-width="2"
                              />
                              <path
                                d="M18.5971 3.53523C18.9876 3.14471 19.6208 3.14471 20.0113 3.53523L20.9212 4.44511C21.3117 4.83564 21.3117 5.4688 20.9212 5.85932L14.0195 12.761C13.8756 12.9049 13.6913 13.0015 13.4911 13.0378L12.3793 13.2398C11.6921 13.3646 11.0919 12.7644 11.2167 12.0772L11.4186 10.9654C11.4549 10.7652 11.5515 10.5808 11.6954 10.4369L18.5971 3.53523Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Edit
                            </span>
                          </div>
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="handleDeleteContact('after_hours')"
                          >
                            <svg
                              class="relative -top-px h-5 w-5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.9913 9.65885C14.4132 9.237 14.9854 9 15.582 9C16.1786 9 16.7507 9.237 17.1726 9.65885C17.3468 9.83306 17.4895 10.0329 17.597 10.2495H13.567C13.6745 10.0329 13.8171 9.83306 13.9913 9.65885ZM11.4518 10.2495C11.6341 9.49669 12.0204 8.80138 12.5771 8.24464C13.3741 7.44771 14.4549 7 15.582 7C16.709 7 17.7899 7.44771 18.5868 8.24464C19.1435 8.80138 19.5298 9.49669 19.7121 10.2495H19.9363L19.9552 10.2496H23.1642V12.2496H21.9363C21.9363 12.2889 21.9351 12.3285 21.9327 12.3683L21.2781 23.3662C21.2152 24.4228 20.3401 25.2474 19.2816 25.2474H11.8819C10.8235 25.2474 9.94837 24.4228 9.88548 23.3662L9.23084 12.3683C9.22847 12.3285 9.22728 12.2889 9.22724 12.2496H8V10.2496H11.2083L11.2273 10.2495H11.4518ZM11.8819 23.2474L11.2273 12.2496H19.9363L19.2816 23.2474H11.8819ZM12.6865 21.336L12.6865 13.7539H14.6865L14.6865 21.336H12.6865ZM16.4775 13.7539V21.336H18.4775V13.7539H16.4775Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="relative -left-px text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Delete
                            </span>
                          </div>
                        </div>
                        <div
                          class="text-contact-card align-self-end flex flex-col text-right"
                        >
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedAfterHoursContact?.name"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedAfterHoursContact?.name }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedAfterHoursContact?.phone?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{
                                formatPhone(
                                  savedAfterHoursContact?.phone?.value
                                ) || savedAfterHoursContact?.phone?.value
                              }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="
                              savedAfterHoursContact?.email_address?.value
                            "
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedAfterHoursContact?.email_address?.value }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      !savedAfterHoursContact &&
                      showAfterHoursForm == false &&
                      firstTime
                    "
                    class="hover:alt-white flex cursor-pointer flex-col items-center justify-center gap-2 rounded-lg bg-off-white px-3 pb-5 pt-6"
                    @click="showForm('after_hours')"
                  >
                    <svg
                      class="h-10 w-auto text-gray-over-dark"
                      viewBox="0 0 49 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.68 23.62C18.82 23.62 15.68 20.48 15.68 16.62C15.68 12.76 18.82 9.62 22.68 9.62C26.54 9.62 29.68 12.76 29.68 16.62C29.68 20.48 26.54 23.62 22.68 23.62ZM22.68 12.62C20.47 12.62 18.68 14.41 18.68 16.62C18.68 18.83 20.47 20.62 22.68 20.62C24.89 20.62 26.68 18.83 26.68 16.62C26.68 14.41 24.89 12.62 22.68 12.62Z"
                        fill="currentColor"
                      />
                      <path
                        d="M31.73 26.45C30.74 26.17 29.58 26.12 28.28 26.12H17.08C13.89 26.12 11.03 27.77 9.43999 30.54C7.84999 33.31 7.85999 36.61 9.46999 39.37L12.06 37.86C11 36.04 10.99 33.86 12.04 32.03C13.09 30.2 14.97 29.11 17.08 29.11H28.28C28.85 29.11 28.32 29.07 28.81 29.11"
                        fill="currentColor"
                      />
                      <path
                        d="M3.91 22.23C3.91 11.86 12.32 3.45 22.69 3.45C24.82 3.45 26.85 3.82 28.76 4.47C28.87 4.27 29 4.08 29.17 3.91C29.64 3.44 30.27 3.18 30.93 3.18H33.15C30.05 1.47 26.48 0.5 22.69 0.5C10.69 0.5 0.970001 10.23 0.970001 22.22C0.970001 34.21 10.7 43.94 22.69 43.94C24.29 43.94 25.96 43.79 27.46 43.46L26.19 40.65C24.7 41.03 24.29 41 22.68 41C12.31 41 3.9 32.59 3.9 22.22L3.91 22.23Z"
                        fill="currentColor"
                      />
                      <path
                        d="M41.33 13.6C41.33 14.26 41.07 14.89 40.6 15.36C40.49 15.47 40.38 15.56 40.25 15.64C41.02 17.69 41.46 19.91 41.46 22.23C41.46 24.87 41.05 28.69 37.64 33.52L39.33 36.24C44.03 30.29 44.58 24.72 44.41 22.23C43.96 15.55 43.28 14.34 41.33 11.07V13.59V13.6Z"
                        fill="currentColor"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M37.26 0.510002C37.67 0.510002 38.07 0.670001 38.36 0.970001C38.65 1.26 38.82 1.66 38.82 2.07V5.36H42.11C42.52 5.36 42.92 5.52 43.21 5.82C43.5 6.11 43.67 6.51 43.67 6.92C43.67 7.33 43.51 7.73 43.21 8.02C42.91 8.31 42.52 8.48 42.11 8.48H38.82V11.77C38.82 12.18 38.66 12.58 38.36 12.87C38.06 13.16 37.67 13.33 37.26 13.33C36.85 13.33 36.45 13.17 36.16 12.87C35.87 12.58 35.7 12.18 35.7 11.77V8.48H32.41C32 8.48 31.6 8.32 31.31 8.02C31.02 7.73 30.85 7.33 30.85 6.92C30.85 6.51 31.01 6.11 31.31 5.82C31.6 5.53 32 5.36 32.41 5.36H35.7V2.07C35.7 1.66 35.86 1.26 36.16 0.970001C36.45 0.680001 36.85 0.510002 37.26 0.510002Z"
                        fill="currentColor"
                      />
                      <path
                        d="M38.56 48C32.49 48 27.56 43.07 27.56 37C27.56 32.55 30.22 28.56 34.33 26.84C34.8 26.65 35.34 26.75 35.7 27.11C36.06 27.47 36.16 28.01 35.97 28.47C35.54 29.51 35.32 30.61 35.32 31.74C35.32 36.43 39.13 40.24 43.82 40.24C44.95 40.24 46.05 40.02 47.09 39.59C47.56 39.39 48.1 39.5 48.46 39.86C48.82 40.22 48.92 40.76 48.73 41.23C47.02 45.34 43.03 48 38.57 48H38.56ZM32.86 30.69C31.11 32.27 30.06 34.54 30.06 37C30.06 41.69 33.87 45.5 38.56 45.5C41.02 45.5 43.29 44.45 44.87 42.7C44.52 42.73 44.16 42.75 43.81 42.75C37.74 42.75 32.81 37.82 32.81 31.75C32.81 31.39 32.83 31.04 32.86 30.69Z"
                        fill="currentColor"
                      />
                    </svg>
                    <div class="text-center text-sm text-gray-over-dark">
                      Add after-hours contact
                    </div>
                  </div>
                  <div
                    v-if="showAfterHoursForm == true"
                    class="hover:alt-white relative flex w-full flex-col items-center justify-center gap-4 rounded-lg bg-white p-4 md:flex-row md:items-start"
                  >
                    <div class="flex flex-col items-center gap-1 py-2 pl-2">
                      <svg
                        class="h-auto w-8 text-dark-gray"
                        viewBox="0 0 49 53"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M38.97 23.75C39.95 26.03 40.5 28.54 40.5 31.17C40.5 41.54 32.09 49.95 21.72 49.95C11.35 49.95 2.94 41.54 2.94 31.17C2.94 20.8 11.35 12.39 21.72 12.39C23.33 12.39 24.88 12.61 26.37 12.99L26.05 9.89C24.55 9.56 23.32 9.45 21.72 9.45C9.72 9.45 0 19.18 0 31.17C0 43.16 9.73 52.89 21.72 52.89C33.71 52.89 43.44 43.16 43.44 31.17C43.44 28.56 42.96 24.83 41.87 22.6L38.97 23.75V23.75Z"
                          fill="currentColor"
                        />
                        <path
                          d="M21.71 32.56C17.85 32.56 14.71 29.42 14.71 25.56C14.71 21.7 17.85 18.56 21.71 18.56C25.57 18.56 28.71 21.7 28.71 25.56C28.71 29.42 25.57 32.56 21.71 32.56ZM21.71 21.56C19.5 21.56 17.71 23.35 17.71 25.56C17.71 27.77 19.5 29.56 21.71 29.56C23.92 29.56 25.71 27.77 25.71 25.56C25.71 23.35 23.92 21.56 21.71 21.56Z"
                          fill="currentColor"
                        />
                        <path
                          d="M34.92 48.32L32.33 46.81C33.39 44.99 33.4 42.81 32.35 40.98C31.3 39.15 29.42 38.06 27.31 38.06H16.11C14 38.06 12.12 39.15 11.07 40.98C10.02 42.81 10.03 44.99 11.09 46.81L8.5 48.32C6.89 45.56 6.88 42.26 8.47 39.49C10.06 36.72 12.92 35.07 16.11 35.07H27.31C30.5 35.07 33.36 36.72 34.95 39.49C36.54 42.26 36.53 45.56 34.92 48.32Z"
                          fill="currentColor"
                        />
                        <path
                          d="M38.46 22.08C32.39 22.08 27.46 17.15 27.46 11.08C27.46 6.63 30.12 2.64 34.23 0.919997C34.7 0.729997 35.24 0.830002 35.6 1.19C35.96 1.55 36.06 2.09 35.87 2.55C35.44 3.59 35.22 4.69 35.22 5.82C35.22 10.51 39.03 14.32 43.72 14.32C44.85 14.32 45.95 14.1 46.99 13.67C47.46 13.47 48 13.58 48.36 13.94C48.72 14.3 48.82 14.84 48.63 15.31C46.92 19.42 42.93 22.08 38.47 22.08H38.46ZM32.76 4.77C31.01 6.35 29.96 8.62 29.96 11.08C29.96 15.77 33.77 19.58 38.46 19.58C40.92 19.58 43.19 18.53 44.77 16.78C44.42 16.81 44.06 16.83 43.71 16.83C37.64 16.83 32.71 11.9 32.71 5.83C32.71 5.47 32.73 5.12 32.76 4.77V4.77Z"
                          fill="currentColor"
                        />
                      </svg>
                      <div
                        class="text-center text-xs font-semibold uppercase text-dark-gray"
                      >
                        <span class="block pr-1">After Hours</span>
                      </div>
                    </div>
                    <div
                      class="flex w-full transform flex-col gap-4 border-light-gray transition-all duration-200 md:gap-0 md:border-l lg:mr-8"
                      style="min-height: 260px"
                    >
                      <div class="w-full md:pl-4">
                        <div
                          class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                        >
                          <span
                            class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                          >
                            Contact Name
                          </span>
                          <div class="h-6 w-full overflow-hidden">
                            <Transition name="fadeUp">
                              <div
                                v-if="selectedCensusNameComplete"
                                key="1"
                                class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold uppercase text-white"
                              >
                                <span class="truncate">
                                  {{ selectedCensusName[0] }}
                                </span>
                                <div
                                  class=""
                                  @click="
                                    ((selectedCensusName = []),
                                    (selectedCensusNameComplete = false))
                                  "
                                >
                                  <svg
                                    class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-v-7c65271a=""
                                    style="top: -0.5px"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                      clip-rule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </Transition>
                            <Transition name="fadeUp">
                              <div
                                v-if="!selectedCensusNameComplete"
                                key="2"
                                class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                              >
                                Select name of after-hours contact or add a new
                                name
                              </div>
                            </Transition>
                          </div>
                        </div>
                        <Transition name="fadeDelayHeight">
                          <div
                            v-if="selectedCensusNameComplete"
                            class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                          >
                            <span
                              class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                            >
                              Phone
                            </span>
                            <div class="h-6 w-full overflow-hidden">
                              <TransitionGroup name="fadeUp">
                                <div
                                  v-for="(
                                    selectedPhone, spIndex
                                  ) in selectedCensusPhones"
                                  :key="`phones-${spIndex}`"
                                  class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold uppercase text-white"
                                >
                                  <span class="truncate">
                                    {{
                                      formatPhone(selectedPhone) ||
                                      selectedPhone
                                    }}
                                  </span>
                                  <div
                                    class=""
                                    @click="removeAndCheck('phones', spIndex)"
                                  >
                                    <svg
                                      class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                      xmlns="http://www.w3.org/2000/svg"
                                      data-v-7c65271a=""
                                      style="top: -0.5px"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </TransitionGroup>
                              <Transition name="fadeUp">
                                <div
                                  v-if="
                                    selectedCensusNameComplete &&
                                    selectedCensusPhones?.length == 0
                                  "
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  Select {{ selectedCensusName[0] }}'s phone
                                  number or add new
                                </div>
                              </Transition>
                            </div>
                          </div>
                        </Transition>
                        <Transition name="fadeDelayHeight">
                          <div
                            v-if="
                              selectedCensusNameComplete &&
                              selectedCensusPhonesComplete
                            "
                            class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                          >
                            <span
                              class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                            >
                              Email
                            </span>
                            <div class="h-6 w-full overflow-hidden">
                              <TransitionGroup name="fadeUp">
                                <div
                                  v-for="(
                                    selectedEmail, seIndex
                                  ) in selectedCensusEmails"
                                  :key="`emails-${seIndex}`"
                                  class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold lowercase text-white"
                                >
                                  <span class="truncate">
                                    {{ selectedEmail }}
                                  </span>
                                  <div
                                    class=""
                                    @click="removeAndCheck('emails', seIndex)"
                                  >
                                    <svg
                                      class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                      xmlns="http://www.w3.org/2000/svg"
                                      data-v-7c65271a=""
                                      style="top: -0.5px"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </TransitionGroup>
                              <Transition name="fadeUp">
                                <div
                                  v-if="
                                    selectedCensusNameComplete &&
                                    selectedCensusEmails?.length == 0
                                  "
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  Select {{ selectedCensusName[0] }}'s email
                                  address or add new
                                </div>
                              </Transition>
                            </div>
                          </div>
                        </Transition>
                        <div class="w-full pt-1 md:pr-6">
                          <Transition name="fadeDelay">
                            <div
                              v-if="!selectedCensusNameComplete"
                              class="flex flex-col gap-2 pt-0"
                            >
                              <!-- NOTE: if saved contacts for this contact is_type, show here, else go to censusNames below... -->
                              <div
                                v-if="censusNames?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="contact in censusNames"
                                  :key="contact?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="contact"
                                    :item="contact?.name"
                                    :active="
                                      selectedCensusName.includes(contact?.name)
                                        ? true
                                        : false
                                    "
                                    :handle-select="handleSelectCensusName"
                                    name="census_contacts"
                                    :thin="true"
                                    :model-id="
                                      contact?.is_type == 'after_hours'
                                        ? contact?.id
                                        : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('name')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Name</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                !selectedCensusPhonesComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <div
                                v-if="censusPhones?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="phone in censusPhones"
                                  :key="phone?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="phone"
                                    :item="formatPhone(phone) || phone"
                                    :active="
                                      selectedCensusPhones.includes(phone)
                                        ? true
                                        : false
                                    "
                                    :handle-select="handleSelectCensusPhone"
                                    name="census_phones"
                                    :thin="true"
                                    :model-id="
                                      phone?.is_type == 'after_hours'
                                        ? phone?.id
                                        : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('phone')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Phone</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                selectedCensusPhonesComplete &&
                                !selectedCensusEmailsComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <div
                                v-if="censusEmails?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="email in censusEmails"
                                  :key="email?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="email"
                                    :item="email"
                                    :active="
                                      selectedCensusEmails.includes(email)
                                    "
                                    :handle-select="handleSelectCensusEmail"
                                    name="census_emails"
                                    :thin="true"
                                    :model-id="
                                      email?.is_type == 'after_hours'
                                        ? email?.id
                                        : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('email')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Email</span>
                                  </div>
                                </button-icon>
                                <button-icon
                                  v-if="firstTime"
                                  variant="primary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  :disabled="selectedCensusEmails?.length == 0"
                                  @click="
                                    ((selectedCensusEmailsComplete = true),
                                    saveNewContact('after_hours'))
                                  "
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Save Contact</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                selectedCensusPhonesComplete &&
                                selectedCensusEmailsComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <Transition name="fadeUp">
                                <div
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  <!-- You may edit by removing the contact's name, phone number, and/or email above. When ready, click Save Contact below. -->
                                </div>
                              </Transition>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="primary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  :disabled="selectedCensusEmails?.length == 0"
                                  @click="
                                    ((selectedCensusEmailsComplete = true),
                                    saveNewContact('after_hours'))
                                  "
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Save Contact</span>
                                  </div>
                                </button-icon>
                                <button-icon
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="hideForm('after_hours')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Cancel</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                        </div>
                      </div>
                    </div>
                    <div
                      class="absolute right-2 top-2 z-10 p-1"
                      @click="hideForm('after_hours')"
                    >
                      <svg
                        class="relative h-5 w-5 cursor-pointer text-body-color"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                        data-v-7c65271a=""
                        style="top: -0.5px"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div
                  v-if="!showAfterHoursForm && !showOwnerForm"
                  class="w-full rounded-lg"
                  :class="[
                    showEmergencyForm || savedEmergencyContact?.id > 0
                      ? 'border-solid'
                      : !savedEmergencyContact &&
                          showEmergencyForm == false &&
                          !firstTime
                        ? 'border-none'
                        : 'border-dashed',
                    !formLoading
                      ? ''
                      : showAfterHoursForm || showOwnerForm
                        ? 'hidden'
                        : '',
                    savedEmergencyContact && !firstTime
                      ? 'custom-box-shadow border border-light-gray'
                      : savedEmergencyContact
                        ? 'border border-body-color'
                        : 'border-2 border-placeholder-gray',
                  ]"
                  style="transition: all 400ms"
                  :style="
                    showEmergencyForm
                      ? 'flex-grow: 1.000; flex-basis: 100%; order: -9999;'
                      : 'flex-grow: 0.001; flex-basis: calc( ( 100% - 2rem - 4px ) / 3); order: 2;'
                  "
                >
                  <div
                    v-if="savedEmergencyContact && showEmergencyForm == false"
                    class="hover:alt-white relative flex h-28 flex-row items-start justify-between gap-0.5 rounded-lg bg-white p-2 text-body-color"
                  >
                    <div
                      class="absolute left-2 top-2 flex h-24 flex-col items-center gap-0 py-0"
                    >
                      <svg
                        class="h-auto w-6 text-dark-gray"
                        viewBox="0 0 48 52"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M38.97 21.97C39.95 24.25 40.5 26.76 40.5 29.39C40.5 39.76 32.09 48.17 21.72 48.17C11.35 48.17 2.94 39.76 2.94 29.39C2.94 19.02 11.35 10.61 21.72 10.61C23.33 10.61 24.88 10.83 26.37 11.21L27.83 8.77L26.05 8.11C24.55 7.78 23.32 7.67 21.72 7.67C9.72 7.67 0 17.4 0 29.39C0 41.38 9.73 51.11 21.72 51.11C33.71 51.11 43.44 41.38 43.44 29.39C43.44 26.78 42.96 23.05 41.87 20.82L38.4 20.85L38.97 21.97Z"
                          fill="currentColor"
                        />
                        <path
                          d="M21.71 30.78C17.85 30.78 14.71 27.64 14.71 23.78C14.71 19.92 17.85 16.78 21.71 16.78C25.57 16.78 28.71 19.92 28.71 23.78C28.71 27.64 25.57 30.78 21.71 30.78ZM21.71 19.78C19.5 19.78 17.71 21.57 17.71 23.78C17.71 25.99 19.5 27.78 21.71 27.78C23.92 27.78 25.71 25.99 25.71 23.78C25.71 21.57 23.92 19.78 21.71 19.78Z"
                          fill="currentColor"
                        />
                        <path
                          d="M34.92 46.53L32.33 45.02C33.39 43.2 33.4 41.02 32.35 39.19C31.3 37.36 29.42 36.27 27.31 36.27H16.11C14 36.27 12.12 37.36 11.07 39.19C10.02 41.02 10.03 43.2 11.09 45.02L8.5 46.53C6.89 43.77 6.88 40.47 8.47 37.7C10.06 34.93 12.92 33.28 16.11 33.28H27.31C30.5 33.28 33.36 34.93 34.95 37.7C36.54 40.47 36.53 43.77 34.92 46.53Z"
                          fill="currentColor"
                        />
                        <path
                          d="M44.13 18.81H30.8C29.61 18.81 28.55 18.2 27.95 17.17C27.35 16.14 27.36 14.91 27.95 13.88L34.62 2.33C35.21 1.3 36.28 0.679993 37.47 0.679993C38.66 0.679993 39.72 1.29 40.32 2.33L46.99 13.88C47.58 14.91 47.58 16.14 46.99 17.17C46.4 18.2 45.33 18.81 44.14 18.81H44.13ZM30.12 15.13C29.91 15.49 30.05 15.8 30.12 15.92C30.19 16.04 30.39 16.31 30.8 16.31H44.13C44.54 16.31 44.75 16.03 44.81 15.92C44.87 15.81 45.02 15.49 44.81 15.13L38.15 3.58C37.94 3.22 37.6 3.19 37.47 3.19C37.34 3.19 36.99 3.23 36.79 3.58L30.12 15.13ZM37.47 15.42C36.78 15.42 36.21 14.86 36.21 14.17C36.21 13.48 36.77 12.91 37.46 12.91C38.15 12.91 38.71 13.47 38.71 14.16C38.71 14.85 38.15 15.42 37.46 15.42H37.47ZM37.47 12.25C36.78 12.25 36.22 11.73 36.22 11.09V7.95C36.22 7.31 36.78 6.78999 37.47 6.78999C38.16 6.78999 38.72 7.31 38.72 7.95V11.09C38.72 11.73 38.16 12.25 37.47 12.25Z"
                          fill="currentColor"
                        />
                      </svg>
                      <div
                        class="relative text-center font-semibold uppercase text-dark-gray"
                        style="font-size: 0.6rem"
                      >
                        <span class="block">Emergency</span>
                      </div>
                    </div>
                    <div class="flex h-24 w-full flex-col justify-end gap-0.5">
                      <div
                        class="flex h-full flex-col items-end justify-between"
                      >
                        <div class="flex justify-end gap-0.5">
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0.5 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="showForm('emergency')"
                          >
                            <svg
                              class="h-3.5 w-3.5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 24 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13 4.39062H6C5.44772 4.39062 5 4.83834 5 5.39062V19.3906C5 19.9429 5.44772 20.3906 6 20.3906H18C18.5523 20.3906 19 19.9429 19 19.3906V12.3906"
                                stroke="currentColor"
                                stroke-width="2"
                              />
                              <path
                                d="M18.5971 3.53523C18.9876 3.14471 19.6208 3.14471 20.0113 3.53523L20.9212 4.44511C21.3117 4.83564 21.3117 5.4688 20.9212 5.85932L14.0195 12.761C13.8756 12.9049 13.6913 13.0015 13.4911 13.0378L12.3793 13.2398C11.6921 13.3646 11.0919 12.7644 11.2167 12.0772L11.4186 10.9654C11.4549 10.7652 11.5515 10.5808 11.6954 10.4369L18.5971 3.53523Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Edit
                            </span>
                          </div>
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="handleDeleteContact('emergency')"
                          >
                            <svg
                              class="relative -top-px h-5 w-5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.9913 9.65885C14.4132 9.237 14.9854 9 15.582 9C16.1786 9 16.7507 9.237 17.1726 9.65885C17.3468 9.83306 17.4895 10.0329 17.597 10.2495H13.567C13.6745 10.0329 13.8171 9.83306 13.9913 9.65885ZM11.4518 10.2495C11.6341 9.49669 12.0204 8.80138 12.5771 8.24464C13.3741 7.44771 14.4549 7 15.582 7C16.709 7 17.7899 7.44771 18.5868 8.24464C19.1435 8.80138 19.5298 9.49669 19.7121 10.2495H19.9363L19.9552 10.2496H23.1642V12.2496H21.9363C21.9363 12.2889 21.9351 12.3285 21.9327 12.3683L21.2781 23.3662C21.2152 24.4228 20.3401 25.2474 19.2816 25.2474H11.8819C10.8235 25.2474 9.94837 24.4228 9.88548 23.3662L9.23084 12.3683C9.22847 12.3285 9.22728 12.2889 9.22724 12.2496H8V10.2496H11.2083L11.2273 10.2495H11.4518ZM11.8819 23.2474L11.2273 12.2496H19.9363L19.2816 23.2474H11.8819ZM12.6865 21.336L12.6865 13.7539H14.6865L14.6865 21.336H12.6865ZM16.4775 13.7539V21.336H18.4775V13.7539H16.4775Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="relative -left-px text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Delete
                            </span>
                          </div>
                        </div>
                        <div
                          class="text-contact-card align-self-end flex flex-col text-right"
                        >
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedEmergencyContact?.name"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedEmergencyContact?.name }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedEmergencyContact?.phone?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{
                                formatPhone(
                                  savedEmergencyContact?.phone?.value
                                ) || savedEmergencyContact?.phone?.value
                              }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedEmergencyContact?.email_address?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedEmergencyContact?.email_address?.value }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      !savedEmergencyContact &&
                      showEmergencyForm == false &&
                      firstTime
                    "
                    class="hover:alt-white flex cursor-pointer flex-col items-center justify-center gap-2 rounded-lg bg-off-white px-3 pb-5 pt-6"
                    @click="showForm('emergency')"
                  >
                    <svg
                      class="h-10 w-auto text-gray-over-dark"
                      viewBox="0 0 50 49"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.68 23.84C18.82 23.84 15.68 20.7 15.68 16.84C15.68 12.98 18.82 9.84 22.68 9.84C26.54 9.84 29.68 12.98 29.68 16.84C29.68 20.7 26.54 23.84 22.68 23.84ZM22.68 12.84C20.47 12.84 18.68 14.63 18.68 16.84C18.68 19.05 20.47 20.84 22.68 20.84C24.89 20.84 26.68 19.05 26.68 16.84C26.68 14.63 24.89 12.84 22.68 12.84Z"
                        fill="currentColor"
                      />
                      <path
                        d="M31.51 29.89C30.63 29.2 29.53 29.34 28.28 29.34H17.08C14.97 29.34 13.09 30.43 12.04 32.26C10.99 34.09 11 36.27 12.06 38.09L9.46999 39.6C7.85999 36.84 7.84999 33.54 9.43999 30.77C11.03 28 13.89 26.35 17.08 26.35H28.28C31.22 26.35 34.47 27.21 35.52 29.89C35.52 29.89 35.39 29.67 35.52 29.89L32.8 33.46C32.8 33.46 32.76 30.89 31.52 29.91L31.51 29.89Z"
                        fill="currentColor"
                      />
                      <path
                        d="M3.91 22.45C3.91 12.08 12.32 3.67 22.69 3.67C24.82 3.67 26.85 4.04 28.76 4.69C28.87 4.49 29 4.3 29.17 4.13C29.64 3.66 30.27 3.39999 30.93 3.39999H33.15C30.05 1.68999 26.48 0.720001 22.69 0.720001C10.69 0.720001 0.970001 10.45 0.970001 22.44C0.970001 34.43 10.7 44.16 22.69 44.16C24.29 44.16 25.96 44.01 27.46 43.68L29.15 40.23L27.33 40.61C25.84 40.99 24.29 41.21 22.68 41.21C12.31 41.21 3.9 32.8 3.9 22.43L3.91 22.45Z"
                        fill="currentColor"
                      />
                      <path
                        d="M41.33 13.81C41.33 14.47 41.07 15.1 40.6 15.57C40.49 15.68 40.38 15.77 40.25 15.85C41.02 17.9 41.46 20.12 41.46 22.44C41.46 25.08 41.3 25.84 40.32 28.12L43.02 29.84C43.86 27.52 44.4 25.06 44.4 22.44C44.4 18.36 43.27 14.55 41.32 11.28V13.8L41.33 13.81Z"
                        fill="currentColor"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M37.26 0.729996C37.67 0.729996 38.07 0.890002 38.36 1.19C38.65 1.48 38.82 1.87999 38.82 2.28999V5.58H42.11C42.52 5.58 42.92 5.73999 43.21 6.03999C43.5 6.32999 43.67 6.73 43.67 7.14C43.67 7.55 43.51 7.95001 43.21 8.24001C42.91 8.53001 42.52 8.7 42.11 8.7H38.82V11.99C38.82 12.4 38.66 12.8 38.36 13.09C38.06 13.38 37.67 13.55 37.26 13.55C36.85 13.55 36.45 13.39 36.16 13.09C35.87 12.8 35.7 12.4 35.7 11.99V8.7H32.41C32 8.7 31.6 8.54001 31.31 8.24001C31.02 7.95001 30.85 7.55 30.85 7.14C30.85 6.73 31.01 6.32999 31.31 6.03999C31.6 5.74999 32 5.58 32.41 5.58H35.7V2.28999C35.7 1.87999 35.86 1.48 36.16 1.19C36.45 0.900002 36.85 0.729996 37.26 0.729996Z"
                        fill="currentColor"
                      />
                      <path
                        d="M45.7 48.41H32.37C31.18 48.41 30.12 47.8 29.52 46.77C28.93 45.74 28.93 44.51 29.52 43.48L36.19 31.93C36.78 30.9 37.85 30.28 39.04 30.28C40.23 30.28 41.29 30.9 41.89 31.93L48.56 43.48C49.15 44.51 49.15 45.74 48.56 46.77C47.97 47.8 46.9 48.41 45.71 48.41H45.7ZM31.69 44.73C31.48 45.09 31.62 45.4 31.69 45.52C31.76 45.64 31.96 45.91 32.37 45.91H45.7C46.11 45.91 46.32 45.63 46.38 45.52C46.44 45.41 46.59 45.09 46.38 44.73L39.71 33.18C39.5 32.82 39.16 32.78 39.03 32.78C38.9 32.78 38.55 32.82 38.35 33.18L31.68 44.73H31.69ZM39.04 45.02C38.35 45.02 37.78 44.46 37.78 43.77C37.78 43.08 38.34 42.51 39.03 42.51C39.72 42.51 40.28 43.07 40.28 43.76C40.28 44.45 39.72 45.02 39.03 45.02H39.04ZM39.04 41.85C38.35 41.85 37.79 41.33 37.79 40.69V37.55C37.79 36.91 38.35 36.39 39.04 36.39C39.73 36.39 40.29 36.91 40.29 37.55V40.69C40.29 41.33 39.73 41.85 39.04 41.85Z"
                        fill="currentColor"
                      />
                    </svg>
                    <div class="text-center text-sm text-gray-over-dark">
                      Add emergency contact
                    </div>
                  </div>
                  <div
                    v-if="showEmergencyForm == true"
                    class="hover:alt-white relative flex w-full flex-col items-center justify-center gap-4 rounded-lg bg-white p-4 md:flex-row md:items-start"
                  >
                    <div class="flex flex-col items-center gap-1 py-2 pl-2">
                      <svg
                        class="h-auto w-8 text-dark-gray"
                        viewBox="0 0 48 52"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M38.97 21.97C39.95 24.25 40.5 26.76 40.5 29.39C40.5 39.76 32.09 48.17 21.72 48.17C11.35 48.17 2.94 39.76 2.94 29.39C2.94 19.02 11.35 10.61 21.72 10.61C23.33 10.61 24.88 10.83 26.37 11.21L27.83 8.77L26.05 8.11C24.55 7.78 23.32 7.67 21.72 7.67C9.72 7.67 0 17.4 0 29.39C0 41.38 9.73 51.11 21.72 51.11C33.71 51.11 43.44 41.38 43.44 29.39C43.44 26.78 42.96 23.05 41.87 20.82L38.4 20.85L38.97 21.97Z"
                          fill="currentColor"
                        />
                        <path
                          d="M21.71 30.78C17.85 30.78 14.71 27.64 14.71 23.78C14.71 19.92 17.85 16.78 21.71 16.78C25.57 16.78 28.71 19.92 28.71 23.78C28.71 27.64 25.57 30.78 21.71 30.78ZM21.71 19.78C19.5 19.78 17.71 21.57 17.71 23.78C17.71 25.99 19.5 27.78 21.71 27.78C23.92 27.78 25.71 25.99 25.71 23.78C25.71 21.57 23.92 19.78 21.71 19.78Z"
                          fill="currentColor"
                        />
                        <path
                          d="M34.92 46.53L32.33 45.02C33.39 43.2 33.4 41.02 32.35 39.19C31.3 37.36 29.42 36.27 27.31 36.27H16.11C14 36.27 12.12 37.36 11.07 39.19C10.02 41.02 10.03 43.2 11.09 45.02L8.5 46.53C6.89 43.77 6.88 40.47 8.47 37.7C10.06 34.93 12.92 33.28 16.11 33.28H27.31C30.5 33.28 33.36 34.93 34.95 37.7C36.54 40.47 36.53 43.77 34.92 46.53Z"
                          fill="currentColor"
                        />
                        <path
                          d="M44.13 18.81H30.8C29.61 18.81 28.55 18.2 27.95 17.17C27.35 16.14 27.36 14.91 27.95 13.88L34.62 2.33C35.21 1.3 36.28 0.679993 37.47 0.679993C38.66 0.679993 39.72 1.29 40.32 2.33L46.99 13.88C47.58 14.91 47.58 16.14 46.99 17.17C46.4 18.2 45.33 18.81 44.14 18.81H44.13ZM30.12 15.13C29.91 15.49 30.05 15.8 30.12 15.92C30.19 16.04 30.39 16.31 30.8 16.31H44.13C44.54 16.31 44.75 16.03 44.81 15.92C44.87 15.81 45.02 15.49 44.81 15.13L38.15 3.58C37.94 3.22 37.6 3.19 37.47 3.19C37.34 3.19 36.99 3.23 36.79 3.58L30.12 15.13ZM37.47 15.42C36.78 15.42 36.21 14.86 36.21 14.17C36.21 13.48 36.77 12.91 37.46 12.91C38.15 12.91 38.71 13.47 38.71 14.16C38.71 14.85 38.15 15.42 37.46 15.42H37.47ZM37.47 12.25C36.78 12.25 36.22 11.73 36.22 11.09V7.95C36.22 7.31 36.78 6.78999 37.47 6.78999C38.16 6.78999 38.72 7.31 38.72 7.95V11.09C38.72 11.73 38.16 12.25 37.47 12.25Z"
                          fill="currentColor"
                        />
                      </svg>
                      <div
                        class="text-center text-xs font-semibold uppercase text-dark-gray"
                      >
                        <span class="block pr-1">Emergency</span>
                      </div>
                    </div>
                    <div
                      class="flex w-full transform flex-col gap-4 border-light-gray transition-all duration-200 md:gap-0 md:border-l lg:mr-8"
                      style="min-height: 260px"
                    >
                      <div class="w-full md:pl-4">
                        <div
                          class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                        >
                          <span
                            class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                          >
                            Contact Name
                          </span>
                          <div class="h-6 w-full overflow-hidden">
                            <Transition name="fadeUp">
                              <div
                                v-if="selectedCensusNameComplete"
                                key="1"
                                class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold uppercase text-white"
                              >
                                <span class="truncate">
                                  {{ selectedCensusName[0] }}
                                </span>
                                <div
                                  class=""
                                  @click="
                                    ((selectedCensusName = []),
                                    (selectedCensusNameComplete = false))
                                  "
                                >
                                  <svg
                                    class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-v-7c65271a=""
                                    style="top: -0.5px"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                      clip-rule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </Transition>
                            <Transition name="fadeUp">
                              <div
                                v-if="!selectedCensusNameComplete"
                                key="2"
                                class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                              >
                                Select name of emergency contact or add a new
                                name
                              </div>
                            </Transition>
                          </div>
                        </div>
                        <Transition name="fadeDelayHeight">
                          <div
                            v-if="selectedCensusNameComplete"
                            class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                          >
                            <span
                              class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                            >
                              Phone
                            </span>
                            <div class="h-6 w-full overflow-hidden">
                              <TransitionGroup name="fadeUp">
                                <div
                                  v-for="(
                                    selectedPhone, spIndex
                                  ) in selectedCensusPhones"
                                  :key="`phones-${spIndex}`"
                                  class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold uppercase text-white"
                                >
                                  <span class="truncate">
                                    {{
                                      formatPhone(selectedPhone) ||
                                      selectedPhone
                                    }}
                                  </span>
                                  <div
                                    class=""
                                    @click="removeAndCheck('phones', spIndex)"
                                  >
                                    <svg
                                      class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                      xmlns="http://www.w3.org/2000/svg"
                                      data-v-7c65271a=""
                                      style="top: -0.5px"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </TransitionGroup>
                              <Transition name="fadeUp">
                                <div
                                  v-if="
                                    selectedCensusNameComplete &&
                                    selectedCensusPhones?.length == 0
                                  "
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  Select {{ selectedCensusName[0] }}'s phone
                                  number or add new
                                </div>
                              </Transition>
                            </div>
                          </div>
                        </Transition>
                        <Transition name="fadeDelayHeight">
                          <div
                            v-if="
                              selectedCensusNameComplete &&
                              selectedCensusPhonesComplete
                            "
                            class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                          >
                            <span
                              class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                            >
                              Email
                            </span>
                            <div class="h-6 w-full overflow-hidden">
                              <TransitionGroup name="fadeUp">
                                <div
                                  v-for="(
                                    selectedEmail, seIndex
                                  ) in selectedCensusEmails"
                                  :key="`emails-${seIndex}`"
                                  class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold lowercase text-white"
                                >
                                  <span class="truncate">
                                    {{ selectedEmail }}
                                  </span>
                                  <div
                                    class=""
                                    @click="removeAndCheck('emails', seIndex)"
                                  >
                                    <svg
                                      class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                      xmlns="http://www.w3.org/2000/svg"
                                      data-v-7c65271a=""
                                      style="top: -0.5px"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </TransitionGroup>
                              <Transition name="fadeUp">
                                <div
                                  v-if="
                                    selectedCensusNameComplete &&
                                    selectedCensusEmails?.length == 0
                                  "
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  Select {{ selectedCensusName[0] }}'s email
                                  address or add new
                                </div>
                              </Transition>
                            </div>
                          </div>
                        </Transition>
                        <div class="w-full pt-1 md:pr-6">
                          <Transition name="fadeDelay">
                            <div
                              v-if="!selectedCensusNameComplete"
                              class="flex flex-col gap-2 pt-0"
                            >
                              <!-- NOTE: if saved contacts for this contact is_type, show here, else go to censusNames below... -->
                              <div
                                v-if="censusNames?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="contact in censusNames"
                                  :key="contact?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="contact"
                                    :item="contact?.name"
                                    :active="
                                      selectedCensusName.includes(
                                        contact?.name
                                      ) ?? true
                                    "
                                    :handle-select="handleSelectCensusName"
                                    name="census_contacts"
                                    :thin="true"
                                    :model-id="
                                      contact?.is_type == 'emergency'
                                        ? contact?.id
                                        : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('name')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Name</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                !selectedCensusPhonesComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <div
                                v-if="censusPhones?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="phone in censusPhones"
                                  :key="phone?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="phone"
                                    :item="formatPhone(phone) || phone"
                                    :active="
                                      selectedCensusPhones.includes(phone)
                                    "
                                    :handle-select="handleSelectCensusPhone"
                                    name="census_phones"
                                    :thin="true"
                                    :model-id="
                                      phone?.is_type == 'emergency'
                                        ? phone?.id
                                        : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('phone')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Phone</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                selectedCensusPhonesComplete &&
                                !selectedCensusEmailsComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <div
                                v-if="censusEmails?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="email in censusEmails"
                                  :key="email?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="email"
                                    :item="email"
                                    :active="
                                      selectedCensusEmails.includes(email)
                                    "
                                    :handle-select="handleSelectCensusEmail"
                                    name="census_emails"
                                    :thin="true"
                                    :model-id="
                                      email?.is_type == 'emergency'
                                        ? email?.id
                                        : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('email')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Email</span>
                                  </div>
                                </button-icon>
                                <button-icon
                                  v-if="firstTime"
                                  variant="primary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  :disabled="selectedCensusEmails?.length == 0"
                                  @click="
                                    ((selectedCensusEmailsComplete = true),
                                    saveNewContact('emergency'))
                                  "
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Save Contact</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                selectedCensusPhonesComplete &&
                                selectedCensusEmailsComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <Transition name="fadeUp">
                                <div
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  <!-- You may edit by removing the contact's name, phone number, and/or email above. When ready, click Save Contact below. -->
                                </div>
                              </Transition>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="primary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  :disabled="selectedCensusEmails?.length == 0"
                                  @click="
                                    ((selectedCensusEmailsComplete = true),
                                    saveNewContact('emergency'))
                                  "
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Save Contact</span>
                                  </div>
                                </button-icon>
                                <button-icon
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="hideForm('emergency')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Cancel</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                        </div>
                      </div>
                    </div>
                    <div
                      class="absolute right-2 top-2 z-10 p-1"
                      @click="hideForm('emergency')"
                    >
                      <svg
                        class="relative h-5 w-5 cursor-pointer text-body-color"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                        data-v-7c65271a=""
                        style="top: -0.5px"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div
                  v-if="!showAfterHoursForm && !showEmergencyForm"
                  class="w-full rounded-lg"
                  :class="[
                    showOwnerForm || savedOwnerContact?.id > 0
                      ? 'border-solid'
                      : !savedOwnerContact &&
                          showOwnerForm == false &&
                          !firstTime
                        ? 'border-none'
                        : 'border-dashed',
                    !formLoading
                      ? ''
                      : showAfterHoursForm || showEmergencyForm
                        ? 'hidden'
                        : '',
                    savedOwnerContact && !firstTime
                      ? 'custom-box-shadow border border-light-gray'
                      : savedOwnerContact
                        ? 'border border-body-color'
                        : 'border-2 border-placeholder-gray',
                  ]"
                  style="transition: all 400ms"
                  :style="
                    showOwnerForm
                      ? 'flex-grow: 1.000; flex-basis: 100%; order: -9999;'
                      : 'flex-grow: 0.001; flex-basis: calc( ( 100% - 2rem - 4px ) / 3); order: 3;'
                  "
                >
                  <div
                    v-if="savedOwnerContact && showOwnerForm == false"
                    class="hover:alt-white relative flex h-28 flex-row items-start justify-between gap-0.5 rounded-lg bg-white p-2 text-body-color"
                  >
                    <div
                      class="absolute left-2 top-2 flex h-24 flex-col items-center gap-0 py-0"
                    >
                      <svg
                        class="h-auto w-6 text-dark-gray"
                        viewBox="0 0 47 50"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M39.57 19.97C40.55 22.25 41.1 24.76 41.1 27.39C41.1 37.76 32.69 46.17 22.32 46.17C11.95 46.17 3.54001 37.76 3.54001 27.39C3.54001 17.02 11.95 8.60999 22.32 8.60999C23.93 8.60999 24.3 8.57001 25.79 8.95001L26.65 6.10999C25.15 5.77999 23.92 5.67001 22.32 5.67001C10.32 5.67001 0.600006 15.4 0.600006 27.39C0.600006 39.38 10.33 49.11 22.32 49.11C34.31 49.11 44.04 39.38 44.04 27.39C44.04 24.78 43.56 21.05 42.47 18.82L39.57 19.97V19.97Z"
                          fill="currentColor"
                        />
                        <path
                          d="M22.31 28.78C18.45 28.78 15.31 25.64 15.31 21.78C15.31 17.92 18.45 14.78 22.31 14.78C26.17 14.78 29.31 17.92 29.31 21.78C29.31 25.64 26.17 28.78 22.31 28.78V28.78ZM22.31 17.78C20.1 17.78 18.31 19.57 18.31 21.78C18.31 23.99 20.1 25.78 22.31 25.78C24.52 25.78 26.31 23.99 26.31 21.78C26.31 19.57 24.52 17.78 22.31 17.78Z"
                          fill="currentColor"
                        />
                        <path
                          d="M35.52 44.53L32.93 43.02C33.99 41.2 34 39.02 32.95 37.19C31.9 35.36 30.02 34.27 27.91 34.27H16.71C14.6 34.27 12.72 35.36 11.67 37.19C10.62 39.02 10.63 41.2 11.69 43.02L9.10001 44.53C7.49001 41.77 7.48001 38.47 9.07001 35.7C10.66 32.93 13.52 31.28 16.71 31.28H27.91C31.1 31.28 33.96 32.93 35.55 35.7C37.14 38.47 37.13 41.77 35.52 44.53V44.53Z"
                          fill="currentColor"
                        />
                        <path
                          d="M36.74 19.02C35.49 19.02 34.3 18.51 33.43 17.63C32.22 17.63 30.99 17.16 30.11 16.27C29.22 15.39 28.74 14.18 28.75 12.95C27.87 12.09 27.36 10.89 27.36 9.64001C27.36 8.39001 27.87 7.19999 28.75 6.32999C28.74 5.09999 29.22 3.89001 30.11 3.01001C31 2.13001 32.25 1.63999 33.43 1.64999C34.29 0.769994 35.49 0.259995 36.74 0.259995C37.99 0.259995 39.18 0.769994 40.05 1.64999C41.29 1.64999 42.49 2.12001 43.37 3.01001C44.25 3.90001 44.74 5.09999 44.73 6.32999C45.61 7.18999 46.12 8.38001 46.12 9.64001C46.12 10.9 45.61 12.08 44.73 12.95C44.74 14.18 44.26 15.39 43.37 16.27C42.49 17.15 41.31 17.63 40.09 17.63H40.05C39.19 18.51 37.99 19.02 36.74 19.02ZM33.97 15.08C34.37 15.08 34.76 15.27 34.99 15.61C35.39 16.18 36.04 16.52 36.74 16.52C37.44 16.52 38.09 16.18 38.49 15.61C38.77 15.21 39.25 15.01 39.73 15.1C40.41 15.22 41.12 15 41.61 14.51C42.1 14.02 42.32 13.32 42.2 12.63C42.12 12.15 42.32 11.67 42.71 11.39C43.28 10.99 43.62 10.34 43.62 9.64001C43.62 8.94001 43.28 8.29001 42.71 7.89001C42.31 7.61001 42.12 7.12999 42.2 6.64999C42.32 5.96999 42.1 5.25999 41.61 4.76999C41.12 4.27999 40.42 4.05999 39.73 4.17999C39.25 4.26999 38.77 4.06001 38.49 3.67001C38.09 3.10001 37.44 2.76001 36.74 2.76001C36.04 2.76001 35.39 3.10001 34.99 3.67001C34.71 4.06001 34.23 4.26999 33.75 4.17999C33.07 4.05999 32.36 4.27999 31.87 4.76999C31.38 5.25999 31.16 5.95999 31.28 6.64999C31.36 7.12999 31.16 7.61001 30.77 7.89001C30.2 8.29001 29.86 8.94001 29.86 9.64001C29.86 10.34 30.2 10.99 30.77 11.39C31.17 11.67 31.36 12.15 31.28 12.63C31.16 13.32 31.38 14.02 31.87 14.51C32.36 15 33.06 15.22 33.75 15.1C33.82 15.09 33.89 15.08 33.96 15.08H33.97ZM36.06 13.6C35.73 13.6 35.41 13.47 35.18 13.23L33.15 11.2C32.66 10.71 32.66 9.91999 33.15 9.42999C33.64 8.93999 34.43 8.93999 34.92 9.42999L35.91 10.42L38.44 6.88C38.84 6.32 39.62 6.19 40.18 6.59C40.74 6.99 40.87 7.76999 40.47 8.32999L37.09 13.07C36.88 13.37 36.54 13.56 36.18 13.59C36.14 13.59 36.11 13.59 36.08 13.59L36.06 13.6Z"
                          fill="currentColor"
                        />
                      </svg>
                      <div
                        class="relative text-center font-semibold uppercase text-dark-gray"
                        style="font-size: 0.6rem"
                      >
                        <span class="block">Owner</span>
                      </div>
                    </div>
                    <div class="flex h-24 w-full flex-col justify-end gap-0.5">
                      <div
                        class="flex h-full flex-col items-end justify-between"
                      >
                        <div class="flex justify-end gap-0.5">
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0.5 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="showForm('owner')"
                          >
                            <svg
                              class="h-3.5 w-3.5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 24 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13 4.39062H6C5.44772 4.39062 5 4.83834 5 5.39062V19.3906C5 19.9429 5.44772 20.3906 6 20.3906H18C18.5523 20.3906 19 19.9429 19 19.3906V12.3906"
                                stroke="currentColor"
                                stroke-width="2"
                              />
                              <path
                                d="M18.5971 3.53523C18.9876 3.14471 19.6208 3.14471 20.0113 3.53523L20.9212 4.44511C21.3117 4.83564 21.3117 5.4688 20.9212 5.85932L14.0195 12.761C13.8756 12.9049 13.6913 13.0015 13.4911 13.0378L12.3793 13.2398C11.6921 13.3646 11.0919 12.7644 11.2167 12.0772L11.4186 10.9654C11.4549 10.7652 11.5515 10.5808 11.6954 10.4369L18.5971 3.53523Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Edit
                            </span>
                          </div>
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="handleDeleteContact('owner')"
                          >
                            <svg
                              class="relative -top-px h-5 w-5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.9913 9.65885C14.4132 9.237 14.9854 9 15.582 9C16.1786 9 16.7507 9.237 17.1726 9.65885C17.3468 9.83306 17.4895 10.0329 17.597 10.2495H13.567C13.6745 10.0329 13.8171 9.83306 13.9913 9.65885ZM11.4518 10.2495C11.6341 9.49669 12.0204 8.80138 12.5771 8.24464C13.3741 7.44771 14.4549 7 15.582 7C16.709 7 17.7899 7.44771 18.5868 8.24464C19.1435 8.80138 19.5298 9.49669 19.7121 10.2495H19.9363L19.9552 10.2496H23.1642V12.2496H21.9363C21.9363 12.2889 21.9351 12.3285 21.9327 12.3683L21.2781 23.3662C21.2152 24.4228 20.3401 25.2474 19.2816 25.2474H11.8819C10.8235 25.2474 9.94837 24.4228 9.88548 23.3662L9.23084 12.3683C9.22847 12.3285 9.22728 12.2889 9.22724 12.2496H8V10.2496H11.2083L11.2273 10.2495H11.4518ZM11.8819 23.2474L11.2273 12.2496H19.9363L19.2816 23.2474H11.8819ZM12.6865 21.336L12.6865 13.7539H14.6865L14.6865 21.336H12.6865ZM16.4775 13.7539V21.336H18.4775V13.7539H16.4775Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="relative -left-px text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Delete
                            </span>
                          </div>
                        </div>
                        <div
                          class="text-contact-card align-self-end flex flex-col text-right"
                        >
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedOwnerContact?.name"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedOwnerContact?.name }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedOwnerContact?.phone?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{
                                formatPhone(savedOwnerContact?.phone?.value) ||
                                savedOwnerContact?.phone?.value
                              }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedOwnerContact?.email_address?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedOwnerContact?.email_address?.value }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      !savedOwnerContact && showOwnerForm == false && firstTime
                    "
                    class="hover:alt-white flex cursor-pointer flex-col items-center justify-center gap-2 rounded-lg bg-off-white px-3 pb-5 pt-6"
                    @click="showForm('owner')"
                  >
                    <svg
                      class="h-10 w-auto text-gray-over-dark"
                      viewBox="0 0 48 49"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.28 23.84C18.42 23.84 15.28 20.7 15.28 16.84C15.28 12.98 18.42 9.84 22.28 9.84C26.14 9.84 29.28 12.98 29.28 16.84C29.28 20.7 26.14 23.84 22.28 23.84ZM22.28 12.84C20.07 12.84 18.28 14.63 18.28 16.84C18.28 19.05 20.07 20.84 22.28 20.84C24.49 20.84 26.28 19.05 26.28 16.84C26.28 14.63 24.49 12.84 22.28 12.84Z"
                        fill="currentColor"
                      />
                      <path
                        d="M31.11 29.89C30.15 29.2 29.13 29.34 27.88 29.34H16.68C14.57 29.34 12.69 30.43 11.64 32.26C10.59 34.09 10.6 36.27 11.66 38.09L9.07 39.6C7.46 36.84 7.45 33.54 9.04 30.77C10.63 28 13.49 26.35 16.68 26.35H27.88C30.82 26.35 34.07 27.21 35.12 29.89C35.12 29.89 34.99 29.67 35.12 29.89H31.12H31.11Z"
                        fill="currentColor"
                      />
                      <path
                        d="M3.52 22.45C3.52 12.08 11.93 3.67001 22.3 3.67001C24.43 3.67001 26.46 4.04 28.37 4.69C28.48 4.49 28.61 4.3 28.78 4.13C29.25 3.66 29.88 3.39999 30.54 3.39999H32.76C29.66 1.68999 26.09 0.720001 22.3 0.720001C10.3 0.720001 0.580002 10.45 0.580002 22.44C0.580002 34.43 10.31 44.16 22.3 44.16C23.9 44.16 26.16 43.89 27.66 43.56L26.95 40.61C25.46 40.99 23.91 41.21 22.3 41.21C11.93 41.21 3.52 32.8 3.52 22.43V22.45Z"
                        fill="currentColor"
                      />
                      <path
                        d="M40.94 13.81C40.94 14.47 40.68 15.1 40.21 15.57C40.1 15.68 39.99 15.77 39.86 15.85C40.63 17.9 41.07 20.12 41.07 22.44C41.07 25.08 40.52 26.77 39.54 29.05L42.32 30.75C43.16 28.43 44.02 25.05 44.02 22.43C44.02 18.35 42.89 14.54 40.94 11.27V13.79V13.81Z"
                        fill="currentColor"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M36.86 0.730011C37.27 0.730011 37.67 0.890002 37.96 1.19C38.25 1.48 38.42 1.88001 38.42 2.29001V5.57999H41.71C42.12 5.57999 42.52 5.74001 42.81 6.04001C43.1 6.33001 43.27 6.73001 43.27 7.14001C43.27 7.55001 43.11 7.94999 42.81 8.23999C42.51 8.52999 42.12 8.70001 41.71 8.70001H38.42V11.99C38.42 12.4 38.26 12.8 37.96 13.09C37.66 13.38 37.27 13.55 36.86 13.55C36.45 13.55 36.05 13.39 35.76 13.09C35.47 12.8 35.3 12.4 35.3 11.99V8.70001H32.01C31.6 8.70001 31.2 8.53999 30.91 8.23999C30.62 7.94999 30.45 7.55001 30.45 7.14001C30.45 6.73001 30.61 6.33001 30.91 6.04001C31.2 5.75001 31.6 5.57999 32.01 5.57999H35.3V2.29001C35.3 1.88001 35.46 1.48 35.76 1.19C36.05 0.900002 36.45 0.730011 36.86 0.730011Z"
                        fill="currentColor"
                      />
                      <path
                        d="M37.67 48.85C36.42 48.85 35.23 48.34 34.36 47.46C33.15 47.46 31.92 46.99 31.04 46.1C30.15 45.22 29.67 44.01 29.68 42.78C28.8 41.92 28.29 40.72 28.29 39.47C28.29 38.22 28.8 37.03 29.68 36.16C29.67 34.93 30.15 33.72 31.04 32.84C31.93 31.96 33.18 31.47 34.36 31.48C35.22 30.6 36.42 30.09 37.67 30.09C38.92 30.09 40.11 30.6 40.98 31.48C42.22 31.48 43.42 31.95 44.3 32.84C45.18 33.73 45.67 34.93 45.66 36.16C46.54 37.02 47.05 38.21 47.05 39.47C47.05 40.73 46.54 41.91 45.66 42.78C45.67 44.01 45.19 45.22 44.3 46.1C43.42 46.98 42.24 47.46 41.02 47.46H40.98C40.12 48.34 38.92 48.85 37.67 48.85V48.85ZM34.9 44.91C35.3 44.91 35.69 45.1 35.92 45.44C36.32 46.01 36.97 46.35 37.67 46.35C38.37 46.35 39.02 46.01 39.42 45.44C39.7 45.04 40.18 44.84 40.66 44.93C41.34 45.05 42.05 44.83 42.54 44.34C43.03 43.85 43.25 43.15 43.13 42.46C43.05 41.98 43.25 41.5 43.64 41.22C44.21 40.82 44.55 40.17 44.55 39.47C44.55 38.77 44.21 38.12 43.64 37.72C43.24 37.44 43.05 36.96 43.13 36.48C43.25 35.8 43.03 35.09 42.54 34.6C42.05 34.11 41.35 33.89 40.66 34.01C40.18 34.1 39.7 33.89 39.42 33.5C39.02 32.93 38.37 32.59 37.67 32.59C36.97 32.59 36.32 32.93 35.92 33.5C35.64 33.89 35.16 34.1 34.68 34.01C34 33.89 33.29 34.11 32.8 34.6C32.31 35.09 32.09 35.79 32.21 36.48C32.29 36.96 32.09 37.44 31.7 37.72C31.13 38.12 30.79 38.77 30.79 39.47C30.79 40.17 31.13 40.82 31.7 41.22C32.1 41.5 32.29 41.98 32.21 42.46C32.09 43.15 32.31 43.85 32.8 44.34C33.29 44.83 33.99 45.05 34.68 44.93C34.75 44.92 34.82 44.91 34.89 44.91H34.9ZM36.99 43.43C36.66 43.43 36.34 43.3 36.11 43.06L34.08 41.03C33.59 40.54 33.59 39.75 34.08 39.26C34.57 38.77 35.36 38.77 35.85 39.26L36.84 40.25L39.37 36.71C39.77 36.15 40.55 36.02 41.11 36.42C41.67 36.82 41.8 37.6 41.4 38.16L38.02 42.9C37.81 43.2 37.47 43.39 37.11 43.42C37.07 43.42 37.04 43.42 37.01 43.42L36.99 43.43Z"
                        fill="currentColor"
                      />
                    </svg>
                    <div class="text-center text-sm text-gray-over-dark">
                      Add owner contact
                    </div>
                  </div>
                  <div
                    v-if="showOwnerForm == true"
                    class="hover:alt-white relative flex w-full flex-col items-center justify-center gap-4 rounded-lg bg-white p-4 md:flex-row md:items-start"
                  >
                    <div class="flex flex-col items-center gap-1 py-2 pl-2">
                      <svg
                        class="h-auto w-8 text-dark-gray"
                        viewBox="0 0 47 50"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M39.57 19.97C40.55 22.25 41.1 24.76 41.1 27.39C41.1 37.76 32.69 46.17 22.32 46.17C11.95 46.17 3.54001 37.76 3.54001 27.39C3.54001 17.02 11.95 8.60999 22.32 8.60999C23.93 8.60999 24.3 8.57001 25.79 8.95001L26.65 6.10999C25.15 5.77999 23.92 5.67001 22.32 5.67001C10.32 5.67001 0.600006 15.4 0.600006 27.39C0.600006 39.38 10.33 49.11 22.32 49.11C34.31 49.11 44.04 39.38 44.04 27.39C44.04 24.78 43.56 21.05 42.47 18.82L39.57 19.97V19.97Z"
                          fill="currentColor"
                        />
                        <path
                          d="M22.31 28.78C18.45 28.78 15.31 25.64 15.31 21.78C15.31 17.92 18.45 14.78 22.31 14.78C26.17 14.78 29.31 17.92 29.31 21.78C29.31 25.64 26.17 28.78 22.31 28.78V28.78ZM22.31 17.78C20.1 17.78 18.31 19.57 18.31 21.78C18.31 23.99 20.1 25.78 22.31 25.78C24.52 25.78 26.31 23.99 26.31 21.78C26.31 19.57 24.52 17.78 22.31 17.78Z"
                          fill="currentColor"
                        />
                        <path
                          d="M35.52 44.53L32.93 43.02C33.99 41.2 34 39.02 32.95 37.19C31.9 35.36 30.02 34.27 27.91 34.27H16.71C14.6 34.27 12.72 35.36 11.67 37.19C10.62 39.02 10.63 41.2 11.69 43.02L9.10001 44.53C7.49001 41.77 7.48001 38.47 9.07001 35.7C10.66 32.93 13.52 31.28 16.71 31.28H27.91C31.1 31.28 33.96 32.93 35.55 35.7C37.14 38.47 37.13 41.77 35.52 44.53V44.53Z"
                          fill="currentColor"
                        />
                        <path
                          d="M36.74 19.02C35.49 19.02 34.3 18.51 33.43 17.63C32.22 17.63 30.99 17.16 30.11 16.27C29.22 15.39 28.74 14.18 28.75 12.95C27.87 12.09 27.36 10.89 27.36 9.64001C27.36 8.39001 27.87 7.19999 28.75 6.32999C28.74 5.09999 29.22 3.89001 30.11 3.01001C31 2.13001 32.25 1.63999 33.43 1.64999C34.29 0.769994 35.49 0.259995 36.74 0.259995C37.99 0.259995 39.18 0.769994 40.05 1.64999C41.29 1.64999 42.49 2.12001 43.37 3.01001C44.25 3.90001 44.74 5.09999 44.73 6.32999C45.61 7.18999 46.12 8.38001 46.12 9.64001C46.12 10.9 45.61 12.08 44.73 12.95C44.74 14.18 44.26 15.39 43.37 16.27C42.49 17.15 41.31 17.63 40.09 17.63H40.05C39.19 18.51 37.99 19.02 36.74 19.02ZM33.97 15.08C34.37 15.08 34.76 15.27 34.99 15.61C35.39 16.18 36.04 16.52 36.74 16.52C37.44 16.52 38.09 16.18 38.49 15.61C38.77 15.21 39.25 15.01 39.73 15.1C40.41 15.22 41.12 15 41.61 14.51C42.1 14.02 42.32 13.32 42.2 12.63C42.12 12.15 42.32 11.67 42.71 11.39C43.28 10.99 43.62 10.34 43.62 9.64001C43.62 8.94001 43.28 8.29001 42.71 7.89001C42.31 7.61001 42.12 7.12999 42.2 6.64999C42.32 5.96999 42.1 5.25999 41.61 4.76999C41.12 4.27999 40.42 4.05999 39.73 4.17999C39.25 4.26999 38.77 4.06001 38.49 3.67001C38.09 3.10001 37.44 2.76001 36.74 2.76001C36.04 2.76001 35.39 3.10001 34.99 3.67001C34.71 4.06001 34.23 4.26999 33.75 4.17999C33.07 4.05999 32.36 4.27999 31.87 4.76999C31.38 5.25999 31.16 5.95999 31.28 6.64999C31.36 7.12999 31.16 7.61001 30.77 7.89001C30.2 8.29001 29.86 8.94001 29.86 9.64001C29.86 10.34 30.2 10.99 30.77 11.39C31.17 11.67 31.36 12.15 31.28 12.63C31.16 13.32 31.38 14.02 31.87 14.51C32.36 15 33.06 15.22 33.75 15.1C33.82 15.09 33.89 15.08 33.96 15.08H33.97ZM36.06 13.6C35.73 13.6 35.41 13.47 35.18 13.23L33.15 11.2C32.66 10.71 32.66 9.91999 33.15 9.42999C33.64 8.93999 34.43 8.93999 34.92 9.42999L35.91 10.42L38.44 6.88C38.84 6.32 39.62 6.19 40.18 6.59C40.74 6.99 40.87 7.76999 40.47 8.32999L37.09 13.07C36.88 13.37 36.54 13.56 36.18 13.59C36.14 13.59 36.11 13.59 36.08 13.59L36.06 13.6Z"
                          fill="currentColor"
                        />
                      </svg>
                      <div
                        class="text-center text-xs font-semibold uppercase text-dark-gray"
                      >
                        <span class="block pr-1">Owner</span>
                      </div>
                    </div>
                    <div
                      class="flex w-full transform flex-col gap-4 border-light-gray transition-all duration-200 md:gap-0 md:border-l lg:mr-8"
                      style="min-height: 260px"
                    >
                      <div class="w-full md:pl-4">
                        <div
                          class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                        >
                          <span
                            class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                          >
                            Contact Name
                          </span>
                          <div class="h-6 w-full overflow-hidden">
                            <Transition name="fadeUp">
                              <div
                                v-if="selectedCensusNameComplete"
                                key="1"
                                class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold uppercase text-white"
                              >
                                <span class="truncate">
                                  {{ selectedCensusName[0] }}
                                </span>
                                <div
                                  class=""
                                  @click="
                                    ((selectedCensusName = []),
                                    (selectedCensusNameComplete = false))
                                  "
                                >
                                  <svg
                                    class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-v-7c65271a=""
                                    style="top: -0.5px"
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                      clip-rule="evenodd"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </Transition>
                            <Transition name="fadeUp">
                              <div
                                v-if="!selectedCensusNameComplete"
                                key="2"
                                class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                              >
                                Select name of owner contact or add a new name
                              </div>
                            </Transition>
                          </div>
                        </div>
                        <Transition name="fadeDelayHeight">
                          <div
                            v-if="selectedCensusNameComplete"
                            class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                          >
                            <span
                              class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                            >
                              Phone
                            </span>
                            <div class="h-6 w-full overflow-hidden">
                              <TransitionGroup name="fadeUp">
                                <div
                                  v-for="(
                                    selectedPhone, spIndex
                                  ) in selectedCensusPhones"
                                  :key="`phones-${spIndex}`"
                                  class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold uppercase text-white"
                                >
                                  <span class="truncate">
                                    {{
                                      formatPhone(selectedPhone) ||
                                      selectedPhone
                                    }}
                                  </span>
                                  <div
                                    class=""
                                    @click="removeAndCheck('phones', spIndex)"
                                  >
                                    <svg
                                      class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                      xmlns="http://www.w3.org/2000/svg"
                                      data-v-7c65271a=""
                                      style="top: -0.5px"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </TransitionGroup>
                              <Transition name="fadeUp">
                                <div
                                  v-if="
                                    selectedCensusNameComplete &&
                                    selectedCensusPhones?.length == 0
                                  "
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  Select {{ selectedCensusName[0] }}'s phone
                                  number or add new
                                </div>
                              </Transition>
                            </div>
                          </div>
                        </Transition>
                        <Transition name="fadeDelayHeight">
                          <div
                            v-if="
                              selectedCensusNameComplete &&
                              selectedCensusPhonesComplete
                            "
                            class="mb-1 flex gap-2 text-left text-xs text-body-color md:flex-row md:items-start"
                          >
                            <span
                              class="inline-block whitespace-nowrap py-1 pr-1 font-semibold uppercase leading-normal"
                            >
                              Email
                            </span>
                            <div class="h-6 w-full overflow-hidden">
                              <TransitionGroup name="fadeUp">
                                <div
                                  v-for="(
                                    selectedEmail, seIndex
                                  ) in selectedCensusEmails"
                                  :key="`emails-${seIndex}`"
                                  class="inline-flex max-w-full items-center gap-1 overflow-hidden rounded-full bg-yellow-500 px-2 py-1 text-xs font-semibold lowercase text-white"
                                >
                                  <span class="truncate">
                                    {{ selectedEmail }}
                                  </span>
                                  <div
                                    class=""
                                    @click="removeAndCheck('emails', seIndex)"
                                  >
                                    <svg
                                      class="relative h-3.5 w-3.5 cursor-pointer rounded-full text-white hover:bg-yellow-600"
                                      fill="currentColor"
                                      viewBox="0 0 20 20"
                                      xmlns="http://www.w3.org/2000/svg"
                                      data-v-7c65271a=""
                                      style="top: -0.5px"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                        clip-rule="evenodd"
                                      />
                                    </svg>
                                  </div>
                                </div>
                              </TransitionGroup>
                              <Transition name="fadeUp">
                                <div
                                  v-if="
                                    selectedCensusNameComplete &&
                                    selectedCensusEmails?.length == 0
                                  "
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  Select {{ selectedCensusName[0] }}'s email
                                  address or add new
                                </div>
                              </Transition>
                            </div>
                          </div>
                        </Transition>
                        <div class="w-full pt-1 md:pr-6">
                          <Transition name="fadeDelay">
                            <div
                              v-if="!selectedCensusNameComplete"
                              class="flex flex-col gap-2 pt-0"
                            >
                              <!-- NOTE: if saved contacts for this contact is_type, show here, else go to censusNames below... -->
                              <div
                                v-if="censusNames?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="contact in censusNames"
                                  :key="contact?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="contact"
                                    :item="contact?.name"
                                    :active="
                                      selectedCensusName.includes(
                                        contact?.name
                                      ) ?? true
                                    "
                                    :handle-select="handleSelectCensusName"
                                    name="census_contacts"
                                    :thin="true"
                                    :model-id="
                                      contact?.is_type == 'owner'
                                        ? contact?.id
                                        : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('name')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Name</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                !selectedCensusPhonesComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <div
                                v-if="censusPhones?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="phone in censusPhones"
                                  :key="phone?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="phone"
                                    :item="formatPhone(phone) || phone"
                                    :active="
                                      selectedCensusPhones.includes(phone)
                                    "
                                    :handle-select="handleSelectCensusPhone"
                                    name="census_phones"
                                    :thin="true"
                                    :model-id="
                                      phone?.is_type == 'owner' ? phone?.id : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('phone')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Phone</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                selectedCensusPhonesComplete &&
                                !selectedCensusEmailsComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <div
                                v-if="censusEmails?.length > 0"
                                class="grid grid-cols-1 gap-2"
                              >
                                <div
                                  v-for="email in censusEmails"
                                  :key="email?.id"
                                  class="flex flex-col"
                                >
                                  <radio-button
                                    :key="email"
                                    :item="email"
                                    :active="
                                      selectedCensusEmails.includes(email)
                                    "
                                    :handle-select="handleSelectCensusEmail"
                                    name="census_emails"
                                    :thin="true"
                                    :model-id="
                                      email?.is_type == 'owner' ? email?.id : 0
                                    "
                                  />
                                </div>
                              </div>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="toggleModalOn('email')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="text-lg">+</span>
                                    <span>Add New Email</span>
                                  </div>
                                </button-icon>
                                <button-icon
                                  v-if="firstTime"
                                  variant="primary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  :disabled="selectedCensusEmails?.length == 0"
                                  @click="
                                    ((selectedCensusEmailsComplete = true),
                                    saveNewContact('owner'))
                                  "
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Save Contact</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                          <Transition name="fadeDelay">
                            <div
                              v-if="
                                selectedCensusNameComplete &&
                                selectedCensusPhonesComplete &&
                                selectedCensusEmailsComplete
                              "
                              class="flex flex-col gap-2 pt-0"
                            >
                              <Transition name="fadeUp">
                                <div
                                  key="2"
                                  class="top-1px relative hidden py-1 pr-2 text-xs text-body-color sm:block"
                                >
                                  <!-- You may edit by removing the contact's name, phone number, and/or email above. When ready, click Save Contact below. -->
                                </div>
                              </Transition>
                              <div class="flex flex-col gap-2 pt-2 sm:flex-row">
                                <button-icon
                                  v-if="firstTime"
                                  variant="primary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  :disabled="selectedCensusEmails?.length == 0"
                                  @click="
                                    ((selectedCensusEmailsComplete = true),
                                    saveNewContact('owner'))
                                  "
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Save Contact</span>
                                  </div>
                                </button-icon>
                                <button-icon
                                  variant="secondary"
                                  :style="{
                                    paddingTop: '8px',
                                    paddingBottom: '8px',
                                  }"
                                  class="block cursor-pointer md:inline-block"
                                  type="button"
                                  @click="hideForm('owner')"
                                >
                                  <div
                                    class="flex w-full items-center justify-center gap-0.5 px-3 md:w-auto"
                                  >
                                    <span class="w-0 text-lg opacity-0">+</span>
                                    <span>Cancel</span>
                                  </div>
                                </button-icon>
                              </div>
                            </div>
                          </Transition>
                        </div>
                      </div>
                    </div>
                    <div
                      class="absolute right-2 top-2 z-10 p-1"
                      @click="hideForm('owner')"
                    >
                      <svg
                        class="relative h-5 w-5 cursor-pointer text-body-color"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                        data-v-7c65271a=""
                        style="top: -0.5px"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="showAfterHoursForm || showEmergencyForm || showOwnerForm"
                class="flex flex-col gap-4 md:flex-row md:flex-wrap"
              >
                <div
                  v-if="showEmergencyForm || showOwnerForm"
                  class="w-full cursor-pointer rounded-lg border-placeholder-gray"
                  :class="
                    savedAfterHoursContact && showAfterHoursForm == false
                      ? 'border border-body-color'
                      : 'border-dashed border-placeholder-gray'
                  "
                  style="transition: all 400ms"
                  :style="
                    showAfterHoursForm
                      ? 'flex-grow: 1.000; flex-basis: 100%; order: -9999;'
                      : 'flex-grow: 0.001; flex-basis: calc( ( 100% - 1rem ) / 2); order: 1;'
                  "
                >
                  <div
                    v-if="savedAfterHoursContact && showAfterHoursForm == false"
                    class="hover:alt-white relative flex h-28 flex-row items-start justify-between gap-0.5 rounded-lg bg-white p-2 text-body-color"
                  >
                    <div
                      class="absolute left-2 top-2 flex h-24 flex-col items-center gap-0 py-0"
                    >
                      <svg
                        class="h-auto w-6 text-dark-gray"
                        viewBox="0 0 49 53"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M38.97 23.75C39.95 26.03 40.5 28.54 40.5 31.17C40.5 41.54 32.09 49.95 21.72 49.95C11.35 49.95 2.94 41.54 2.94 31.17C2.94 20.8 11.35 12.39 21.72 12.39C23.33 12.39 24.88 12.61 26.37 12.99L26.05 9.89C24.55 9.56 23.32 9.45 21.72 9.45C9.72 9.45 0 19.18 0 31.17C0 43.16 9.73 52.89 21.72 52.89C33.71 52.89 43.44 43.16 43.44 31.17C43.44 28.56 42.96 24.83 41.87 22.6L38.97 23.75V23.75Z"
                          fill="currentColor"
                        />
                        <path
                          d="M21.71 32.56C17.85 32.56 14.71 29.42 14.71 25.56C14.71 21.7 17.85 18.56 21.71 18.56C25.57 18.56 28.71 21.7 28.71 25.56C28.71 29.42 25.57 32.56 21.71 32.56ZM21.71 21.56C19.5 21.56 17.71 23.35 17.71 25.56C17.71 27.77 19.5 29.56 21.71 29.56C23.92 29.56 25.71 27.77 25.71 25.56C25.71 23.35 23.92 21.56 21.71 21.56Z"
                          fill="currentColor"
                        />
                        <path
                          d="M34.92 48.32L32.33 46.81C33.39 44.99 33.4 42.81 32.35 40.98C31.3 39.15 29.42 38.06 27.31 38.06H16.11C14 38.06 12.12 39.15 11.07 40.98C10.02 42.81 10.03 44.99 11.09 46.81L8.5 48.32C6.89 45.56 6.88 42.26 8.47 39.49C10.06 36.72 12.92 35.07 16.11 35.07H27.31C30.5 35.07 33.36 36.72 34.95 39.49C36.54 42.26 36.53 45.56 34.92 48.32Z"
                          fill="currentColor"
                        />
                        <path
                          d="M38.46 22.08C32.39 22.08 27.46 17.15 27.46 11.08C27.46 6.63 30.12 2.64 34.23 0.919997C34.7 0.729997 35.24 0.830002 35.6 1.19C35.96 1.55 36.06 2.09 35.87 2.55C35.44 3.59 35.22 4.69 35.22 5.82C35.22 10.51 39.03 14.32 43.72 14.32C44.85 14.32 45.95 14.1 46.99 13.67C47.46 13.47 48 13.58 48.36 13.94C48.72 14.3 48.82 14.84 48.63 15.31C46.92 19.42 42.93 22.08 38.47 22.08H38.46ZM32.76 4.77C31.01 6.35 29.96 8.62 29.96 11.08C29.96 15.77 33.77 19.58 38.46 19.58C40.92 19.58 43.19 18.53 44.77 16.78C44.42 16.81 44.06 16.83 43.71 16.83C37.64 16.83 32.71 11.9 32.71 5.83C32.71 5.47 32.73 5.12 32.76 4.77V4.77Z"
                          fill="currentColor"
                        />
                      </svg>
                      <div
                        class="relative text-center font-semibold uppercase text-dark-gray"
                        style="
                          font-size: 0.6rem;
                          line-height: 1.15;
                          padding-top: 2px;
                        "
                      >
                        <span class="block">After Hours</span>
                      </div>
                    </div>
                    <div class="flex h-24 w-full flex-col justify-end gap-0.5">
                      <div
                        class="flex h-full flex-col items-end justify-between"
                      >
                        <div class="flex justify-end gap-0.5">
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0.5 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="showForm('after_hours')"
                          >
                            <svg
                              class="h-3.5 w-3.5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 24 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13 4.39062H6C5.44772 4.39062 5 4.83834 5 5.39062V19.3906C5 19.9429 5.44772 20.3906 6 20.3906H18C18.5523 20.3906 19 19.9429 19 19.3906V12.3906"
                                stroke="currentColor"
                                stroke-width="2"
                              />
                              <path
                                d="M18.5971 3.53523C18.9876 3.14471 19.6208 3.14471 20.0113 3.53523L20.9212 4.44511C21.3117 4.83564 21.3117 5.4688 20.9212 5.85932L14.0195 12.761C13.8756 12.9049 13.6913 13.0015 13.4911 13.0378L12.3793 13.2398C11.6921 13.3646 11.0919 12.7644 11.2167 12.0772L11.4186 10.9654C11.4549 10.7652 11.5515 10.5808 11.6954 10.4369L18.5971 3.53523Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Edit
                            </span>
                          </div>
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="handleDeleteContact('after_hours')"
                          >
                            <svg
                              class="relative -top-px h-5 w-5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.9913 9.65885C14.4132 9.237 14.9854 9 15.582 9C16.1786 9 16.7507 9.237 17.1726 9.65885C17.3468 9.83306 17.4895 10.0329 17.597 10.2495H13.567C13.6745 10.0329 13.8171 9.83306 13.9913 9.65885ZM11.4518 10.2495C11.6341 9.49669 12.0204 8.80138 12.5771 8.24464C13.3741 7.44771 14.4549 7 15.582 7C16.709 7 17.7899 7.44771 18.5868 8.24464C19.1435 8.80138 19.5298 9.49669 19.7121 10.2495H19.9363L19.9552 10.2496H23.1642V12.2496H21.9363C21.9363 12.2889 21.9351 12.3285 21.9327 12.3683L21.2781 23.3662C21.2152 24.4228 20.3401 25.2474 19.2816 25.2474H11.8819C10.8235 25.2474 9.94837 24.4228 9.88548 23.3662L9.23084 12.3683C9.22847 12.3285 9.22728 12.2889 9.22724 12.2496H8V10.2496H11.2083L11.2273 10.2495H11.4518ZM11.8819 23.2474L11.2273 12.2496H19.9363L19.2816 23.2474H11.8819ZM12.6865 21.336L12.6865 13.7539H14.6865L14.6865 21.336H12.6865ZM16.4775 13.7539V21.336H18.4775V13.7539H16.4775Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="relative -left-px text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Delete
                            </span>
                          </div>
                        </div>
                        <div
                          class="text-contact-card align-self-end flex flex-col text-right"
                        >
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedAfterHoursContact?.name"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedAfterHoursContact?.name }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedAfterHoursContact?.phone?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{
                                formatPhone(
                                  savedAfterHoursContact?.phone?.value
                                ) || savedAfterHoursContact?.phone?.value
                              }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="
                              savedAfterHoursContact?.email_address?.value
                            "
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedAfterHoursContact?.email_address?.value }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      !savedAfterHoursContact && showAfterHoursForm == false
                    "
                    class="flex cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-placeholder-gray bg-off-white px-3 pb-5 pt-6"
                    @click="showForm('after_hours')"
                  >
                    <svg
                      class="h-10 w-auto text-gray-over-dark"
                      viewBox="0 0 49 48"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.68 23.62C18.82 23.62 15.68 20.48 15.68 16.62C15.68 12.76 18.82 9.62 22.68 9.62C26.54 9.62 29.68 12.76 29.68 16.62C29.68 20.48 26.54 23.62 22.68 23.62ZM22.68 12.62C20.47 12.62 18.68 14.41 18.68 16.62C18.68 18.83 20.47 20.62 22.68 20.62C24.89 20.62 26.68 18.83 26.68 16.62C26.68 14.41 24.89 12.62 22.68 12.62Z"
                        fill="currentColor"
                      />
                      <path
                        d="M31.73 26.45C30.74 26.17 29.58 26.12 28.28 26.12H17.08C13.89 26.12 11.03 27.77 9.43999 30.54C7.84999 33.31 7.85999 36.61 9.46999 39.37L12.06 37.86C11 36.04 10.99 33.86 12.04 32.03C13.09 30.2 14.97 29.11 17.08 29.11H28.28C28.85 29.11 28.32 29.07 28.81 29.11"
                        fill="currentColor"
                      />
                      <path
                        d="M3.91 22.23C3.91 11.86 12.32 3.45 22.69 3.45C24.82 3.45 26.85 3.82 28.76 4.47C28.87 4.27 29 4.08 29.17 3.91C29.64 3.44 30.27 3.18 30.93 3.18H33.15C30.05 1.47 26.48 0.5 22.69 0.5C10.69 0.5 0.970001 10.23 0.970001 22.22C0.970001 34.21 10.7 43.94 22.69 43.94C24.29 43.94 25.96 43.79 27.46 43.46L26.19 40.65C24.7 41.03 24.29 41 22.68 41C12.31 41 3.9 32.59 3.9 22.22L3.91 22.23Z"
                        fill="currentColor"
                      />
                      <path
                        d="M41.33 13.6C41.33 14.26 41.07 14.89 40.6 15.36C40.49 15.47 40.38 15.56 40.25 15.64C41.02 17.69 41.46 19.91 41.46 22.23C41.46 24.87 41.05 28.69 37.64 33.52L39.33 36.24C44.03 30.29 44.58 24.72 44.41 22.23C43.96 15.55 43.28 14.34 41.33 11.07V13.59V13.6Z"
                        fill="currentColor"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M37.26 0.510002C37.67 0.510002 38.07 0.670001 38.36 0.970001C38.65 1.26 38.82 1.66 38.82 2.07V5.36H42.11C42.52 5.36 42.92 5.52 43.21 5.82C43.5 6.11 43.67 6.51 43.67 6.92C43.67 7.33 43.51 7.73 43.21 8.02C42.91 8.31 42.52 8.48 42.11 8.48H38.82V11.77C38.82 12.18 38.66 12.58 38.36 12.87C38.06 13.16 37.67 13.33 37.26 13.33C36.85 13.33 36.45 13.17 36.16 12.87C35.87 12.58 35.7 12.18 35.7 11.77V8.48H32.41C32 8.48 31.6 8.32 31.31 8.02C31.02 7.73 30.85 7.33 30.85 6.92C30.85 6.51 31.01 6.11 31.31 5.82C31.6 5.53 32 5.36 32.41 5.36H35.7V2.07C35.7 1.66 35.86 1.26 36.16 0.970001C36.45 0.680001 36.85 0.510002 37.26 0.510002Z"
                        fill="currentColor"
                      />
                      <path
                        d="M38.56 48C32.49 48 27.56 43.07 27.56 37C27.56 32.55 30.22 28.56 34.33 26.84C34.8 26.65 35.34 26.75 35.7 27.11C36.06 27.47 36.16 28.01 35.97 28.47C35.54 29.51 35.32 30.61 35.32 31.74C35.32 36.43 39.13 40.24 43.82 40.24C44.95 40.24 46.05 40.02 47.09 39.59C47.56 39.39 48.1 39.5 48.46 39.86C48.82 40.22 48.92 40.76 48.73 41.23C47.02 45.34 43.03 48 38.57 48H38.56ZM32.86 30.69C31.11 32.27 30.06 34.54 30.06 37C30.06 41.69 33.87 45.5 38.56 45.5C41.02 45.5 43.29 44.45 44.87 42.7C44.52 42.73 44.16 42.75 43.81 42.75C37.74 42.75 32.81 37.82 32.81 31.75C32.81 31.39 32.83 31.04 32.86 30.69Z"
                        fill="currentColor"
                      />
                    </svg>
                    <div class="text-center text-sm text-gray-over-dark">
                      Add after-hours contact
                    </div>
                  </div>
                </div>

                <div
                  v-if="showAfterHoursForm || showOwnerForm"
                  class="w-full cursor-pointer rounded-lg border-placeholder-gray"
                  :class="
                    savedEmergencyContact && showEmergencyForm == false
                      ? 'border border-body-color'
                      : 'border-dashed border-placeholder-gray'
                  "
                  style="transition: all 400ms"
                  :style="
                    showEmergencyForm
                      ? 'flex-grow: 1.000; flex-basis: 100%; order: -9999;'
                      : 'flex-grow: 0.001; flex-basis: calc( ( 100% - 1rem ) / 2); order: 2;'
                  "
                >
                  <div
                    v-if="savedEmergencyContact && showEmergencyForm == false"
                    class="hover:alt-white relative flex h-28 flex-row items-start justify-between gap-0.5 rounded-lg bg-white p-2 text-body-color"
                  >
                    <div
                      class="absolute left-2 top-2 flex h-24 flex-col items-center gap-0 py-0"
                    >
                      <svg
                        class="h-auto w-6 text-dark-gray"
                        viewBox="0 0 48 52"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M38.97 21.97C39.95 24.25 40.5 26.76 40.5 29.39C40.5 39.76 32.09 48.17 21.72 48.17C11.35 48.17 2.94 39.76 2.94 29.39C2.94 19.02 11.35 10.61 21.72 10.61C23.33 10.61 24.88 10.83 26.37 11.21L27.83 8.77L26.05 8.11C24.55 7.78 23.32 7.67 21.72 7.67C9.72 7.67 0 17.4 0 29.39C0 41.38 9.73 51.11 21.72 51.11C33.71 51.11 43.44 41.38 43.44 29.39C43.44 26.78 42.96 23.05 41.87 20.82L38.4 20.85L38.97 21.97Z"
                          fill="currentColor"
                        />
                        <path
                          d="M21.71 30.78C17.85 30.78 14.71 27.64 14.71 23.78C14.71 19.92 17.85 16.78 21.71 16.78C25.57 16.78 28.71 19.92 28.71 23.78C28.71 27.64 25.57 30.78 21.71 30.78ZM21.71 19.78C19.5 19.78 17.71 21.57 17.71 23.78C17.71 25.99 19.5 27.78 21.71 27.78C23.92 27.78 25.71 25.99 25.71 23.78C25.71 21.57 23.92 19.78 21.71 19.78Z"
                          fill="currentColor"
                        />
                        <path
                          d="M34.92 46.53L32.33 45.02C33.39 43.2 33.4 41.02 32.35 39.19C31.3 37.36 29.42 36.27 27.31 36.27H16.11C14 36.27 12.12 37.36 11.07 39.19C10.02 41.02 10.03 43.2 11.09 45.02L8.5 46.53C6.89 43.77 6.88 40.47 8.47 37.7C10.06 34.93 12.92 33.28 16.11 33.28H27.31C30.5 33.28 33.36 34.93 34.95 37.7C36.54 40.47 36.53 43.77 34.92 46.53Z"
                          fill="currentColor"
                        />
                        <path
                          d="M44.13 18.81H30.8C29.61 18.81 28.55 18.2 27.95 17.17C27.35 16.14 27.36 14.91 27.95 13.88L34.62 2.33C35.21 1.3 36.28 0.679993 37.47 0.679993C38.66 0.679993 39.72 1.29 40.32 2.33L46.99 13.88C47.58 14.91 47.58 16.14 46.99 17.17C46.4 18.2 45.33 18.81 44.14 18.81H44.13ZM30.12 15.13C29.91 15.49 30.05 15.8 30.12 15.92C30.19 16.04 30.39 16.31 30.8 16.31H44.13C44.54 16.31 44.75 16.03 44.81 15.92C44.87 15.81 45.02 15.49 44.81 15.13L38.15 3.58C37.94 3.22 37.6 3.19 37.47 3.19C37.34 3.19 36.99 3.23 36.79 3.58L30.12 15.13ZM37.47 15.42C36.78 15.42 36.21 14.86 36.21 14.17C36.21 13.48 36.77 12.91 37.46 12.91C38.15 12.91 38.71 13.47 38.71 14.16C38.71 14.85 38.15 15.42 37.46 15.42H37.47ZM37.47 12.25C36.78 12.25 36.22 11.73 36.22 11.09V7.95C36.22 7.31 36.78 6.78999 37.47 6.78999C38.16 6.78999 38.72 7.31 38.72 7.95V11.09C38.72 11.73 38.16 12.25 37.47 12.25Z"
                          fill="currentColor"
                        />
                      </svg>
                      <div
                        class="relative text-center font-semibold uppercase text-dark-gray"
                        style="font-size: 0.6rem"
                      >
                        <span class="block">Emergency</span>
                      </div>
                    </div>
                    <div class="flex h-24 w-full flex-col justify-end gap-0.5">
                      <div
                        class="flex h-full flex-col items-end justify-between"
                      >
                        <div class="flex justify-end gap-0.5">
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0.5 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="showForm('emergency')"
                          >
                            <svg
                              class="h-3.5 w-3.5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 24 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13 4.39062H6C5.44772 4.39062 5 4.83834 5 5.39062V19.3906C5 19.9429 5.44772 20.3906 6 20.3906H18C18.5523 20.3906 19 19.9429 19 19.3906V12.3906"
                                stroke="currentColor"
                                stroke-width="2"
                              />
                              <path
                                d="M18.5971 3.53523C18.9876 3.14471 19.6208 3.14471 20.0113 3.53523L20.9212 4.44511C21.3117 4.83564 21.3117 5.4688 20.9212 5.85932L14.0195 12.761C13.8756 12.9049 13.6913 13.0015 13.4911 13.0378L12.3793 13.2398C11.6921 13.3646 11.0919 12.7644 11.2167 12.0772L11.4186 10.9654C11.4549 10.7652 11.5515 10.5808 11.6954 10.4369L18.5971 3.53523Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Edit
                            </span>
                          </div>
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="handleDeleteContact('emergency')"
                          >
                            <svg
                              class="relative -top-px h-5 w-5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.9913 9.65885C14.4132 9.237 14.9854 9 15.582 9C16.1786 9 16.7507 9.237 17.1726 9.65885C17.3468 9.83306 17.4895 10.0329 17.597 10.2495H13.567C13.6745 10.0329 13.8171 9.83306 13.9913 9.65885ZM11.4518 10.2495C11.6341 9.49669 12.0204 8.80138 12.5771 8.24464C13.3741 7.44771 14.4549 7 15.582 7C16.709 7 17.7899 7.44771 18.5868 8.24464C19.1435 8.80138 19.5298 9.49669 19.7121 10.2495H19.9363L19.9552 10.2496H23.1642V12.2496H21.9363C21.9363 12.2889 21.9351 12.3285 21.9327 12.3683L21.2781 23.3662C21.2152 24.4228 20.3401 25.2474 19.2816 25.2474H11.8819C10.8235 25.2474 9.94837 24.4228 9.88548 23.3662L9.23084 12.3683C9.22847 12.3285 9.22728 12.2889 9.22724 12.2496H8V10.2496H11.2083L11.2273 10.2495H11.4518ZM11.8819 23.2474L11.2273 12.2496H19.9363L19.2816 23.2474H11.8819ZM12.6865 21.336L12.6865 13.7539H14.6865L14.6865 21.336H12.6865ZM16.4775 13.7539V21.336H18.4775V13.7539H16.4775Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="relative -left-px text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Delete
                            </span>
                          </div>
                        </div>
                        <div
                          class="text-contact-card align-self-end flex flex-col text-right"
                        >
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedEmergencyContact?.name"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedEmergencyContact?.name }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedEmergencyContact?.phone?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{
                                formatPhone(
                                  savedEmergencyContact?.phone?.value
                                ) || savedEmergencyContact?.phone?.value
                              }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedEmergencyContact?.email_address?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedEmergencyContact?.email_address?.value }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!savedEmergencyContact && showEmergencyForm == false"
                    class="flex cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-placeholder-gray bg-off-white px-3 pb-5 pt-6"
                    @click="showForm('emergency')"
                  >
                    <svg
                      class="h-10 w-auto text-gray-over-dark"
                      viewBox="0 0 50 49"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.68 23.84C18.82 23.84 15.68 20.7 15.68 16.84C15.68 12.98 18.82 9.84 22.68 9.84C26.54 9.84 29.68 12.98 29.68 16.84C29.68 20.7 26.54 23.84 22.68 23.84ZM22.68 12.84C20.47 12.84 18.68 14.63 18.68 16.84C18.68 19.05 20.47 20.84 22.68 20.84C24.89 20.84 26.68 19.05 26.68 16.84C26.68 14.63 24.89 12.84 22.68 12.84Z"
                        fill="currentColor"
                      />
                      <path
                        d="M31.51 29.89C30.63 29.2 29.53 29.34 28.28 29.34H17.08C14.97 29.34 13.09 30.43 12.04 32.26C10.99 34.09 11 36.27 12.06 38.09L9.46999 39.6C7.85999 36.84 7.84999 33.54 9.43999 30.77C11.03 28 13.89 26.35 17.08 26.35H28.28C31.22 26.35 34.47 27.21 35.52 29.89C35.52 29.89 35.39 29.67 35.52 29.89L32.8 33.46C32.8 33.46 32.76 30.89 31.52 29.91L31.51 29.89Z"
                        fill="currentColor"
                      />
                      <path
                        d="M3.91 22.45C3.91 12.08 12.32 3.67 22.69 3.67C24.82 3.67 26.85 4.04 28.76 4.69C28.87 4.49 29 4.3 29.17 4.13C29.64 3.66 30.27 3.39999 30.93 3.39999H33.15C30.05 1.68999 26.48 0.720001 22.69 0.720001C10.69 0.720001 0.970001 10.45 0.970001 22.44C0.970001 34.43 10.7 44.16 22.69 44.16C24.29 44.16 25.96 44.01 27.46 43.68L29.15 40.23L27.33 40.61C25.84 40.99 24.29 41.21 22.68 41.21C12.31 41.21 3.9 32.8 3.9 22.43L3.91 22.45Z"
                        fill="currentColor"
                      />
                      <path
                        d="M41.33 13.81C41.33 14.47 41.07 15.1 40.6 15.57C40.49 15.68 40.38 15.77 40.25 15.85C41.02 17.9 41.46 20.12 41.46 22.44C41.46 25.08 41.3 25.84 40.32 28.12L43.02 29.84C43.86 27.52 44.4 25.06 44.4 22.44C44.4 18.36 43.27 14.55 41.32 11.28V13.8L41.33 13.81Z"
                        fill="currentColor"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M37.26 0.729996C37.67 0.729996 38.07 0.890002 38.36 1.19C38.65 1.48 38.82 1.87999 38.82 2.28999V5.58H42.11C42.52 5.58 42.92 5.73999 43.21 6.03999C43.5 6.32999 43.67 6.73 43.67 7.14C43.67 7.55 43.51 7.95001 43.21 8.24001C42.91 8.53001 42.52 8.7 42.11 8.7H38.82V11.99C38.82 12.4 38.66 12.8 38.36 13.09C38.06 13.38 37.67 13.55 37.26 13.55C36.85 13.55 36.45 13.39 36.16 13.09C35.87 12.8 35.7 12.4 35.7 11.99V8.7H32.41C32 8.7 31.6 8.54001 31.31 8.24001C31.02 7.95001 30.85 7.55 30.85 7.14C30.85 6.73 31.01 6.32999 31.31 6.03999C31.6 5.74999 32 5.58 32.41 5.58H35.7V2.28999C35.7 1.87999 35.86 1.48 36.16 1.19C36.45 0.900002 36.85 0.729996 37.26 0.729996Z"
                        fill="currentColor"
                      />
                      <path
                        d="M45.7 48.41H32.37C31.18 48.41 30.12 47.8 29.52 46.77C28.93 45.74 28.93 44.51 29.52 43.48L36.19 31.93C36.78 30.9 37.85 30.28 39.04 30.28C40.23 30.28 41.29 30.9 41.89 31.93L48.56 43.48C49.15 44.51 49.15 45.74 48.56 46.77C47.97 47.8 46.9 48.41 45.71 48.41H45.7ZM31.69 44.73C31.48 45.09 31.62 45.4 31.69 45.52C31.76 45.64 31.96 45.91 32.37 45.91H45.7C46.11 45.91 46.32 45.63 46.38 45.52C46.44 45.41 46.59 45.09 46.38 44.73L39.71 33.18C39.5 32.82 39.16 32.78 39.03 32.78C38.9 32.78 38.55 32.82 38.35 33.18L31.68 44.73H31.69ZM39.04 45.02C38.35 45.02 37.78 44.46 37.78 43.77C37.78 43.08 38.34 42.51 39.03 42.51C39.72 42.51 40.28 43.07 40.28 43.76C40.28 44.45 39.72 45.02 39.03 45.02H39.04ZM39.04 41.85C38.35 41.85 37.79 41.33 37.79 40.69V37.55C37.79 36.91 38.35 36.39 39.04 36.39C39.73 36.39 40.29 36.91 40.29 37.55V40.69C40.29 41.33 39.73 41.85 39.04 41.85Z"
                        fill="currentColor"
                      />
                    </svg>
                    <div class="text-center text-sm text-gray-over-dark">
                      Add emergency contact
                    </div>
                  </div>
                </div>

                <div
                  v-if="showAfterHoursForm || showEmergencyForm"
                  class="w-full cursor-pointer rounded-lg border-placeholder-gray"
                  :class="
                    savedOwnerContact && showOwnerForm == false
                      ? 'border border-body-color'
                      : 'border-dashed border-placeholder-gray'
                  "
                  style="transition: all 400ms"
                  :style="
                    showOwnerForm
                      ? 'flex-grow: 1.000; flex-basis: 100%; order: -9999;'
                      : 'flex-grow: 0.001; flex-basis: calc( ( 100% - 1rem ) / 2); order: 3;'
                  "
                >
                  <div
                    v-if="savedOwnerContact && showOwnerForm == false"
                    class="hover:alt-white relative flex h-28 flex-row items-start justify-between gap-0.5 rounded-lg bg-white p-2 text-body-color"
                  >
                    <div
                      class="absolute left-2 top-2 flex h-24 flex-col items-center gap-0 py-0"
                    >
                      <svg
                        class="h-auto w-6 text-dark-gray"
                        viewBox="0 0 47 50"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M39.57 19.97C40.55 22.25 41.1 24.76 41.1 27.39C41.1 37.76 32.69 46.17 22.32 46.17C11.95 46.17 3.54001 37.76 3.54001 27.39C3.54001 17.02 11.95 8.60999 22.32 8.60999C23.93 8.60999 24.3 8.57001 25.79 8.95001L26.65 6.10999C25.15 5.77999 23.92 5.67001 22.32 5.67001C10.32 5.67001 0.600006 15.4 0.600006 27.39C0.600006 39.38 10.33 49.11 22.32 49.11C34.31 49.11 44.04 39.38 44.04 27.39C44.04 24.78 43.56 21.05 42.47 18.82L39.57 19.97V19.97Z"
                          fill="currentColor"
                        />
                        <path
                          d="M22.31 28.78C18.45 28.78 15.31 25.64 15.31 21.78C15.31 17.92 18.45 14.78 22.31 14.78C26.17 14.78 29.31 17.92 29.31 21.78C29.31 25.64 26.17 28.78 22.31 28.78V28.78ZM22.31 17.78C20.1 17.78 18.31 19.57 18.31 21.78C18.31 23.99 20.1 25.78 22.31 25.78C24.52 25.78 26.31 23.99 26.31 21.78C26.31 19.57 24.52 17.78 22.31 17.78Z"
                          fill="currentColor"
                        />
                        <path
                          d="M35.52 44.53L32.93 43.02C33.99 41.2 34 39.02 32.95 37.19C31.9 35.36 30.02 34.27 27.91 34.27H16.71C14.6 34.27 12.72 35.36 11.67 37.19C10.62 39.02 10.63 41.2 11.69 43.02L9.10001 44.53C7.49001 41.77 7.48001 38.47 9.07001 35.7C10.66 32.93 13.52 31.28 16.71 31.28H27.91C31.1 31.28 33.96 32.93 35.55 35.7C37.14 38.47 37.13 41.77 35.52 44.53V44.53Z"
                          fill="currentColor"
                        />
                        <path
                          d="M36.74 19.02C35.49 19.02 34.3 18.51 33.43 17.63C32.22 17.63 30.99 17.16 30.11 16.27C29.22 15.39 28.74 14.18 28.75 12.95C27.87 12.09 27.36 10.89 27.36 9.64001C27.36 8.39001 27.87 7.19999 28.75 6.32999C28.74 5.09999 29.22 3.89001 30.11 3.01001C31 2.13001 32.25 1.63999 33.43 1.64999C34.29 0.769994 35.49 0.259995 36.74 0.259995C37.99 0.259995 39.18 0.769994 40.05 1.64999C41.29 1.64999 42.49 2.12001 43.37 3.01001C44.25 3.90001 44.74 5.09999 44.73 6.32999C45.61 7.18999 46.12 8.38001 46.12 9.64001C46.12 10.9 45.61 12.08 44.73 12.95C44.74 14.18 44.26 15.39 43.37 16.27C42.49 17.15 41.31 17.63 40.09 17.63H40.05C39.19 18.51 37.99 19.02 36.74 19.02ZM33.97 15.08C34.37 15.08 34.76 15.27 34.99 15.61C35.39 16.18 36.04 16.52 36.74 16.52C37.44 16.52 38.09 16.18 38.49 15.61C38.77 15.21 39.25 15.01 39.73 15.1C40.41 15.22 41.12 15 41.61 14.51C42.1 14.02 42.32 13.32 42.2 12.63C42.12 12.15 42.32 11.67 42.71 11.39C43.28 10.99 43.62 10.34 43.62 9.64001C43.62 8.94001 43.28 8.29001 42.71 7.89001C42.31 7.61001 42.12 7.12999 42.2 6.64999C42.32 5.96999 42.1 5.25999 41.61 4.76999C41.12 4.27999 40.42 4.05999 39.73 4.17999C39.25 4.26999 38.77 4.06001 38.49 3.67001C38.09 3.10001 37.44 2.76001 36.74 2.76001C36.04 2.76001 35.39 3.10001 34.99 3.67001C34.71 4.06001 34.23 4.26999 33.75 4.17999C33.07 4.05999 32.36 4.27999 31.87 4.76999C31.38 5.25999 31.16 5.95999 31.28 6.64999C31.36 7.12999 31.16 7.61001 30.77 7.89001C30.2 8.29001 29.86 8.94001 29.86 9.64001C29.86 10.34 30.2 10.99 30.77 11.39C31.17 11.67 31.36 12.15 31.28 12.63C31.16 13.32 31.38 14.02 31.87 14.51C32.36 15 33.06 15.22 33.75 15.1C33.82 15.09 33.89 15.08 33.96 15.08H33.97ZM36.06 13.6C35.73 13.6 35.41 13.47 35.18 13.23L33.15 11.2C32.66 10.71 32.66 9.91999 33.15 9.42999C33.64 8.93999 34.43 8.93999 34.92 9.42999L35.91 10.42L38.44 6.88C38.84 6.32 39.62 6.19 40.18 6.59C40.74 6.99 40.87 7.76999 40.47 8.32999L37.09 13.07C36.88 13.37 36.54 13.56 36.18 13.59C36.14 13.59 36.11 13.59 36.08 13.59L36.06 13.6Z"
                          fill="currentColor"
                        />
                      </svg>
                      <div
                        class="relative text-center font-semibold uppercase text-dark-gray"
                        style="font-size: 0.6rem"
                      >
                        <span class="block">Owner</span>
                      </div>
                    </div>
                    <div class="flex h-24 w-full flex-col justify-end gap-0.5">
                      <div
                        class="flex h-full flex-col items-end justify-between"
                      >
                        <div class="flex justify-end gap-0.5">
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0.5 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="showForm('owner')"
                          >
                            <svg
                              class="h-3.5 w-3.5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 24 25"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M13 4.39062H6C5.44772 4.39062 5 4.83834 5 5.39062V19.3906C5 19.9429 5.44772 20.3906 6 20.3906H18C18.5523 20.3906 19 19.9429 19 19.3906V12.3906"
                                stroke="currentColor"
                                stroke-width="2"
                              />
                              <path
                                d="M18.5971 3.53523C18.9876 3.14471 19.6208 3.14471 20.0113 3.53523L20.9212 4.44511C21.3117 4.83564 21.3117 5.4688 20.9212 5.85932L14.0195 12.761C13.8756 12.9049 13.6913 13.0015 13.4911 13.0378L12.3793 13.2398C11.6921 13.3646 11.0919 12.7644 11.2167 12.0772L11.4186 10.9654C11.4549 10.7652 11.5515 10.5808 11.6954 10.4369L18.5971 3.53523Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Edit
                            </span>
                          </div>
                          <div
                            class="group relative -right-0.5 -top-0.5 inline-flex cursor-pointer items-center gap-0 rounded-md p-0.5 pr-1 hover:bg-lighter-gray"
                            :class="firstTime ? '' : 'hidden'"
                            @click="handleDeleteContact('owner')"
                          >
                            <svg
                              class="relative -top-px h-5 w-5 cursor-pointer text-body-color group-hover:text-dark-gray"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M13.9913 9.65885C14.4132 9.237 14.9854 9 15.582 9C16.1786 9 16.7507 9.237 17.1726 9.65885C17.3468 9.83306 17.4895 10.0329 17.597 10.2495H13.567C13.6745 10.0329 13.8171 9.83306 13.9913 9.65885ZM11.4518 10.2495C11.6341 9.49669 12.0204 8.80138 12.5771 8.24464C13.3741 7.44771 14.4549 7 15.582 7C16.709 7 17.7899 7.44771 18.5868 8.24464C19.1435 8.80138 19.5298 9.49669 19.7121 10.2495H19.9363L19.9552 10.2496H23.1642V12.2496H21.9363C21.9363 12.2889 21.9351 12.3285 21.9327 12.3683L21.2781 23.3662C21.2152 24.4228 20.3401 25.2474 19.2816 25.2474H11.8819C10.8235 25.2474 9.94837 24.4228 9.88548 23.3662L9.23084 12.3683C9.22847 12.3285 9.22728 12.2889 9.22724 12.2496H8V10.2496H11.2083L11.2273 10.2495H11.4518ZM11.8819 23.2474L11.2273 12.2496H19.9363L19.2816 23.2474H11.8819ZM12.6865 21.336L12.6865 13.7539H14.6865L14.6865 21.336H12.6865ZM16.4775 13.7539V21.336H18.4775V13.7539H16.4775Z"
                                fill="currentColor"
                              />
                            </svg>
                            <span
                              class="relative -left-px text-2xs text-body-color group-hover:text-dark-gray"
                            >
                              Delete
                            </span>
                          </div>
                        </div>
                        <div
                          class="text-contact-card align-self-end flex flex-col text-right"
                        >
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedOwnerContact?.name"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedOwnerContact?.name }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedOwnerContact?.phone?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{
                                formatPhone(savedOwnerContact?.phone?.value) ||
                                savedOwnerContact?.phone?.value
                              }}
                            </span>
                          </div>
                          <div
                            class="contact-truncate-max-width cursor-default"
                            :title="savedOwnerContact?.email_address?.value"
                          >
                            <span class="block truncate whitespace-nowrap">
                              {{ savedOwnerContact?.email_address?.value }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="!savedOwnerContact && showOwnerForm == false"
                    class="flex cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-placeholder-gray bg-off-white px-3 pb-5 pt-6"
                    @click="showForm('owner')"
                  >
                    <svg
                      class="h-10 w-auto text-gray-over-dark"
                      viewBox="0 0 48 49"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M22.28 23.84C18.42 23.84 15.28 20.7 15.28 16.84C15.28 12.98 18.42 9.84 22.28 9.84C26.14 9.84 29.28 12.98 29.28 16.84C29.28 20.7 26.14 23.84 22.28 23.84ZM22.28 12.84C20.07 12.84 18.28 14.63 18.28 16.84C18.28 19.05 20.07 20.84 22.28 20.84C24.49 20.84 26.28 19.05 26.28 16.84C26.28 14.63 24.49 12.84 22.28 12.84Z"
                        fill="currentColor"
                      />
                      <path
                        d="M31.11 29.89C30.15 29.2 29.13 29.34 27.88 29.34H16.68C14.57 29.34 12.69 30.43 11.64 32.26C10.59 34.09 10.6 36.27 11.66 38.09L9.07 39.6C7.46 36.84 7.45 33.54 9.04 30.77C10.63 28 13.49 26.35 16.68 26.35H27.88C30.82 26.35 34.07 27.21 35.12 29.89C35.12 29.89 34.99 29.67 35.12 29.89H31.12H31.11Z"
                        fill="currentColor"
                      />
                      <path
                        d="M3.52 22.45C3.52 12.08 11.93 3.67001 22.3 3.67001C24.43 3.67001 26.46 4.04 28.37 4.69C28.48 4.49 28.61 4.3 28.78 4.13C29.25 3.66 29.88 3.39999 30.54 3.39999H32.76C29.66 1.68999 26.09 0.720001 22.3 0.720001C10.3 0.720001 0.580002 10.45 0.580002 22.44C0.580002 34.43 10.31 44.16 22.3 44.16C23.9 44.16 26.16 43.89 27.66 43.56L26.95 40.61C25.46 40.99 23.91 41.21 22.3 41.21C11.93 41.21 3.52 32.8 3.52 22.43V22.45Z"
                        fill="currentColor"
                      />
                      <path
                        d="M40.94 13.81C40.94 14.47 40.68 15.1 40.21 15.57C40.1 15.68 39.99 15.77 39.86 15.85C40.63 17.9 41.07 20.12 41.07 22.44C41.07 25.08 40.52 26.77 39.54 29.05L42.32 30.75C43.16 28.43 44.02 25.05 44.02 22.43C44.02 18.35 42.89 14.54 40.94 11.27V13.79V13.81Z"
                        fill="currentColor"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M36.86 0.730011C37.27 0.730011 37.67 0.890002 37.96 1.19C38.25 1.48 38.42 1.88001 38.42 2.29001V5.57999H41.71C42.12 5.57999 42.52 5.74001 42.81 6.04001C43.1 6.33001 43.27 6.73001 43.27 7.14001C43.27 7.55001 43.11 7.94999 42.81 8.23999C42.51 8.52999 42.12 8.70001 41.71 8.70001H38.42V11.99C38.42 12.4 38.26 12.8 37.96 13.09C37.66 13.38 37.27 13.55 36.86 13.55C36.45 13.55 36.05 13.39 35.76 13.09C35.47 12.8 35.3 12.4 35.3 11.99V8.70001H32.01C31.6 8.70001 31.2 8.53999 30.91 8.23999C30.62 7.94999 30.45 7.55001 30.45 7.14001C30.45 6.73001 30.61 6.33001 30.91 6.04001C31.2 5.75001 31.6 5.57999 32.01 5.57999H35.3V2.29001C35.3 1.88001 35.46 1.48 35.76 1.19C36.05 0.900002 36.45 0.730011 36.86 0.730011Z"
                        fill="currentColor"
                      />
                      <path
                        d="M37.67 48.85C36.42 48.85 35.23 48.34 34.36 47.46C33.15 47.46 31.92 46.99 31.04 46.1C30.15 45.22 29.67 44.01 29.68 42.78C28.8 41.92 28.29 40.72 28.29 39.47C28.29 38.22 28.8 37.03 29.68 36.16C29.67 34.93 30.15 33.72 31.04 32.84C31.93 31.96 33.18 31.47 34.36 31.48C35.22 30.6 36.42 30.09 37.67 30.09C38.92 30.09 40.11 30.6 40.98 31.48C42.22 31.48 43.42 31.95 44.3 32.84C45.18 33.73 45.67 34.93 45.66 36.16C46.54 37.02 47.05 38.21 47.05 39.47C47.05 40.73 46.54 41.91 45.66 42.78C45.67 44.01 45.19 45.22 44.3 46.1C43.42 46.98 42.24 47.46 41.02 47.46H40.98C40.12 48.34 38.92 48.85 37.67 48.85V48.85ZM34.9 44.91C35.3 44.91 35.69 45.1 35.92 45.44C36.32 46.01 36.97 46.35 37.67 46.35C38.37 46.35 39.02 46.01 39.42 45.44C39.7 45.04 40.18 44.84 40.66 44.93C41.34 45.05 42.05 44.83 42.54 44.34C43.03 43.85 43.25 43.15 43.13 42.46C43.05 41.98 43.25 41.5 43.64 41.22C44.21 40.82 44.55 40.17 44.55 39.47C44.55 38.77 44.21 38.12 43.64 37.72C43.24 37.44 43.05 36.96 43.13 36.48C43.25 35.8 43.03 35.09 42.54 34.6C42.05 34.11 41.35 33.89 40.66 34.01C40.18 34.1 39.7 33.89 39.42 33.5C39.02 32.93 38.37 32.59 37.67 32.59C36.97 32.59 36.32 32.93 35.92 33.5C35.64 33.89 35.16 34.1 34.68 34.01C34 33.89 33.29 34.11 32.8 34.6C32.31 35.09 32.09 35.79 32.21 36.48C32.29 36.96 32.09 37.44 31.7 37.72C31.13 38.12 30.79 38.77 30.79 39.47C30.79 40.17 31.13 40.82 31.7 41.22C32.1 41.5 32.29 41.98 32.21 42.46C32.09 43.15 32.31 43.85 32.8 44.34C33.29 44.83 33.99 45.05 34.68 44.93C34.75 44.92 34.82 44.91 34.89 44.91H34.9ZM36.99 43.43C36.66 43.43 36.34 43.3 36.11 43.06L34.08 41.03C33.59 40.54 33.59 39.75 34.08 39.26C34.57 38.77 35.36 38.77 35.85 39.26L36.84 40.25L39.37 36.71C39.77 36.15 40.55 36.02 41.11 36.42C41.67 36.82 41.8 37.6 41.4 38.16L38.02 42.9C37.81 43.2 37.47 43.39 37.11 43.42C37.07 43.42 37.04 43.42 37.01 43.42L36.99 43.43Z"
                        fill="currentColor"
                      />
                    </svg>
                    <div class="text-center text-sm text-gray-over-dark">
                      Add owner contact
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <confirm-delete-contact-modal
        v-if="confirmDelete"
        :visible="confirmDelete"
        :contact-type="contactTypeToDelete"
        @close="onCloseDeleteModal"
        @delete="handleDeleteContact"
      />
      <add-contact-info-modal
        v-if="showContactInfoModal"
        ref="contactInfoModal"
        :visible="showContactInfoModal"
        :field-type="modalFieldType"
        :contact-is-type="modalContactIsType"
        :update-field="handleContactInfoModal"
        @close="toggleModalOff"
      />
    </div>
    <form-navigation-buttons
      v-if="!isNavigationDisabled"
      :enabled="!isNavigationDisabled"
      :component-identifier="componentIdentifier"
      :buttons-to-display="buttonsToDisplay"
      :is-button-disabled="isButtonDisabled"
      @next="handleNext"
      @back="handleBack"
      @edit="handleEdit"
      @exit-modal="emitExitModal"
    />
  </div>
</template>

<script>
import FormNavigationButtons from '@/components/FormNavigationButtons.vue';
import { useFormRouter } from '@/composables/formRouter';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import ButtonIcon from '@/components/ButtonIcon.vue';
import AddContactInfoModal from '@/components/modals/AddContactInfoModal.vue';
import ConfirmDeleteContactModal from '@/components/modals/ConfirmDeleteContactModal.vue';
import RadioButton from '../../../components/ContactRadioButton.vue';
import dayjs from 'dayjs';
import _ from 'lodash';
import { formatE164 } from '@/common/validators.js';
import { toastResponse } from '@/common/handleServerResponse.js';

export default {
  name: 'IdentityStepTwo',
  components: {
    FormNavigationButtons,
    ButtonIcon,
    RadioButton,
    ConfirmDeleteContactModal,
    AddContactInfoModal,
  },
  props: {
    data: Object,
    updateField: Function,
    nextStep: Function,
    formPosition: Number,
    title: String,
    // firstTime: Boolean,
    stepName: String,
    skipStep: Function,
    screenSize: String,
  },
  setup(_, { emit }) {
    const store = useStore();
    const componentIdentifier = 'Identity-2';
    const formRouter = useFormRouter(componentIdentifier);
    const componentStep = computed(() => formRouter.componentStep.value);
    const isNavigationDisabled = computed(() => formRouter.isDisabled.value);
    const firstTime = computed(
      () => store.state.firstTime?.[componentStep.value?.firstTimeIdentifier]
    );
    const buttonsToDisplay = computed(() => {
      if (firstTime.value) return 'continue-save';
      return 'continue-edit';
    });

    const skipSubstepsThreeAndFourIdentity = computed(() => {
      if (
        import.meta.env.VITE_DISABLE_RATE_CON_AND_INVOICING_CONTACT_STEPS == 1
      ) {
        return true;
      }
      return (
        store.state.carriers.carrierDetails?.authority?.authorities
          ?.broker_authority_status !== 'Active'
      );
    });

    const isButtonDisabled = false;

    const handleNext = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleNext' called"
      );
      if (isNavigationDisabled.value)
        return store.commit(
          'addFormDebugMessage',
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );

      if (skipSubstepsThreeAndFourIdentity.value) {
        formRouter.moveToStepByIdentifier('Operations');
      } else {
        formRouter.moveToNextStep();
      }
    };

    const handleBack = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleBack' called"
      );
      if (isNavigationDisabled.value)
        return store.commit(
          'addFormDebugMessage',
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.moveToPreviousStep();
    };

    const handleEdit = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'handleEdit' called"
      );
      if (isNavigationDisabled.value)
        return console.log(
          'ERROR: ' +
            componentIdentifier +
            ': formRouter is disabled, returning'
        );
      formRouter.editActiveStep();
    };

    const showModal = ref(false);

    const openModal = () => {
      showModal.value = true;
    };

    const onCloseModal = () => {
      showModal.value = false;
      store.commit('identity/resetErrors');
    };

    const emitExitModal = () => {
      store.commit(
        'addFormDebugMessage',
        componentIdentifier + ": 'emitExitModal' called"
      );
      emit('exit-modal');
    };

    return {
      componentIdentifier,
      handleNext,
      handleBack,
      handleEdit,
      buttonsToDisplay,
      isButtonDisabled,
      isNavigationDisabled,
      firstTime,
      componentStep,
      openModal,
      showModal,
      onCloseModal,
      emitExitModal,
    };
  },
  data() {
    return {
      confirmDelete: false,
      contactTypeToDelete: null,
      deleteType: null,
      deleteId: null,
      selectedCensusName: [],
      selectedCensusEmails: [],
      selectedCensusPhones: [],
      selectedCensusNameId: [],
      selectedCensusEmailsId: [],
      selectedCensusPhonesId: [],
      selectedCensusPhonesE164: [],
      addedCensusName: [],
      addedCensusEmails: [],
      addedCensusPhones: [],
      dispatchNameModal: false,
      showContactInfoModal: false,
      dispatchPhoneModal: false,
      billingNameModal: false,
      billingEmailModal: false,
      billingPhoneModal: false,
      claimsNameModal: false,
      claimsEmailModal: false,
      claimsPhoneModal: false,
      selectedCensusNameComplete: false,
      selectedCensusPhonesComplete: false,
      selectedCensusEmailsComplete: false,
      showDispatchForm: false,
      showBillingForm: false,
      showClaimsForm: false,
      showAfterHoursForm: false,
      showEmergencyForm: false,
      showOwnerForm: false,
      formLoading: false,
      formAnimationDuration: 400,
      modalFieldType: null,
      modalContactIsType: null,
      addedModalNames: [],
      addedModalEmails: [],
      addedModalPhones: [],
    };
  },
  computed: {
    savedDispatchContact() {
      return this.$store.state.contacts?.savedContacts?.dispatch;
    },
    savedBillingContact() {
      return this.$store.state.contacts?.savedContacts?.billing;
    },
    savedClaimsContact() {
      return this.$store.state.contacts?.savedContacts?.claims;
    },
    savedAfterHoursContact() {
      return this.$store.state.contacts?.savedContacts?.after_hours;
    },
    savedEmergencyContact() {
      return this.$store.state.contacts?.savedContacts?.emergency;
    },
    savedOwnerContact() {
      return this.$store.state.contacts?.savedContacts?.owner;
    },
    onboardingPacketId() {
      return this.$store.state.onboardingPacket?.id;
    },
    identity() {
      return (
        this.$store.state.identity?.show ||
        this.$store.state.carriers?.carrierData?.identity
      );
    },
    requiredContactsCompleted() {
      return this.$store.state.contacts?.requiredContactsCompleted || false;
    },
    contactData() {
      if (this.identity?.id > 0) {
        return {
          contacts: this.identity?.contacts,
          emails: this.identity?.email_addresses,
          phones: this.identity?.phones,
        };
      }
      return null;
    },
    censusNames() {
      let census = _.uniqBy(this.identity?.contacts, 'name') || [];
      let allNames = [...census.map((el) => el), ...this.addedCensusName];
      console.log('allNames1');
      console.dir(allNames);
      allNames = allNames.sort((a, b) => a?.name?.localeCompare(b?.name));
      console.log('allNames');
      console.dir(allNames);
      return [...new Set(allNames)];
    },
    censusEmails() {
      let census = _.uniqBy(this.identity?.email_addresses, 'value') || [];
      let allEmails = [
        ...census.map((el) => el.value),
        ...this.addedCensusEmails,
      ];
      allEmails = allEmails.sort((a, b) => a?.value?.localeCompare(b?.value));
      return [...new Set(allEmails)];
    },
    censusPhones() {
      let census =
        _.uniqBy(
          this.identity?.phones.filter((el) => el.is_type !== 'census_fax'),
          'value'
        ) || [];
      let allPhones = [
        ...census.map((el) => el.value),
        ...this.addedCensusPhones,
      ];
      allPhones = allPhones.sort((a, b) => a?.value?.localeCompare(b?.value));
      return [...new Set(allPhones)];
    },
    dispatchNames() {
      return (
        this.identity?.contacts?.filter((el) => el.is_type === 'dispatch') || []
      );
    },
    dispatchEmails() {
      return (
        this.identity?.email_addresses?.filter(
          (el) => el.is_type === 'dispatch'
        ) || []
      );
    },
    dispatchPhones() {
      return (
        this.identity?.phones?.filter((el) => el.is_type === 'dispatch') || []
      );
    },
    billingNames() {
      return (
        this.identity?.contacts?.filter((el) => el.is_type === 'billing') || []
      );
    },
    billingEmails() {
      return (
        this.identity?.email_addresses?.filter(
          (el) => el.is_type === 'billing'
        ) || []
      );
    },
    billingPhones() {
      return (
        this.identity?.phones?.filter((el) => el.is_type === 'billing') || []
      );
    },
    claimsNames() {
      return (
        this.identity?.contacts?.filter((el) => el.is_type === 'claims') || []
      );
    },
    claimsEmails() {
      return (
        this.identity?.email_addresses?.filter(
          (el) => el.is_type === 'claims'
        ) || []
      );
    },
    claimsPhones() {
      return (
        this.identity?.phones?.filter((el) => el.is_type === 'claims') || []
      );
    },
    ownerNames() {
      return (
        this.identity?.contacts?.filter((el) => el.is_type === 'owner') || []
      );
    },
    ownerEmails() {
      return (
        this.identity?.email_addresses?.filter(
          (el) => el.is_type === 'owner'
        ) || []
      );
    },
    ownerPhones() {
      return (
        this.identity?.phones?.filter((el) => el.is_type === 'owner') || []
      );
    },
    afterHoursNames() {
      return (
        this.identity?.contacts?.filter((el) => el.is_type === 'after_hours') ||
        []
      );
    },
    afterHoursEmails() {
      return (
        this.identity?.email_addresses?.filter(
          (el) => el.is_type === 'after_hours'
        ) || []
      );
    },
    afterHoursPhones() {
      return (
        this.identity?.phones?.filter((el) => el.is_type === 'after_hours') ||
        []
      );
    },
    emergencyNames() {
      return (
        this.identity?.contacts?.filter((el) => el.is_type === 'emergency') ||
        []
      );
    },
    emergencyEmails() {
      return (
        this.identity?.email_addresses?.filter(
          (el) => el.is_type === 'emergency'
        ) || []
      );
    },
    emergencyPhones() {
      return (
        this.identity?.phones?.filter((el) => el.is_type === 'emergency') || []
      );
    },
    emptyState() {
      return (
        !this.ownerEmails.length &&
        !this.ownerPhones.length &&
        !this.afterHoursPhones.length &&
        !this.afterHoursEmails.length &&
        !this.emergencyEmails.length &&
        !this.emergencyPhones.length
      );
    },
  },
  watch: {
    stepName: async function (val) {
      if (val === 'Operations' || val === 'Identity-1') {
        this.selectedCensusEmails = [];
        this.selectedCensusPhones = [];
        this.$store.commit('identity/setShow', null);
      }
      if (this.stepName === 'Identity-2') {
        if (this.requiredContactsCompleted == false) {
          console.log('toggling btn on stepname');
          this.$store.commit('toggleDisabledButton', {
            bool: true,
            source: 'IdentityStepTwo #1',
          });
          await this.$store.commit('firstTime/updateStepFirstTime', {
            step: 'Identity',
            value: true,
          });
        }
      }
    },
    '$store.state.identity': {
      deep: true,
      handler() {
        var self = this;
        let contactData = {
          contacts: this.identity?.contacts,
          emails: this.identity?.email_addresses,
          phones: this.identity?.phones,
        };
        self.$store.dispatch('contacts/initializeContacts', contactData);
      },
      immediate: true,
    },
    requiredContactsCompleted: {
      deep: true,
      handler(val) {
        var self = this;
        if (self.stepName === 'Identity-2' && val == true) {
          self.$store.commit('toggleDisabledButton', {
            bool: false,
            source: 'IdentityStepTwo #2',
          });
        } else if (self.stepName === 'Identity-2') {
          self.$store.commit('toggleDisabledButton', {
            bool: true,
            source: 'IdentityStepTwo #3',
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    formatPhone(phone) {
      // console.log('identitystep2 - formatPhone', phone);
      return formatE164(phone) || phone;
    },
    async saveNewContact(type) {
      if (
        this.selectedCensusName?.length > 0 &&
        this.selectedCensusPhones?.length > 0 &&
        this.selectedCensusEmails?.length > 0
      ) {
        let email_attributes = {
          is_type: type,
          value: this.selectedCensusEmails[0],
        };

        let phone_attributes = {
          is_type: type,
          value:
            this.selectedCensusPhonesE164?.length > 0
              ? this.selectedCensusPhonesE164[0]
              : this.selectedCensusPhones[0],
        };

        let method = 'post';
        let addIDs = false;
        switch (type) {
          case 'dispatch':
            if (this.savedDispatchContact) {
              method = 'patch';
              addIDs = true;
            }
            break;
          case 'billing':
            if (this.savedBillingContact) {
              method = 'patch';
              addIDs = true;
            }
            break;
          case 'claims':
            if (this.savedClaimsContact) {
              method = 'patch';
              addIDs = true;
            }
            break;
          case 'after_hours':
            if (this.savedAfterHoursContact) {
              method = 'patch';
              addIDs = true;
            }
            break;
          case 'emergency':
            if (this.savedEmergencyContact) {
              method = 'patch';
              addIDs = true;
            }
            break;
          case 'owner':
            if (this.savedOwnerContact) {
              method = 'patch';
              addIDs = true;
            }
            break;
        }

        let payload = {
          carrier_id: this.identity?.id,
          name: this.selectedCensusName[0],
          is_type: type,
          contactable_id: this.onboardingPacketId,
          contactable_type: 'OnboardingPacket',
          file_date: dayjs().format('YYYY-MM-DD'),
          email_address_attributes: email_attributes,
          phone_attributes: phone_attributes,
        };

        if (addIDs == true) {
          payload['id'] = this.$store.state.contacts?.savedContacts[type]?.id;
        }

        let res = await this.$store.dispatch('contacts/createOrUpdateContact', {
          method: method,
          payload: payload,
        });

        // if (res?.status == 422 && res?.data?.['email_address.email_address']?.length > 0) {
        if ([422].includes(res?.status)) {
          toastResponse(this, res, null);
        } else if ([200, 201].includes(res?.status)) {
          this.hideForm(type);
          toastResponse(this, res, 'Contact saved');
        }
      }
    },
    removeAndCheck(type, index) {
      switch (type) {
        case 'phones':
          this.selectedCensusPhones.splice(index);
          this.selectedCensusPhonesE164 = [];
          if (this.selectedCensusPhones?.length == 0) {
            this.selectedCensusPhonesComplete = false;
          }
          break;
        case 'emails':
          this.selectedCensusEmails.splice(index);
          if (this.selectedCensusEmails?.length == 0) {
            this.selectedCensusEmailsComplete = false;
          }
          break;
      }
    },
    showForm(form) {
      this.formLoading = true;
      switch (form) {
        case 'dispatch':
          if (this.showDispatchForm == false) {
            if (this.savedDispatchContact) {
              this.setupEditData(this.savedDispatchContact);
            }
            this.showBillingForm = false;
            this.showClaimsForm = false;
            this.showAfterHoursForm = false;
            this.showEmergencyForm = false;
            this.showOwnerForm = false;
            this.showDispatchForm = true;
          }
          break;
        case 'billing':
          if (this.showBillingForm == false) {
            if (this.savedBillingContact) {
              this.setupEditData(this.savedBillingContact);
            }
            this.showDispatchForm = false;
            this.showClaimsForm = false;
            this.showAfterHoursForm = false;
            this.showEmergencyForm = false;
            this.showOwnerForm = false;
            this.showBillingForm = true;
          }
          break;
        case 'claims':
          if (this.showClaimsForm == false) {
            if (this.savedClaimsContact) {
              this.setupEditData(this.savedClaimsContact);
            }
            this.showDispatchForm = false;
            this.showBillingForm = false;
            this.showAfterHoursForm = false;
            this.showEmergencyForm = false;
            this.showOwnerForm = false;
            this.showClaimsForm = true;
          }
          break;
        case 'after_hours':
          if (this.showDispatchForm == false) {
            if (this.savedAfterHoursContact) {
              this.setupEditData(this.savedAfterHoursContact);
            }
            this.showDispatchForm = false;
            this.showBillingForm = false;
            this.showClaimsForm = false;
            this.showEmergencyForm = false;
            this.showOwnerForm = false;
            this.showAfterHoursForm = true;
          }
          break;
        case 'emergency':
          if (this.showBillingForm == false) {
            if (this.savedEmergencyContact) {
              this.setupEditData(this.savedEmergencyContact);
            }
            this.showDispatchForm = false;
            this.showBillingForm = false;
            this.showClaimsForm = false;
            this.showAfterHoursForm = false;
            this.showOwnerForm = false;
            this.showEmergencyForm = true;
          }
          break;
        case 'owner':
          if (this.showClaimsForm == false) {
            if (this.savedOwnerContact) {
              this.setupEditData(this.savedOwnerContact);
            }
            this.showDispatchForm = false;
            this.showBillingForm = false;
            this.showClaimsForm = false;
            this.showAfterHoursForm = false;
            this.showEmergencyForm = false;
            this.showOwnerForm = true;
          }
          break;
      }
      let self = this;
      setTimeout(function () {
        self.formLoading = false;
      }, this.formAnimationDuration);
    },
    hideForm(form) {
      this.formLoading = true;
      switch (form) {
        case 'dispatch':
          this.showDispatchForm = false;
          break;
        case 'billing':
          this.showBillingForm = false;
          break;
        case 'claims':
          this.showClaimsForm = false;
          break;
        case 'after_hours':
          this.showAfterHoursForm = false;
          break;
        case 'emergency':
          this.showEmergencyForm = false;
          break;
        case 'owner':
          this.showOwnerForm = false;
          break;
      }
      let self = this;
      setTimeout(function () {
        self.formLoading = false;
        self.resetSelectedCensusData();
      }, this.formAnimationDuration);
    },
    hideAllForms() {
      this.showDispatchForm = false;
      this.showBillingForm = false;
      this.showClaimsForm = false;
      this.showAfterHoursForm = false;
      this.showEmergencyForm = false;
      this.showOwnerForm = false;
      this.resetSelectedCensusData();
    },
    resetSelectedCensusData() {
      this.selectedCensusNameComplete = false;
      this.selectedCensusEmailsComplete = false;
      this.selectedCensusPhonesComplete = false;
      this.selectedCensusName = [];
      this.selectedCensusEmails = [];
      this.selectedCensusPhones = [];
      this.selectedCensusNameId = [];
      this.selectedCensusEmailsId = [];
      this.selectedCensusPhonesId = [];
      this.selectedCensusPhonesE164 = [];
    },
    setupEditData(contact) {
      this.resetSelectedCensusData();
      this.selectedCensusEmails.push(contact?.email_address?.value);
      this.selectedCensusPhones.push(contact?.phone?.value);
      this.selectedCensusName.push(contact?.name);
      this.selectedCensusEmailsId.push(contact?.email_address?.id);
      this.selectedCensusPhonesId.push(contact?.phone?.id);
      this.selectedCensusNameId.push(contact?.id);
      this.selectedCensusNameComplete = true;
      this.selectedCensusEmailsComplete = true;
      this.selectedCensusPhonesComplete = true;
    },
    removeAlternateContact(item, type) {
      let deleteableType = {
        phone: 'phones_attributes',
        email: 'email_addresses_attributes',
      };

      this.confirmDelete = true;
      this.deleteType = deleteableType[type];
      this.deleteId = item.id;
    },
    onCloseDeleteModal() {
      this.confirmDelete = false;
      this.contactTypeToDelete = null;
    },
    onOpenDeleteModal(type) {
      this.confirmDelete = true;
      this.contactTypeToDelete = type;
    },
    setOnboardingData() {
      let payload = {};

      payload['body'] = {
        carrier: {
          email_addresses_attributes: [],
          phones_attributes: [],
        },
      };

      this.$store.dispatch('onboardingPacket/setOnboardingBody', payload.body);
    },
    updateOnboardingData(type, body) {
      let payload = {};
      let attributeType = {
        email: 'email_addresses_attributes',
        phone: 'phones_attributes',
      };
      payload['body'] = {
        carrier: {
          [attributeType[type]]: [body],
        },
      };
      this.$store.commit(
        'addFormDebugMessage',
        'AUTO PACKET UPDATE | Identity-2: (updateOnboardingData) carrier email_address_attributes and/or phone_attributes data sent to server'
      );
      this.$store.dispatch('onboardingPacket/updatePacket', payload);
    },
    handleSelectCensusName(e) {
      if (this.selectedCensusName.includes(e.target.value)) {
        this.selectedCensusName = this.selectedCensusName.filter(
          (el) => el !== e.target.value
        );
        this.selectedCensusNameId = this.selectedCensusNameId.filter(
          (el) => el !== e.target.getAttribute('data-model-id')
        );
      } else {
        this.selectedCensusName.push(e.target.value);
        this.selectedCensusNameId.push(e.target.getAttribute('data-model-id'));
        if (
          e.target.value &&
          this.selectedCensusName.includes(e.target.value)
        ) {
          this.selectedCensusNameComplete = true;
        }
      }
      this.setOnboardingData();
    },
    handleSelectCensusEmail(e) {
      if (this.selectedCensusEmails.includes(e.target.value)) {
        this.selectedCensusEmails = this.selectedCensusEmails.filter(
          (el) => el !== e.target.value
        );
        this.selectedCensusEmailsId = this.selectedCensusEmailsId.filter(
          (el) => el !== e.target.getAttribute('data-model-id')
        );
      } else {
        this.selectedCensusEmails.push(e.target.value);
        this.selectedCensusEmailsId.push(
          e.target.getAttribute('data-model-id')
        );
      }
      this.setOnboardingData();
    },
    handleSelectCensusPhone(e) {
      if (this.selectedCensusPhones.includes(e.target.value)) {
        this.selectedCensusPhones = this.selectedCensusPhones.filter(
          (el) => el !== e.target.value
        );
        this.selectedCensusPhonesId = this.selectedCensusPhonesId.filter(
          (el) => el !== e.target.getAttribute('data-model-id')
        );
      } else {
        this.selectedCensusPhones.push(e.target.value);
        this.selectedCensusPhonesId.push(
          e.target.getAttribute('data-model-id')
        );
        if (
          e.target.value &&
          this.selectedCensusPhones.includes(e.target.value)
        ) {
          this.selectedCensusPhonesComplete = true;
        }
      }
      this.setOnboardingData();
    },
    handleContactInfoModal(data) {
      if (data?.fieldType == 'phone') {
        let newPhone = null;
        if (data?.value) {
          newPhone = '(' + data?.value?.replace('-', ') ');
        }
        this.addedCensusPhones.push(newPhone);
        this.selectedCensusPhones.push(newPhone);
        this.selectedCensusPhonesE164.push(
          this.$refs?.contactInfoModal?.$refs?.addContactInfoPhone?.elementData?.getNumber()
        );
        this.selectedCensusPhonesComplete = true;
      } else if (data?.fieldType == 'email') {
        this.addedCensusEmails.push(data?.value);
        this.selectedCensusEmails.push(data?.value);
        this.selectedCensusEmailsComplete = true;
      } else if (data?.fieldType == 'name') {
        this.addedCensusName.push({
          id: null,
          name: data?.value,
        });
        this.selectedCensusName.push(data?.value);
        this.selectedCensusNameComplete = true;
      }
    },
    createCensusNameBody(is_type) {
      let body = [];
      const onboarding_id = this.$store.state.carriers.carrierData.id;
      this.selectedCensusName.forEach((el) => {
        let email = {
          value: el,
          is_type: is_type,
          contactable_id: onboarding_id,
          contactable_type: 'OnboardingPacket',
        };
        body.push(email);
      });
      return body;
    },
    createCensusEmailBody(is_type) {
      let body = [];
      const onboarding_id = this.$store.state.carriers.carrierData.id;
      this.selectedCensusEmails.forEach((el) => {
        let email = {
          value: el,
          is_type: is_type,
          email_addressable_id: onboarding_id,
          email_addressable_type: 'OnboardingPacket',
        };
        body.push(email);
      });
      return body;
    },
    createCensusPhoneBody() {
      let body = [];
      const onboarding_id = this.$store.state.carriers.carrierData.id;
      this.selectedCensusPhones.forEach((el) => {
        let phone = {
          value: el,
          is_type: 'dispatch',
          phoneable_id: onboarding_id,
          phoneable_type: 'OnboardingPacket',
        };
        body.push(phone);
      });
      return body;
    },
    async handleDeleteContact(contactIsType) {
      let contactObjectToDelete =
        this.$store.state.contacts?.savedContacts[contactIsType];
      if (contactObjectToDelete) {
        let payload = {
          contact: {
            id: contactObjectToDelete?.id,
            _destroy: 1,
          },
        };
        // If contact has an email address, delete the email address record as well
        if (contactObjectToDelete?.email_address?.id > 0) {
          payload.contact['email_address_attributes'] = {
            id: contactObjectToDelete?.email_address?.id,
            _destroy: 1,
          };
        }
        // If contact has a phone number, delete the phone number record as well
        if (contactObjectToDelete?.phone?.id > 0) {
          payload.contact['phone_attributes'] = {
            id: contactObjectToDelete?.phone?.id,
            _destroy: 1,
          };
        }

        await this.$store.dispatch('identity/deleteContact', {
          contact_id: contactObjectToDelete?.id,
          contact_is_type: contactObjectToDelete?.is_type,
          payload,
        });

        this.contactTypeToDelete = null;
        this.confirmDelete = false;
      }
    },
    toggleModalOn(fieldType, contactIsType) {
      this.modalFieldType = fieldType;
      this.modalContactIsType = contactIsType;
      this.showContactInfoModal = true;
    },
    toggleModalOff() {
      this.modalFieldType = null;
      this.modalContactIsType = null;
      this.showContactInfoModal = false;
    },
  },
};
</script>

<style>
.c-border {
  border: 1px solid #ededf0;
  box-sizing: border-box;
  border-radius: 5px;
}

.divider-2 {
  height: 2px;
  border-radius: 10px;
  @apply mb-2 mt-1 bg-light-gray;
}

.divider {
  height: 2px;
  border-radius: 10px;
  @apply mb-4 bg-light-gray;
}

.header-text {
  @apply text-left text-dark-gray;
  font-size: 16px;
}
</style>
